// ***********************************
// Metrics.vue
// ***********************************
<template>
  <div id="app">
    <div class="container">
      <div>
        <router-link :to="{ name: 'Main'}">List</router-link> | 
        <router-link :to="{ name: 'Add'}">Add</router-link> |
        <router-link :to="{ name: 'Profile' }">Share</router-link> |
        <router-link :to="{ name: 'Shapes' }">ShapeBrowser</router-link> |
        <router-link :to="{ name: 'API' }">API</router-link> 
      </div>

Use this page to explore your database.
  <b-button v-b-toggle.morehelp variant="link">Click here to see more instructions.</b-button>
<br/>
  <b-collapse id="morehelp">
    <b-card           border-variant="primary"
          header-bg-variant="primary"
          header-text-variant="white"
>
    <div id="morehelptext" class="mt-3 text-left">
      This page is structured into different collapsable sections. Click on the title bar of each section to expand or collapse it.
<br/><br/>
The first section ("General Information") provides some general details about your database.
<br/>
The second section ("Comparative Information") offers a quick visual way to look at your database compared to other databases.  This can help you quickly see if you are dealing with a relatively big or small database.
<br/>
The next four sections ("CPU", "Memory", "I/O", and "Disk Space") focus on the real-world performance metrics related to the 5 key sizing dimensions (CPU, Memory, IOPS, IO Throughput, and Disk Space).  You can use the charts in these sections to help decide upon target values for these 5 key metrics.
<br/>
The "Backup Metrics" section provides some metrics around backups, but the backup metrics data is not currently used by DBCSI's sizing algorithms so this section is for information-only.
<br/>
The "Wait Metrics" section provides the top 10 wait events over time, which can help you understand a bit more about the current system performance.  This is for information-only and not used by DBCSI's sizing algorithms.
<br/>
The "Exadata Metrics" section provides charts showing some key Exadata metrics that can help you judge how much the workload is using (or not using) Exadata capabilities.  Some of these metrics can be used by the DBCSI Auto-Right-Sizer functionality to predict IO Throughput in post-Exadata scenarios.
<br/>
<br/>
The final section ("Mapping to AWS") is a "version1" attempt of a sizing tool-- currently, we recommend you use the newer Auto-Right-Sizer functionality.  The older v1 sizing tool on this page is not as advanced and is not being enhanced.  In general, we recommend you use the Auto-Right-Sizing tool for sizing but there maybe use-cases where you find the version1 sizing tool useful.
<br/><br/>      
    </div>
        
    </b-card>

  </b-collapse>  

<router-link v-if="!this.shareMode" :to="{ name: 'Batch', params: {batch_id: this.shareMode ? this.param_collection_id : ('C' + this.collection_id) } }">Switch to Auto-Right-Sizer</router-link>

      <b-form @submit="onSubmit" @reset="onReset">
        <!-- General Info       -->
        <b-card
          no-body
          class="mb-1"
          border-variant="primary"
          header-bg-variant="primary"
          header-text-variant="white"
        >
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-btn block href="#" v-b-toggle.accordionGeneral variant="info">General Information &nbsp;
              <span class="float-right">{{ !showCollapseGeneral ? '▶' : '▼' }}</span></b-btn>
          </b-card-header>
          <b-collapse id="accordionGeneral" v-model="showCollapseGeneral" visible role="tabpanel">
            <b-card-body>
              
              
              
              <b-alert :show="shareMode" variant="info">This database has been shared with you via URL.  Please save the URL if you want to continue to view it later.</b-alert>
              <b-button v-if="!this.shareMode  " block variant="outline-primary" v-b-modal="`mShare`">Share this database via URL</b-button>
              <b-button
                v-if="(collection_id!=459) && (collection_id!=458) && (collection_id!=455) && !shareMode"
                type="button"
                block
                variant="outline-primary"
                v-b-modal.modal-delete
              >Delete this database</b-button>
              
              <b-modal :id="`mShare`" title="Share Database via URL" ok-only ok-title="Finished" size="xl" >
                    <div style="margin: 15px">
                      <p style="font-size:14px">This feature lets you share your DBCSI databases via generated obscure URLs, similar to how you share in the AWS Pricing Calculator.  The other users who wish to use your generated sharing URL will need to be DBCSI users as well. The generated URL does not copy over your algorithm choices or any manually entered target values.  To continue, please read and acknowledge the following:</p>
                      <br/><br/>
                      <p style="font-size:14px"><b>Sharing Acknowledgement:</b>  Any DBCSI user who has been given the generated sharing URL will be able to see the DBCSI information for this database.</p>
                      

                      <b-form>
                        
                        <b-form-group
                          id="exampleInputGroup0"
                          label="Generated Sharing URL:"
                          label-for="genURL"
                          description="Please copy the above URL and distribute it for sharing this database with other DBCSI users."
                          v-if="generatedSharingURL !=''"
                        >
                          <b-form-input
                            id="genURL"
                            type="text"
                            v-model="generatedSharingURL"
                            required
                            disabled
                            placeholder="generated URL for sharing this database"
                          ></b-form-input>
                        </b-form-group>
                        
                       
                       
                        <b-button @click="shareDatabases(0)" v-if="(generatedSharingURL=='')" variant="success">Acknowledge and Continue</b-button>
                        
                        
                      </b-form>
                      <br/><br/>
                      

                </div>  
              </b-modal>      



                    <b-modal id="modal-delete" title="Confirm Delete" ok-only ok-title="Close Window" size="xl" @show="resetDeleteModal">
                          <div style="margin: 15px">
                            <p style="font-size:14px">Are you sure you want to delete this database from DBCSI?</p>
                            <br/><br/>

                              <b-button v-if=" (this.deleteMessage=='')" @click="deleteCollection" variant="success">Yes - Delete Database</b-button>
                
                            <br/><br/>
                            {{this.deleteMessage}}
                            
                      </div>  
                    </b-modal>

              
              <br/>
              This section provides some basic characteristics of your database.
              <br/>

              
              <img v-if="(this.batchItems[0].AWR_MINER_VER != undefined && !( this.batchItems[0].AWR_MINER_VER.includes('aws') || this.batchItems[0].AWR_MINER_VER.includes('statspack') ) )" src="@/assets/warning.png" height="20px" v-b-tooltip.hover title="Warning: This looks like the generic non-DBCSI AWR Miner script was used to collect metrics.  DBCSI works best if you use the DBCSI-specific data collection script downloadable from the DBCSI Add page.  Some DBCSI functionality will be missing."></img>
              
              <img v-if="(this.batchItems[0].PLATFORM_NAME=='AIX-Based_Systems_(64-bit)')" src="@/assets/AIX.png" height="16px" v-b-popover.hover="`Be sure to adjust the CPU Thread Mapping Ratio to adjust to x86 threads [${this.batchItems[0].PLATFORM_NAME}]`" title="not x86"></img>
              <img v-if="(this.batchItems[0].PLATFORM_NAME=='Solaris[tm]_OE_(64-bit)')" src="@/assets/SPARC.png" height="16px" v-b-popover.hover="`Be sure to adjust the CPU Thread Mapping Ratio to adjust to x86 threads [${this.batchItems[0].PLATFORM_NAME}]`" title="not x86"></img>
              <img v-if="(this.batchItems[0].PLATFORM_NAME=='HP-UX_IA_(64-bit)')" src="@/assets/HPUX.png" height="16px" v-b-popover.hover="`Be sure to adjust the CPU Thread Mapping Ratio to adjust to x86 threads [${this.batchItems[0].PLATFORM_NAME}]`" title="not x86"></img>
              <img v-if="(this.batchItems[0].PLATFORM_NAME=='IBM_zSeries_Based_Linux')" src="@/assets/zSeries.png" height="16px" v-b-popover.hover="`Be sure to adjust the CPU Thread Mapping Ratio to adjust to x86 threads [${this.batchItems[0].PLATFORM_NAME}]`" title="not x86"></img>
              <img v-if="(this.batchItems[0].PLATFORM_NAME=='Microsoft_Windows_x86_64-bit')" src="@/assets/WIN.png" height="16px" ></img>
              <img v-if="(this.batchItems[0].PLATFORM_NAME=='Solaris_Operating_System_(x86-64)')" src="@/assets/SolarisX86.png" height="16px" ></img>

                    <img v-if="(this.batchItems[0].IS_PDB=='YES') && (this.batchItems[0].CDB_collectionId==undefined) && (this.batchItems[0].cdb_target_comments==undefined)" v-b-popover.hover="`This is a PDB database.  Collecting PDB-level IO metrics is problematic and we have seen data issues in Oracle's AWR tables.`" title="PDB" src="@/assets/PDB.png" height="20px" ></img>
                    <img v-if="(this.batchItems[0].IS_PDB=='YES') && (this.batchItems[0].CDB_collectionId==undefined) && (this.batchItems[0].cdb_target_comments!=undefined)" v-b-popover.hover="`This is a PDB database.  Collecting PDB-level IO metrics is problematic and we have seen data issues in Oracle's AWR tables.  ${(this.batchItems[0].cdb_target_comments==undefined) ? '' : this.batchItems[0].cdb_target_comments}`" title="PDB" src="@/assets/PDB_NOCDB.png" height="20px" ></img>
                    <a v-if="(this.batchItems[0].IS_PDB=='YES') && (this.batchItems[0].CDB_collectionId!=undefined)" v-b-popover.hover="`This is a PDB database.  Collecting PDB-level IO metrics is problematic and we have seen data issues in Oracle's AWR tables.  ${(this.batchItems[0].cdb_target_comments==undefined) ? '' : this.batchItems[0].cdb_target_comments}`" title="PDB - Click on the PDB icon to view the CDB" :href="`/batch/C${this.batchItems[0].CDB_collectionId}`" target="_blank"><img src="@/assets/PDB_CDB.png" height="20px" ></img></a>  


<img v-if="!(this.batchItems[0].AWR_MINER_VER != undefined && !this.batchItems[0].AWR_MINER_VER.includes('aws')) && (this.batchItems[0].COUNT_LINES_PLSQL*1<20000)" src="@/assets/Postgres.png" height="20px" v-b-popover.hover="`Not much PLSQL (${this.batchItems[0].COUNT_LINES_PLSQL} lines). Consider migrating to PostgreSQL.`" title="PostgreSQL"></img>
<img v-if="(this.batchItems[0].VERSION.substr(0,2)!='21')&&(this.batchItems[0].VERSION.substr(0,2)!='19')" src="@/assets/Upgrade.png" height="20px" v-b-popover.hover="`This is an old version [${this.batchItems[0].VERSION}] of Oracle.  Expect to upgrade it for RDS-Oracle.`" title="old Oracle version"></img>
<img v-if="(this.batchItems[0].Exadata=='Yes')&&(this.batchItems[0].SmartScanEligible==undefined)" src="@/assets/Exadata.png" height="20px" v-b-popover.hover="`This database runs on Exadata.`" title="Exadata"></img>
<img v-if="(this.batchItems[0].Exadata=='Yes')&&(this.batchItems[0].SmartScanEligible!=undefined)&&(this.batchItems[0].SmartScanEligible<=500)" src="@/assets/Exadata1.png" height="20px" v-b-popover.hover="`This database runs on Exadata. ${'Smart Scan Eligible= '+this.batchItems[0].SmartScanEligible.toFixed(0)+'MB/s Storage Index Savings= '+this.batchItems[0].StorageIndexSavings.toFixed(0)+'MB/s'}  ${(this.batchItems[0].ExadataAdjustmentText==undefined) ? '' : this.batchItems[0].ExadataAdjustmentText}`" title="Exadata - Minimal SmartScan Offload"></img>
<img v-if="(this.batchItems[0].Exadata=='Yes')&&(this.batchItems[0].SmartScanEligible!=undefined)&&(this.batchItems[0].SmartScanEligible>500)&&  (this.batchItems[0].SmartScanEligible<2000)" src="@/assets/Exadata2.png" height="20px" v-b-popover.hover="`This database runs on Exadata. ${'Smart Scan Eligible= '+this.batchItems[0].SmartScanEligible.toFixed(0)+'MB/s Storage Index Savings= '+this.batchItems[0].StorageIndexSavings.toFixed(0)+'MB/s'}  ${(this.batchItems[0].ExadataAdjustmentText==undefined) ? '' : this.batchItems[0].ExadataAdjustmentText}`" title="Exadata - Moderate SmartScan Offload"></img>
<img v-if="(this.batchItems[0].Exadata=='Yes')&&(this.batchItems[0].SmartScanEligible!=undefined)&&(this.batchItems[0].SmartScanEligible>2000)&&  (this.batchItems[0].SmartScanEligible<8000)" src="@/assets/Exadata3.png" height="20px" v-b-popover.hover="`This database runs on Exadata. ${'Smart Scan Eligible= '+this.batchItems[0].SmartScanEligible.toFixed(0)+'MB/s Storage Index Savings= '+this.batchItems[0].StorageIndexSavings.toFixed(0)+'MB/s'}  ${(this.batchItems[0].ExadataAdjustmentText==undefined) ? '' : this.batchItems[0].ExadataAdjustmentText}`" title="Exadata - Medium SmartScan Offload"></img>
<img v-if="(this.batchItems[0].Exadata=='Yes')&&(this.batchItems[0].SmartScanEligible!=undefined)&&(this.batchItems[0].SmartScanEligible>8000)" src="@/assets/Exadata4.png" height="20px" v-b-popover.hover="`This database runs on Exadata. ${'Smart Scan Eligible= '+this.batchItems[0].SmartScanEligible.toFixed(0)+'MB/s Storage Index Savings= '+this.batchItems[0].StorageIndexSavings.toFixed(0)+'MB/s'}  ${(this.batchItems[0].ExadataAdjustmentText==undefined) ? '' : this.batchItems[0].ExadataAdjustmentText}`" title="Exadata - Heavy SmartScan Offload"></img>
<img v-if="(this.batchItems[0].IOPS*1>0) && (this.batchItems[0].Throughput/this.batchItems[0].IOPS*1024 <= 30)" src="@/assets/OLTP1.png" height="20px" v-b-popover.hover="`The estimated typical IO request size is ${Math.round(this.batchItems[0].Throughput/this.batchItems[0].IOPS*1024)} KB, which makes this database appear to be supporting OLTP-style workloads.`" title="OLTP-DW Spectrum Estimation"></img>
<img v-if="(this.batchItems[0].IOPS*1>0) && (this.batchItems[0].Throughput/this.batchItems[0].IOPS*1024 > 30) && (this.batchItems[0].Throughput/this.batchItems[0].IOPS*1024 <= 120)" src="@/assets/OLTP2.png" height="20px" v-b-popover.hover="`The estimated typical IO request size is ${Math.round(this.batchItems[0].Throughput/this.batchItems[0].IOPS*1024)} KB, which makes this database appear to be supporting OLTP-style workloads with some mixed workloads.`" title="OLTP-DW Spectrum Estimation"></img>
<img v-if="(this.batchItems[0].IOPS*1>0) && (this.batchItems[0].Throughput/this.batchItems[0].IOPS*1024 > 120) && (this.batchItems[0].Throughput/this.batchItems[0].IOPS*1024 <= 400)" src="@/assets/OLTP3.png" height="20px" v-b-popover.hover="`The estimated typical IO request size is ${Math.round(this.batchItems[0].Throughput/this.batchItems[0].IOPS*1024)} KB, which makes this database appear to be supporting mixed and/or DW workloads.`" title="OLTP-DW Spectrum Estimation"></img>
<img v-if="(this.batchItems[0].IOPS*1>0) && (this.batchItems[0].Throughput/this.batchItems[0].IOPS*1024 > 400)" src="@/assets/OLTP4.png" height="20px" v-b-popover.hover="`The estimated typical IO request size is ${Math.round(this.batchItems[0].Throughput/this.batchItems[0].IOPS*1024)} KB, which makes this database appear to be supporting DW-style workloads.`" title="OLTP-DW Spectrum Estimation"></img>
<img v-if="(this.batchItems[0].considerSE2=='Yes') || (this.batchItems[0].considerSE2==undefined && !(this.batchItems[0].AWR_MINER_VER != undefined && !(this.batchItems[0].AWR_MINER_VER.includes('aws') || this.batchItems[0].AWR_MINER_VER.includes('statspack')) ) && this.batchItems[0].SE2=='Yes')" src="@/assets/SE2.png" height="20px" v-b-popover.hover="`Consider evaluating this database for Oracle Standard Edition2.  At first glance, DBCSI did not find too many different types of EE features such as Partitioning, Bitmap Indexes, Parallel Query, and VPD/ FGA/ Data Redaction. ${this.batchItems[0].SE2_Comments}`" title="Standard Edition2"></img>

<b-alert :show="showPDBalert" variant="warning">Warning: This is a PDB.  PDB support for DBCSI is still evolving.  We encourage you to also collect data from the CDB database to help DBCSI sanity-check the PDB-level metrics.
And we encourage you to use the newer <router-link :to="{ name: 'Batch', params: {batch_id: this.shareMode ? this.param_collection_id : ('C' + this.collection_id) } }">Auto-Right-Sizer</router-link>
 functionality which has better support.  On this page, some of the PDB charts and the sizing suggestions may not function fully.</b-alert>
              <div id="demo">
                <!-- SYNCHRONIZED WITH Batch.vue line 27 -->
                <b-table striped hover bordered fixed :items="genItems" class="table table-sm">
                  <template v-slot:cell(value)="row">
                    <b-form-textarea v-if="row.item.name == 'DESCRIPTION'" v-model="row.item.value"/>
                    <b-form-input v-if="row.item.name == 'DATABASE'" v-model="row.item.value"/>
                    <div v-if="(row.item.name == 'SE2_ANALYSIS')">{{batchItems[0].SE2_Comments}}</div>
                    <div v-if="!(row.item.name == 'DESCRIPTION' || row.item.name == 'DATABASE' || row.item.name == 'SE2_ANALYSIS')">{{row.item.value}}
                      <img v-if="row.item.name == 'NUM_CPUS'" src="@/assets/info.png" height="20px" v-b-tooltip.hover title="This is the number of operating system CPUs (aka threads) seen by Oracle on a single node.  Source: DBA_HIST_OSSTAT or STATS$OSSTAT"></img>
                      <img v-if="row.item.name == 'NUM_CPU_CORES'" src="@/assets/info.png" height="20px" v-b-tooltip.hover title="This is the number of hardware cores detected by Oracle on a single node.  Source: DBA_HIST_OSSTAT or STATS$OSSTAT"></img>
                      <img v-if="row.item.name == 'GLOBAL_CPU_COUNT'" src="@/assets/info.png" height="20px" v-b-tooltip.hover title="This is the number of operating system CPUs (aka threads) seen by Oracle across all nodes.  Source: DBA_CPU_USAGE _STATISTICS"></img>
                      <img v-if="row.item.name == 'GLOBAL_CPU_CORE_COUNT'" src="@/assets/info.png" height="20px" v-b-tooltip.hover title="This is the number of hardware cores detected by Oracle across all nodes.  Source: DBA_CPU_USAGE _STATISTICS"></img>
                      <img v-if="row.item.name == 'TOTAL_DB_SIZE_GB'" src="@/assets/info.png" height="20px" v-b-tooltip.hover title="This is the total size of all data files and temp files.  Source: DBA_DATA_FILES and DBA_TEMP_FILES"></img>
                      <img v-if="row.item.name == 'TOTAL_DATAFILE_SIZE_GB'" src="@/assets/info.png" height="20px" v-b-tooltip.hover title="This is the total size of all data files.  Source: DBA_DATA_FILES"></img>
                      <img v-if="row.item.name == 'USED_DB_SIZE_GB'" src="@/assets/info.png" height="20px" v-b-tooltip.hover title="This is the total size of all segments.  Source: DBA_SEGMENTS"></img>
                      <img v-if="row.item.name == 'HOSTS'" src="@/assets/info.png" height="20px" v-b-tooltip.hover title="Source: DBA_HIST_ DATABASE_INSTANCE or STATS$ DATABASE_INSTANCE"></img>
                      <img v-if="row.item.name == 'HOSTS_CURRENT'" src="@/assets/info.png" height="20px" v-b-tooltip.hover title="Source: GV$INSTANCE"></img>
                      <img v-if="row.item.name == 'HOST_CONNECTED'" src="@/assets/info.png" height="20px" v-b-tooltip.hover title="The host of the database instance used to collect data."></img>
                      <img v-if="row.item.name == 'INSTANCE#_CONNECTED'" src="@/assets/info.png" height="20px" v-b-tooltip.hover title="The database instance number used to collect data.  DBCSI pulls data from all instances in a RAC Cluster, but it can sometimes be helpful to know which instance was used to collect data."></img>
                      <!--<img v-if="(row.item.name == 'AWR_MINER_VER' && row.item.value.includes('aws'))" src="@/assets/info.png" height="20px" v-b-tooltip.hover title="Reminder: best practice is to always download the latest version of the DBCSI data collection script from the DBCSI Add page."></img>-->
                      <img v-if="(row.item.name == 'AWR_MINER_VER' && !row.item.value.includes('aws'))" src="@/assets/warning.png" height="20px" v-b-tooltip.hover title="Warning: This looks like the generic AWR Miner script output.  DBCSI works best if you use the DBCSI-specific data collection script from the DBCSI Add page."></img>
                      <img v-if="row.item.name == 'STATSPACK_MINER_VER'" src="@/assets/warning.png" height="20px" v-b-tooltip.hover title="Warning: when using STATSPACK data, some features of DBCSI will be limited."></img>
                    </div>

                  </template>
                </b-table>
              </div>

              <b-form-textarea
                id="textarea1"
                v-model="comments.General"
                placeholder="Type your general comments/notes here."
                :rows="3"
                :max-rows="6"
              ></b-form-textarea>
              <b-button
                type="submit"
                v-b-tooltip.hover
                title="Save user inputs to the database"
                block
                variant="outline-success"
              >Save Page</b-button>


              <a href="#" class="card-link">Top of Page</a>
              <b-link href="/" class="card-link">Home Page</b-link>

            </b-card-body>
          </b-collapse>
        </b-card>


        <!-- Comparative Info       -->
        <b-card
          no-body
          class="mb-1"
          border-variant="primary"
          header-bg-variant="primary"
          header-text-variant="white"
        >
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-btn block href="#" v-b-toggle.accordionComparative variant="info">Comparative Information &nbsp;
              <span class="float-right">{{ !showCollapseSummary ? '▶' : '▼' }}</span></b-btn>
          </b-card-header>
          <b-collapse id="accordionComparative" v-model="showCollapseSummary" visible role="tabpanel">
            <b-card-body>

                <div
                  class="Chart"
                >
                  <h2>Databases: Comparative Distributions</h2>
                  <div style="margin: 25px">
                      <p style="font-size:14px">These charts show the percentile distribution of various metrics (such as Database Size) for databases analyzed by DBCSI.  These charts show you how your database's metrics compare relative to other databases.  The horizontal axis is the metric displayed using a logarithmic scale.  The vertical axis represents the percentile for databases ordered by the metric.  0 on the vertical axis is the smallest database for that metric.  50 on the vertical axis represents the database with the median value.  100 on the vertical axis represents the largest database for that metric.  Each database is plotted as a dot showing its metric value and its percentile.</p>
                    </div>
                  <scatterchartcontainer
                    v-if="showCollapseSummary"
                    :collection_type="collection_type"
                    :user="user"
                    label="Database Size (GB)"
                    chart_id="TOTAL_DB_SIZE_GB"
                    reflines="true"
                    linear="false"
                    :refpoint=this.gen_db_size
                    units="GB"
                    color="#3e95cd"
                    scale="1"
                    v-b-popover.hover.top="'This shows the total size of the database data files and temp files in GB.'"
                  title="Database Size (GB)"
                  ></scatterchartcontainer>
                
                 
                  <scatterchartcontainer
                    v-if="showCollapseSummary"
                    :collection_type="collection_type"
                    :user="user"
                    label="CPU Threads"
                    chart_id="blended_cpu1"
                    reflines="true"
                    linear="false"
                    :refpoint=this.blended_cpu1
                    units="threads"
                    color="orange"
                    scale="100"
                    v-b-popover.hover.top="'This shows the 99th Percentile value of the Average # of CPU threads used by the database during each snapshot time period using the Oracle metric: (CPU Usage Per Sec).  For a RAC cluster, this chart aggregates the usage across all instances.'"
                  title="CPU Threads"
                  ></scatterchartcontainer>
                
                  
                  <scatterchartcontainer
                    v-if="showCollapseSummary"
                    :collection_type="collection_type"
                    :user="user"
                    label="IOPS"
                    chart_id="blended_iops1"
                    reflines="true"
                    linear="false"
                    :refpoint=this.blended_iops1
                    units="IOPS"
                    color="green"
                    scale="1"
                    v-b-popover.hover.top="'This shows the Average of the Peak IOPS rate (Database IO Requests/second) during each snapshot time period using the Oracle metrics: (Physical Read Total IO Requests Per Sec, Physical Write Total IO Requests Per Sec).  For a RAC Cluster, the chart aggregates the metrics across all the instances.'"
                  title="IOPS"
                  ></scatterchartcontainer>

                  <scatterchartcontainer
                    v-if="showCollapseSummary"
                    :collection_type="collection_type"
                    :user="user"
                    label="IO Throughput (MB/s)"
                    chart_id="blended_iomb1"
                    reflines="true"
                    linear="false"
                    :refpoint=this.blended_iomb1
                    units="MB/s"
                    color="red"
                    scale="1"
                    v-b-popover.hover.top="'This shows the Average of the Peak IO throughput rates (MB/s) during each snapshot time period using the Oracle metrics: (Physical Read Total Bytes Per Sec, Physical Write Total Bytes Per Sec).  For a RAC Cluster, the chart aggregates the metrics across all the instances.'"
                  title="IO Throughput (MB/s)"
                  ></scatterchartcontainer>
                  
                  <scatterchartcontainer
                    v-if="showCollapseSummary"
                    :collection_type="collection_type"
                    :user="user"
                    label="Database Tables"
                    chart_id="COUNT_TABLE"
                    reflines="true"
                    linear="false"
                    :refpoint=this.count_table
                    units="Tables"
                    color="purple"
                    scale="1"
                    v-b-popover.hover.top="'This shows the total number of database tables.'"
                  title="Database Tables"
                  ></scatterchartcontainer>

                  <scatterchartcontainer
                    v-if="showCollapseSummary"
                    :collection_type="collection_type"
                    :user="user"
                    label="Lines of PLSQL"
                    chart_id="COUNT_LINES_PLSQL"
                    reflines="true"
                    linear="false"
                    :refpoint=this.count_lines_plsql
                    units="Lines"
                    color="purple"
                    scale="1"
                    v-b-popover.hover.top="'This shows the total number of lines of PLSQL.'"
                  title="Lines of PLSQL"
                  ></scatterchartcontainer>
 
                </div>
              <a href="#" class="card-link">Top of Page</a>
              <b-link href="/" class="card-link">Home Page</b-link>
            </b-card-body>
          </b-collapse>
        </b-card>


        <!-- CPU Metrics -->
        <b-card
          no-body
          class="mb-1"
          border-variant="primary"
          header-bg-variant="primary"
          header-text-variant="white"
        >
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-btn block href="#" v-b-toggle.accordionCPU variant="info">CPU Metrics {{this.instanceLabel}} &nbsp;
              <span class="float-right">{{ !showCollapseCPU ? '▶' : '▼' }}</span></b-btn>
          </b-card-header>
          <b-collapse id="accordionCPU" v-model="showCollapseCPU" role="tabpanel">
            <b-card-body>
              This section provides CPU metrics for the database.
              <b-form-checkbox v-model="showHostCPU" switch>Show Additional CPU Metrics</b-form-checkbox>
    <!--          <b-form-checkbox v-model="showMax" switch v-b-popover.hover.top="'This will switch between showing the Peak value seen in each time period to showing the average/sustained value in each time period.'">Show Peak Rates instead of Sustained Rates for each period </b-form-checkbox> -->
              <b-form-checkbox v-model="showReflinesCPU" switch @change="check('CPU')" v-b-popover.hover.top="'Toggling this value will close the current section of charts to change the setting.  Simply re-open this section to see the updated charts.'">Show Reference Lines</b-form-checkbox>
              <b-form-select v-if="this.instances>1" v-model="instanceMetrics" :options="instanceChoices" size="sm" @change="check('ALL')" v-b-popover.hover.top="'Changing this value will close the certain sections of charts mapped to this setting.  Simply re-open those sections to see the updated charts for the selected RAC Instance or Cluster-wide.'">
              </b-form-select>  

              <div class="Chart__list">

                  

                <!-- <div
                  class="Chart"
                  v-b-popover.hover.top="'This shows the average number of sessions active at any point in time during each snapshot time period for this metric: (Average Active Sessions)'"
                  title="About this chart"
                >
                  <h2>Average Active Sessions over Time</h2>
                  <timechart2container
                    v-if="showCollapseCPU"
                    :collection_id="collection_id"
                    :collection_type="collection_type"
                    :user="user"
                    label="Active Sessions"
                    chart_id="AAS"
                  ></timechart2container>
                </div> -->
                <!-- <div class="Chart" 
                          v-b-popover.hover.top="'This shows the average rate (Database Time/s) during each snapshot time period for this metric: (Database Time Per Sec)'" title="About this chart" >
              <h2>DB Time per second over Time</h2>
              <timechart2container v-if="showCollapseCPU"
                :collection_id="collection_id"
                :collection_type="collection_type"
                :user="user"
                label="DB Time (per second)"
                chart_id="DBTIME"
              ></timechart2container>
                </div>-->
                <div
                  class="Chart"
                  v-b-popover.hover.top="'Use this chart to help identify a target baseline of CPU threads needed for this database.'"
                  title="About this chart"
                >
                  <h2>Average Database CPU Usage {{this.instanceLabel}}</h2>
                  <div style="margin: 25px">
                      <p style="font-size:14px">This shows the average # of CPU threads used by the database during each snapshot time period using the Oracle metric: (CPU Usage Per Sec).  It can be greater than 1 when multiple CPU threads at active at the same time.  For a RAC cluster, this chart aggregates the usage across all instances.  Use this chart to help identify a target baseline of CPU threads needed for this database.</p>
                    </div>
                  
                  <div style="margin: 25px">
                  <span style="font-size:14px" v-if="showAlertNonX86">The following chart shows the unmodified CPU usage metrics from the source non-x86 platform and does NOT reflect the CPU Thread Mapping ratio adjustment.</span>  
                  <span style="font-size:14px" v-if="showAIX">  The chart also does NOT reflect the AIX Power SMT CPU time adjustment.</span> 
                  </div>
                  
                  <timechart2container
                    v-if="showCollapseCPU"
                    :collection_id="collection_id"
                    :collection_type="collection_type"
                    :user="user"
                    label="CPU Usage"
                    chart_id="cpu_per_s"
                    :reflines="this.showReflinesCPU"
                    :instance_num="this.instanceMetrics"
                    :start_date="this.start_date"
                    :end_date="this.end_date"
                    :start_date_min="this.start_date_min"
                    :end_date_max="this.end_date_max"
                    :showDateRange="true"
                  ></timechart2container>

                </div>
                
                <div
                  class="Chart"
                  v-b-popover.hover.top="'Use this chart, along with the above Average Database CPU Usage chart, to help identify a target baseline of CPU threads needed for this database.'"
                  title="About this chart"
                >
                  <h2>Peak (non-sustained) Database CPU Usage {{this.instanceLabel}}</h2>
                  <div style="margin: 25px">
                      <p style="font-size:14px">
                      This shows the peak # of CPU threads used by the database during each snapshot time period using the Oracle metric: (CPU Usage Per Sec).  It can be greater than 1 when multiple CPU threads at active at the same time.  For a RAC cluster, this chart aggregates the usage across all instances.  Use this chart, along with the above Average Database CPU Usage chart, to help identify a target baseline of CPU threads needed for this database.  Be sure to run the latest DBCSI data collection SQL script if you do not see any data.</p>
                    </div>
                  
                  <div style="margin: 25px">
                  <span style="font-size:14px" v-if="showAlertNonX86">The following chart shows the unmodified CPU usage metrics from the source non-x86 platform and does NOT reflect the CPU Thread Mapping ratio adjustment.</span>  
                  <span style="font-size:14px" v-if="showAIX">  The chart also does NOT reflect the AIX Power SMT CPU time adjustment.</span> 
                  </div>            
                  
                  <timechart2container
                    v-if="showCollapseCPU"
                    :collection_id="collection_id"
                    :collection_type="collection_type"
                    :user="user"
                    label="CPU Usage"
                    chart_id="cpu_per_s_max"
                    :reflines="this.showReflinesCPU"
                    :instance_num="this.instanceMetrics"
                    :start_date="this.start_date"
                    :end_date="this.end_date"
                    :start_date_min="this.start_date_min"
                    :end_date_max="this.end_date_max"
                    :showDateRange="true"
                  ></timechart2container>
                </div>

                <div
                  class="Chart"
                  v-show="showHostCPU"
                  v-b-popover.hover.top="'This chart is mostly for informational purposes-- use this chart to get an understanding if other databases or other programs are running on the same host (or hosts in the case of an Oracle RAC cluster).'"
                  title="About this chart"
                >
                  <h2>Comparison: Average CPU Usage, Database versus Entire Host {{this.instanceLabel}}</h2>
                  <div style="margin: 25px">
                      <p style="font-size:14px">
                      This compares the average # CPU threads used for this database versus the entire host. It is comparing these Oracle metrics: (CPU Usage Per Sec, Host CPU Per Sec).  This chart is mostly for informational purposes-- use this chart to get an understanding if other databases or other programs are running on the same host (or hosts in the case of an Oracle RAC cluster).  This is a non-stacked chart.</p>
                    </div>
                  <timechart2container
                    v-if="showCollapseCPU && showHostCPU"
                    :collection_id="collection_id"
                    :collection_type="collection_type"
                    :user="user"
                    label="DB CPU Usage:Entire Host CPU Usage"
                    chart_id="CPUWITHHOST"
                    stacked="false"
                    reflines="false"
                    :instance_num="this.instanceMetrics"
                    :start_date="this.start_date"
                    :end_date="this.end_date"
                    :start_date_min="this.start_date_min"
                    :end_date_max="this.end_date_max"
                    :showDateRange="true"
                  ></timechart2container>
                </div>
                
                <div
                  class="Chart"
                  v-show="showHostCPU"
                  v-b-popover.hover.top="'This chart is mostly for informational purposes-- typically you would use the Database CPU Usage charts to determine your target baseline of CPU threads needed for the database.'"
                  title="About this chart"
                >
                  <h2>Entire Host: Average CPU Usage {{this.instanceLabel}}</h2>
                  <div style="margin: 25px">
                      <p style="font-size:14px">
                      This shows the average # of CPU threads used by the entire host during each snapshot time period.  This is the Oracle metric: (Host CPU Usage Per Sec).  It can be greater than 1 when multiple CPU threads at active at the same time.  For a RAC cluster, this chart aggregates the usage across all instances.  This chart is mostly for informational purposes-- typically you would use the Database CPU Usage charts to determine your target baseline of CPU threads needed for the database.</p>
                    </div>
                  
                  <timechart2container
                    v-if="showCollapseCPU && showHostCPU"
                    :collection_id="collection_id"
                    :collection_type="collection_type"
                    :user="user"
                    label="Entire Host CPU Usage"
                    chart_id="h_cpu_per_s"
                    :reflines="this.showReflinesCPU"
                    :instance_num="this.instanceMetrics"
                    :start_date="this.start_date"
                    :end_date="this.end_date"
                    :start_date_min="this.start_date_min"
                    :end_date_max="this.end_date_max"
                    :showDateRange="true"
                  ></timechart2container>
                </div>
                <div
                  class="Chart"
                  v-show="showHostCPU"
                  v-b-popover.hover.top="'This chart is mostly for informational purposes-- typically you would use the Database CPU Usage charts to determine your target baseline of CPU threads needed for the database.'"
                  title="About this chart"
                >
                  <h2>Entire Host: Peak (non-sustained) CPU Usage {{this.instanceLabel}}</h2>
                  <div style="margin: 25px">
                      <p style="font-size:14px">
                      This shows the peak # of CPU threads used by the entire host during each snapshot time period.  This is the Oracle metric: (Host CPU Usage Per Sec).  It can be greater than 1 when multiple CPU threads at active at the same time.  For a RAC cluster, this chart aggregates the usage across all instances.  This chart is mostly for informational purposes-- typically you would use the Database CPU Usage charts to determine your target baseline of CPU threads needed for the database.  Be sure to run the latest DBCSI data collection SQL script if you do not see any data.
                    </p>
                    </div>
                  <timechart2container
                    v-if="showCollapseCPU && showHostCPU"
                    :collection_id="collection_id"
                    :collection_type="collection_type"
                    :user="user"
                    label="Entire Host CPU Usage"
                    chart_id="h_cpu_per_s_max"
                    :reflines="this.showReflinesCPU"
                    :instance_num="this.instanceMetrics"
                    :start_date="this.start_date"
                    :end_date="this.end_date"
                    :start_date_min="this.start_date_min"
                    :end_date_max="this.end_date_max"
                    :showDateRange="true"
                  ></timechart2container>
                </div>

                <!-- <div
                  class="Chart"
                  v-show="showHostCPU"
                  v-b-popover.hover.top="'This shows the average host CPU time used per second during each snapshot time period for this metric: (Host CPU Usage Per Sec).  It can be greater than 1 when multiple CPU cores at active at the same time.'"
                  title="About this chart"
                >
                  <h2>Average Host CPU Usage Per Second over Time</h2>
                  <timechart2container
                    v-if="showCollapseCPU && showHostCPU"
                    :collection_id="collection_id"
                    :collection_type="collection_type"
                    :user="user"
                    label="Host CPU Usage"
                    chart_id="h_cpu_per_s"
                  ></timechart2container>
                </div>
                <div
                  class="Chart"
                  v-show="showHostCPU"
                  v-b-popover.hover.top="'This shows the average host CPU utilization percentage during each snapshot time period for this metric: Host CPU Utilization (%).'"
                  title="About this chart"
                >
                  <h2>Average Host CPU Utilization Percent</h2>
                  <timechart2container
                    v-if="showCollapseCPU && showHostCPU"
                    :collection_id="collection_id"
                    :collection_type="collection_type"
                    :user="user"
                    label="Host CPU Utilization Percent"
                    chart_id="os_cpu"
                  ></timechart2container>
                </div>
                <div
                  class="Chart"
                  v-show="showHostCPU"
                  v-b-popover.hover.top="'This shows the maximum host CPU utilization percentage during each snapshot time period for this metric: Host CPU Utilization (%).'"
                  title="About this chart"
                >
                  <h2>Maximum Host CPU Utilization Percent</h2>
                  <timechart2container
                    v-if="showCollapseCPU && showHostCPU"
                    :collection_id="collection_id"
                    :collection_type="collection_type"
                    :user="user"
                    label="Host CPU Utilization Percent"
                    chart_id="os_cpu_max"
                  ></timechart2container>
                </div> -->
                <!-- <div
                  class="Chart"
                  v-show="showHostCPU"
                  v-b-popover.hover.top="'This shows the average and maximum host CPU utilization percentage during each snapshot time period for this metric: Host CPU Utilization (%).  NOTE: For RAC databases, the percentages of each instance are added together so the total can be > 100%.'"
                  title="About this chart"
                >
                  <h2>Host CPU Utilization Percent</h2>
                  <timechart2container
                    v-if="showCollapseCPU && showHostCPU"
                    :collection_id="collection_id"
                    :collection_type="collection_type"
                    :user="user"
                    label="Average:Maximum"
                    chart_id="CPUOSPCT"
                    stacked="false"
                    :reflines="this.showReflinesCPU"
                  ></timechart2container>
                </div> -->
                <!-- <div
                  class="Chart"
                  v-show="showHostCPU"
                  v-b-popover.hover.top="'This shows the average and peak host CPU utilization percentage during each snapshot time period for this metric: Host CPU Utilization (%).  NOTE: For RAC databases, the percentages of each instance are added together so the total can be > 100%.'"
                  title="About this chart"
                >
                  <h2>Comparison: Entire Host CPU Utilization Percentage </h2>
                  <timechart2container
                    v-if="showCollapseCPU && showHostCPU"
                    :collection_id="collection_id"
                    :collection_type="collection_type"
                    :user="user"
                    label="Average Host CPU as Percentage:Peak Host CPU as Percentage"
                    chart_id="CPUOSPCT"
                    stacked="false"
                    reflines="false"
                  ></timechart2container>
                </div> -->

              </div>

              <div v-if="(this.IS_PDB=='YES')" class="Chart__list">
                <div
                  class="Chart"
                  v-b-popover.hover.top="'Use this chart to help identify a target baseline of CPU threads needed for this database.'"
                  title="About this chart"
                >
                  <h2>PDB CPU Usage - Extra Chart {{this.instanceLabel}}</h2>
                  <div style="margin: 25px">
                      <p style="font-size:14px">Because collecting metrics from PDBs can be difficult, we have collected CPU metrics from a 2nd data source so that you can compare it.  This chart shows the average # of CPU threads used by the database during each snapshot time period using the Oracle metric: (CPU_CONSUMED_TIME from DBA_HIST_RSRC_PDB_METRIC).  Values at the PDB-level are sanity-checked against the CDB (if found in DBCSI) or against typical thresholds, and outliers are not shown.  It can be greater than 1 when multiple CPU threads at active at the same time.  For a RAC cluster, this chart aggregates the usage across all instances.  Use this chart to help identify a target baseline of CPU threads needed for this database.</p>
                    </div>
                
                  
                           <timechart2container 
                            v-if="showCollapseCPU"
                    :collection_id="collection_id"
                    :collection_type="collection_type"
                    :user="user"
                            label="Average DB CPU Usage for the PDB"
                            chart_id="PDB_CPU_USAGE_PER_S"
                    :reflines="this.showReflinesCPU"
                    :instance_num="this.instanceMetrics"
                            :filter="`${(this.IS_PDB=='YES') ? this.batchItems[0].CDB_VCPU*2 : 0}`"
                            :start_date="this.start_date"
                    :end_date="this.end_date"
                    :start_date_min="this.start_date_min"
                    :end_date_max="this.end_date_max"
                    :showDateRange="true"
                          ></timechart2container>
               
                </div>
                
              </div>
              
              <br>
              <b-card>
                <b-alert :show="showAlertNonX86" variant="warning">{{alertTextNonX86}}</b-alert>
                <b-form-group v-if="showAlertNonX86" label="CPU Thread Mapping Ratio:" label-cols="3"
                  v-b-popover.hover.top="'The Thread Mapping Ratio is the number of source system threads that are equivalent to 1 Intel thread.  For instance, for a SPARC T4, you might enter 5.  You can use industry benchmarks such as SPECINT to compare thread-to-thread performance for different chipsets to derive the ratio to use.'">
                  <b-form-input 
                        v-model.lazy="form.cpu_thread_ratio" type="number"
                        step="0.01"
                        :placeholder="`Ratio to map ${this.gen_platform} threads to Intel threads`"
                        @input="autosuggest('CPU')">
                  </b-form-input>
                </b-form-group>
                <b-form-group v-if="showAIX" label="AIX Power CPU Usage Time Adjustment:" label-cols="3" 
                v-b-popover.hover="'The AIX Power SMT CPU Time Adjustment tries to normalize AIX CPU metrics to what Oracle reports on non-AIX platforms.  This adjustment accounts for so-called missing time for Oracle usage on Power7 and newer AIX hardware.  Refer to https://ardentperf.com/2016/07/01/understanding-cpu-on-aix-power-smt-systems/ for additional reading.'">
                <b-form-select v-model="form.aix_algo"  @change="autosuggest('CPU')">
                  <option value="old">Multiply the measured CPU usage of AIX by 8 for SMT-8 and by 4 for SMT-4 (previous default algorithm but we now think this was too extreme)</option>
                  <option value="new">Multiply the measured CPU usage of AIX by 4 for SMT-8 and by 2.5 for SMT-4</option>
                  <option value="new2">Multiply the measured CPU usage of AIX by 2.0 for SMT-8 and by 1.8 for SMT-4</option>
                  <option value="none">Do not try to adjust for AIX SMT CPU time reporting (good for Power6 and earlier hardware)</option>
                </b-form-select>
              </b-form-group>
                
                <b-form-group v-if="IS_PDB=='YES'" label="PDB Metric Data Source:" label-cols="3" label-size="sm" 
                  v-b-tooltip.hover.top="'You can use this control to tell DBCSI what Oracle AWR data source to use for PDB-level metrics.  In some cases, Oracle AWR seems to mis-report PDB-level metrics (such as surprisingly low or high values) and you can tell DBCSI to use data from the other AWR table to work-around this AWR problem.'">
                  <b-form-select v-model="form.pdb_algo" size="sm" @change="autosuggest('CPU')">
                    <option value="pdb1">Use Oracle's DBA_HIST_CON_SYSMETRIC_SUMM table for PDB-level CPU </option>
                    <option value="pdb2">Use Oracle's DBA_HIST_RSRC_PDB_METRIC table for PDB-level CPU </option>
                  </b-form-select>
                </b-form-group>
                

                <b-form-group label="Auto Suggest Algorithm:" label-cols="3" >
                  <b-form-select v-model="form.cpu_algo"  @change="autosuggest('CPU')" v-b-popover.hover.top="'Choose different algorithms to see the value suggested based on that algorithm'">
                    <option value="cpu1">P99 of the averages</option>
                    <option value="cpu1_plus10">P99 of the averages, plus 10%</option>
                    <option value="cpu5">P75 of the averages</option>
                    <option value="cpu5_plus10">P75 of the averages, plus 10%</option>
                    <option value="cpu2">P90 of the peaks</option>
                    <option value="cpu2_plus10">P90 of the peaks, plus 10%</option>
                    <option value="cpu3">Larger of the P99 of the averages OR the P90 of the peaks</option>
                    <option value="cpu3_plus10">Larger of the P99 of the averages OR the P90 of the peaks, plus 10%</option>
                    <option value="cpu4">Larger of the P99 of the averages OR the P97 of the peaks</option>
                    <option value="cpu4_plus10">Larger of the P99 of the averages OR the P97 of the peaks, plus 10%</option>
                  </b-form-select>
                </b-form-group>
              
                
                Suggested vCPUs: {{suggestions.VCPU}} 
                <br/><img v-if="(this.suggestions.cpu_target_comments!=undefined)&&(this.suggestions.cpu_target_comments!='')" src="@/assets/info.png" height="20px" v-b-popover.hover="`${this.suggestions.cpu_target_comments}`" title="Adjustments"></img>{{suggestions.cpu_target_comments}}
              </b-card>
              <br/>


              <b-form-group label="Desired VCPUs" label-cols="4">
                <b-form-input
                  type="number"
                  v-model="ec2.VCPU"
                  class="col-6"
                  placeholder="Enter desired # of VCPUs"
                ></b-form-input>
              </b-form-group>

              <b-form-textarea
                id="textarea4"
                v-model="comments.CPU"
                placeholder="Type your CPU comments/notes here."
                :rows="3"
                :max-rows="6"
              ></b-form-textarea>
              <b-button
                type="submit"
                v-b-tooltip.hover
                title="Save user inputs to the database"
                block
                variant="outline-success"
              >Save Page</b-button>
              <a href="#" class="card-link">Top of Page</a>
              <b-link href="/" class="card-link">Home Page</b-link>
            </b-card-body>
          </b-collapse>
        </b-card>

        <!-- Memory metrics -->
        <b-card
          no-body
          class="mb-1"
          border-variant="primary"
          header-bg-variant="primary"
          header-text-variant="white"
        >
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-btn block href="#" v-b-toggle.accordionMemory variant="info">Memory Metrics {{this.instanceLabel}} &nbsp;
              <span class="float-right">{{ !showCollapseMemory ? '▶' : '▼' }}</span></b-btn>
          </b-card-header>
          <b-collapse id="accordionMemory" v-model="showCollapseMemory" role="tabpanel">
            <b-card-body>
              This section provides information about database memory allocation.
              <b-form-select v-if="this.instances>1" v-model="instanceMetrics" :options="instanceChoices" size="sm" @change="check('ALL')" v-b-popover.hover.top="'Changing this value will close the certain sections of charts mapped to this setting.  Simply re-open those sections to see the updated charts for the selected RAC Instance or Cluster-wide.'">
              </b-form-select>  

              <div class="Chart__list">
                <div
                  class="Chart"
                  v-b-popover.hover.top="'Use this chart to help select a target memory configuration for this database.'"
                  title="About this chart"
                >
                  <h2>Memory Allocation (GB) {{this.instanceLabel}}</h2>
                  <div style="margin: 25px">
                      <p style="font-size:14px">
                      This shows the combined allocated size in GB of the SGA and PGA.  For Oracle RAC clusters, the sizes are the aggregate across all instances.  Use this chart to help select a target memory configuration for this database (be sure to allow for some additional memory for the operating system).  This is a stacked chart.</p>
                    </div>
                          <timechart2container 
                    v-if="showCollapseMemory && (this.IS_PDB=='YES')"
                    :collection_id="collection_id"
                    :collection_type="collection_type"
                    :user="user"
                            label="PDB SGA:PDB PGA"
                            chart_id="MEMORYPDB"
                            stacked="true"
                            reflines="false"
                    :instance_num="this.instanceMetrics"
                    :start_date="this.start_date"
                    :end_date="this.end_date"
                    :start_date_min="this.start_date_min"
                    :end_date_max="this.end_date_max"
                    :showDateRange="true"
                          ></timechart2container>
                          <timechart2container 
                    v-if="showCollapseMemory && ((this.IS_PDB== undefined) || (this.IS_PDB!='YES'))"
                    :collection_id="collection_id"
                    :collection_type="collection_type"
                    :user="user"
                            label="SGA:PGA"
                            chart_id="MEMORY"
                            stacked="true"
                            reflines="false"
                    :instance_num="this.instanceMetrics"
                    :start_date="this.start_date"
                    :end_date="this.end_date"
                    :start_date_min="this.start_date_min"
                    :end_date_max="this.end_date_max"
                    :showDateRange="true"
                          ></timechart2container>
                  

                </div>
              </div>
              <b-card>
                <b-form-group label="Auto Suggest Algorithm:" label-cols="3" >
                  <b-form-select v-model="form.memory_algo"  @change="autosuggest('MEMORY')" v-b-popover.hover.top="'Adjusted for RAC means that each additional RAC instance adds 50% (not 100%) of its SGA+PGA to the target memory value.  The idea is that in a RAC environment, the same blocks are kept in multiple RAC instances block buffers, so it is not as if you were getting 100% benefit of the aggregate total amount of memory.'">
                    <option value="mem1">sum(SGA+PGA)</option>
                    <option value="mem1_plus20_2">sum(SGA+PGA), plus greater of 2GB or 20%</option>
                    <option value="mem2">sum(SGA+PGA) adjusted for RAC</option>
                    <option value="mem2_plus20_2">sum(SGA+PGA) adjusted for RAC, plus greater of 2GB or 20%</option>
                  </b-form-select>
                </b-form-group>
              <b-form-group v-if="IS_EXADATA" label="Boost post-Exadata Memory target?:" label-cols="3" label-size="sm" v-b-tooltip.hover="'When moving away from Exadata, a common technique is to increasing the memory allocation for the buffer cache.'">
                <b-form-select v-model="form.exa_memory_algo" size="sm" @change="autosuggest('MEMORY')">
                  <option value="em0">No - leave Memory target alone</option>
                  <option value="em1" >Yes - favor a bigger Memory target to ease post-Exadata transition</option>
                </b-form-select>
              </b-form-group>

                Suggested Memory: {{suggestions.Memory}}
                <br/> <img v-if="(this.suggestions.memory_target_comments!=undefined)&&(this.suggestions.memory_target_comments!='')" src="@/assets/info.png" height="20px" v-b-popover.hover="`${this.suggestions.memory_target_comments}`" title="Adjustments"></img> {{suggestions.memory_target_comments}}
              </b-card>
              <br/>
              
              <b-form-group label="Desired Memory (GB)" label-cols="4">
                <b-form-input
                  type="number"
                  v-model="ec2.Memory"
                  class="col-6"
                  placeholder="Enter desired amount of Memory in GB"
                ></b-form-input>
              </b-form-group>

              <b-form-textarea
                id="textarea5"
                v-model="comments.Memory"
                placeholder="Type your memory comments/notes here."
                :rows="3"
                :max-rows="6"
              ></b-form-textarea>
              <b-button
                type="submit"
                v-b-tooltip.hover
                title="Save user inputs to the database"
                block
                variant="outline-success"
              >Save Page</b-button>
              <a href="#" class="card-link">Top of Page</a>
              <b-link href="/" class="card-link">Home Page</b-link>
            </b-card-body>
          </b-collapse>
        </b-card>

        <!-- IOPS Metrics -->
        <b-card
          no-body
          class="mb-1"
          border-variant="primary"
          header-bg-variant="primary"
          header-text-variant="white"
        >
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-btn block href="#" v-b-toggle.accordionIOPS variant="info">IOPS Metrics  {{this.instanceLabel}} &nbsp;
              <span class="float-right">{{ !showCollapseIOPS ? '▶' : '▼' }}</span></b-btn>
          </b-card-header>
          <b-collapse id="accordionIOPS" v-model="showCollapseIOPS" role="tabpanel">
            <b-card-body>
              These I/O metrics are stacked charts (the reads are drawn above the writes) to allow you to see the combined writes+reads visually.
              <!-- <b-form-checkbox v-model="showMax" switch v-b-popover.hover.top="'This will toggle showing the Peak value seen in each time period in addition to showing the average/sustained value in each time period.'">Show Additional Metrics</b-form-checkbox> -->
              <b-form-checkbox v-model="showReflines" switch @change="check('IO')" v-b-popover.hover.top="'Toggling this value will close the current section of charts to change the setting.  Simply re-open this section to see the updated charts.'">Show Reference Lines</b-form-checkbox>
              <b-form-select v-if="this.instances>1" v-model="instanceMetrics" :options="instanceChoices" size="sm" @change="check('ALL')" v-b-popover.hover.top="'Changing this value will close the certain sections of charts mapped to this setting.  Simply re-open those sections to see the updated charts for the selected RAC Instance or Cluster-wide.'">
              </b-form-select>  
              
                <div
                  class="Chart"
                  v-b-popover.hover.top="'Use this chart to help select a target baseline for IOPS for this database.'"
                  title="About this chart"
                >
                  <h2>Average IOPS (IO Requests/second) {{this.instanceLabel}}</h2>
                              <div style="margin: 25px" v-if="(this.IS_PDB=='YES')">
                                  <p style="font-size:14px">The below chart shows the average IOPS during each snapshot time period using the Oracle metric: (IOPS from DBA_HIST_RSRC_PDB_METRIC).  This is a PDB-specific metric and may not include some IOPS that happen at the CDB-level.  For a RAC Cluster, the chart aggregates the metrics across all the instances.  Use this chart to help select a target baseline for IOPS for this database.</p>
                                </div>
                  <div style="margin: 25px" v-else>
                      <p style="font-size:14px">
                      This shows the average rate (Database IO Requests/second) during each snapshot time period using the Oracle metrics: (Physical Read Total IO Requests Per Sec, Physical Write Total IO Requests Per Sec).  For a RAC Cluster, the chart aggregates the metrics across all the instances.  Use this chart to help select a target baseline for IOPS for this database.  This is a stacked chart.
                    </p>
                  </div>

                              <timechart2container v-if="showCollapseIOPS && (this.IS_PDB=='YES')"
                    :collection_id="collection_id"
                    :collection_type="collection_type"
                    :user="user"
                                label="Average IOPS for the PDB"
                                chart_id="PDB_IOPS"
                    :reflines="this.showReflines"
                    :instance_num="this.instanceMetrics"
                     :filter="`${(this.IS_PDB=='YES') ? this.batchItems[0].CDB_IOPS*2 : 0}`"
                     :start_date="this.start_date"
                    :end_date="this.end_date"
                    :start_date_min="this.start_date_min"
                    :end_date_max="this.end_date_max"
                    :showDateRange="true"
                              ></timechart2container>
                              <timechart2container v-if="showCollapseIOPS && ((this.IS_PDB==undefined)||(this.IS_PDB!='YES'))"
                    :collection_id="collection_id"
                    :collection_type="collection_type"
                    :user="user"
                    label="writes:reads"
                    chart_id="IOPS_RW"
                    stacked="true"
                    :reflines="this.showReflines"
                    :instance_num="this.instanceMetrics"
                    :start_date="this.start_date"
                    :end_date="this.end_date"
                    :start_date_min="this.start_date_min"
                    :end_date_max="this.end_date_max"
                    :showDateRange="true"
                              ></timechart2container>
                  
                  
                  
                  
                </div>
                
              <b-card>
                <b-form-group label="Auto Suggest Algorithm:" label-cols="3" >
                  <b-form-select v-model="form.iops_algo"  @change="autosuggest('IOPS')" v-b-popover.hover.top="'Choose different algorithms to see the value suggested based on that algorithm'">
                    <!--<option value="iops1">AVERAGE of the peaks</option>-->
                    <!--<option value="iops1_plus10">AVERAGE of the peaks, plus 10%</option>-->
                    <option value="iops2">P99 of the averages</option>
                    <option value="iops2_plus10">P99 of the averages, plus 10%</option>
                    <option value="iops3">P90 of the peaks</option>
                    <option value="iops3_plus10">P90 of the peaks, plus 10%</option>
                    <option value="iops5">Larger of the P99 of the averages OR the P50 of the peaks</option>
                    <option value="iops5_plus10">Larger of the P99 of the averages OR the P50 of the peaks, plus 10%</option>
                    <option value="iops4">Larger of the P99 of the averages OR the P90 of the peaks</option>
                    <option value="iops4_plus10">Larger of the P99 of the averages OR the P90 of the peaks, plus 10%</option>
                    <option value="iops6">Larger of the P99 of the averages OR the P97 of the peaks</option>
                    <option value="iops6_plus10">Larger of the P99 of the averages OR the P97 of the peaks, plus 10%</option>
                  </b-form-select>
                </b-form-group>
                <b-form-group v-if="IS_EXADATA" label="Assume post-Exadata tuning?:" label-cols="3" label-size="sm" v-b-tooltip.top="'One or more of these databases run on Exadata.  Exadata can favor the use of I/O intensive SmartScans in lieu of more I/O-friendly techniques such as index lookups.  Some customers will take the time/effort to do some post-Exadata tuning to convert their heaviest SQL queries from SmartScans(Full-Table Scans) to indexes or materialized views because the benefits (smaller configurations and more managable I/O demands) outweigh the effort of tuning.'">
                  <b-form-select v-model="form.smartscan_algo" size="sm"  @change="autosuggest('IOMB')">
                    <option value="ss1">No - assume no ex-SmartScan adjustments (such as query tuning, indexes, materialized views, ...)</option>
                    <option value="ss2a" >Yes(Light) - assume some light tuning to reduce I/O Throughput</option>
                    <option value="ss2" >Yes(Moderate) - assume some moderate tuning to reduce I/O Throughput</option>
                    <option value="ss3" >Yes(Heavy) - assume some heavy tuning to reduce I/O Throughput</option>
                    <option value="ss4" >Yes(Very Heavy) - assume some very heavy tuning to reduce I/O Throughput</option>
                  </b-form-select>
                </b-form-group>
                
                Suggested IOPS: {{suggestions.IOPS}}
                <br/> <img v-if="(this.suggestions.iops_target_comments!=undefined)&&(this.suggestions.iops_target_comments!='')" src="@/assets/info.png" height="20px" v-b-popover.hover="`${this.suggestions.iops_target_comments}`" title="Adjustments"></img> {{suggestions.iops_target_comments}}
              </b-card>
              <br/>

              <b-form-group label="Desired IOPS (IO/s)" label-cols="4">
                <b-form-input
                  type="number"
                  v-model="ebs.IOPS"
                  class="col-6"
                  placeholder="Enter desired IOPS in IO/s"
                ></b-form-input>
              </b-form-group>

                
                <div
                  class="Chart"
                  v-if="(this.IS_PDB==undefined)||(this.IS_PDB!='YES')"
                  v-b-popover.hover.top="'Use this chart, along with the above Average IOPS chart, to help select a target baseline for IOPS for this database.'"
                  title="About this chart"
                >
                  <h2>Peak (non-sustained) IOPS (IO Requests/second) {{this.instanceLabel}}</h2>
                  <div style="margin: 25px">
                      <p style="font-size:14px">
                      This shows the peak (non-sustained) rate (Database IO Requests/second) during each snapshot time period using the Oracle metrics: (Physical Read Total IO Requests Per Sec, Physical Write Total IO Requests Per Sec).  For a RAC Cluster, the chart aggregates the metrics across all the instances.  Use this chart, along with the above Average IOPS chart, to help select a target baseline for IOPS for this database.  This is a stacked chart.
                    </p>
                    </div>
                  <timechart2container
                    v-if="showCollapseIOPS && ((this.IS_PDB==undefined)||(this.IS_PDB!='YES'))"
                    :collection_id="collection_id"
                    :collection_type="collection_type"
                    :user="user"
                    label="max writes:max reads"
                    chart_id="IOPS_RW_MAX"
                    stacked="true"
                    :reflines="this.showReflines"
                    :instance_num="this.instanceMetrics"
                    :start_date="this.start_date"
                    :end_date="this.end_date"
                    :start_date_min="this.start_date_min"
                    :end_date_max="this.end_date_max"
                    :showDateRange="true"
                  ></timechart2container>

              </div>



              <b-row>
                <b-col
                  v-if="ec2.Throughput>0 && ebs.IOPS>0"
                >Implied average database request size: {{(ec2.Throughput*1024/ebs.IOPS).toFixed(0)}} KB</b-col>
              </b-row>

              <b-form-textarea
                id="textarea3"
                v-model="comments.IO"
                placeholder="Type your I/O comments/notes here."
                :rows="3"
                :max-rows="6"
              ></b-form-textarea>
              <b-button
                type="submit"
                v-b-tooltip.hover
                title="Save user inputs to the database"
                block
                variant="outline-success"
              >Save Page</b-button>
              <a href="#" class="card-link">Top of Page</a>
              <b-link href="/" class="card-link">Home Page</b-link>
            </b-card-body>
          </b-collapse>
        </b-card>


        <!-- IOMB Metrics -->
        <b-card
          no-body
          class="mb-1"
          border-variant="primary"
          header-bg-variant="primary"
          header-text-variant="white"
        >
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-btn block href="#" v-b-toggle.accordionIOMB variant="info">I/O Throughput Metrics  {{this.instanceLabel}} &nbsp;
              <span class="float-right">{{ !showCollapseIOMB ? '▶' : '▼' }}</span></b-btn>
          </b-card-header>
          <b-collapse id="accordionIOMB" v-model="showCollapseIOMB" role="tabpanel">
            <b-card-body>
              These I/O metrics are stacked charts (the reads are drawn above the writes) to allow you to see the combined writes+reads visually.
              <!-- <b-form-checkbox v-model="showMax" switch v-b-popover.hover.top="'This will toggle showing the Peak value seen in each time period in addition to showing the average/sustained value in each time period.'">Show Additional Metrics</b-form-checkbox> -->
              <b-form-checkbox v-model="showReflines" switch @change="check('IO')" v-b-popover.hover.top="'Toggling this value will close the current section of charts to change the setting.  Simply re-open this section to see the updated charts.'">Show Reference Lines</b-form-checkbox>
              <b-form-select v-if="this.instances>1" v-model="instanceMetrics" :options="instanceChoices" size="sm" @change="check('ALL')" v-b-popover.hover.top="'Changing this value will close the certain sections of charts mapped to this setting.  Simply re-open those sections to see the updated charts for the selected RAC Instance or Cluster-wide.'">
              </b-form-select>  
              <div class="Chart__list">

                
                <div
                  class="Chart"
                  v-b-popover.hover.top="'Use this chart to help select a target baseline for Throughput for this database.'"
                  title="About this chart"
                >
                  <h2>Average Throughput (MB/s) {{this.instanceLabel}}</h2>
                  <div style="margin: 25px">
                      <p style="font-size:14px">
                      This shows the average IO throughput rate (MB/s) during each snapshot time period using the Oracle metrics: (Physical Read Total Bytes Per Sec, Physical Write Total Bytes Per Sec).  For a RAC Cluster, the chart aggregates the metrics across all the instances. For an Exadata system, this does include I/O from the storage cells even I/O avoided via storage index use. Use this chart to help select a target baseline for Throughput for this database.  This is a stacked chart.
                    </p>
                    </div>
                  <timechart2container
                    v-if="showCollapseIOMB"
                    :collection_id="collection_id"
                    :collection_type="collection_type"
                    :user="user"
                    label="writes:reads"
                    chart_id="IO_MBS_RW"
                    stacked="true"
                    :reflines="this.showReflines"
                    :instance_num="this.instanceMetrics"
                    :start_date="this.start_date"
                    :end_date="this.end_date"
                    :start_date_min="this.start_date_min"
                    :end_date_max="this.end_date_max"
                    :showDateRange="true"
                  ></timechart2container>
                </div>
                
                <div v-if="(this.IS_PDB=='YES')"
                  class="Chart"
                  v-b-popover.hover.top="'Use this chart to help identify a target IO throughput needed for this database.'"
                  title="About this chart"
                >
                  <h2>PDB Throughput - Extra Chart {{this.instanceLabel}}</h2>
                  <div style="margin: 25px">
                      <p style="font-size:14px">Because collecting metrics from PDBs can be difficult, we have collected IO Throughput metrics from a 2nd data source so that you can compare it.  This chart shows the average IO throughput rate (MB/s) during each snapshot time period using the Oracle metric: (IOMBPS from DBA_HIST_RSRC_PDB_METRIC).  Values at the PDB-level are sanity-checked against the CDB (if found in DBCSI) or against typical thresholds, and outliers are not shown.  For a RAC Cluster, the chart aggregates the metrics across all the instances. For an Exadata system, this does include I/O from the storage cells even I/O avoided via storage index use. Use this chart to help select a target baseline for Throughput for this database.</p>
                    </div>
                
                  
                           <timechart2container 
                            v-if="showCollapseIOMB"
                    :collection_id="collection_id"
                    :collection_type="collection_type"
                    :user="user"
                            label="Average Throughput for the PDB"
                            chart_id="PDB_IOMBPS"
                    :reflines="this.showReflinesCPU"
                    :instance_num="this.instanceMetrics"
                            :filter="`${(this.IS_PDB=='YES') ? this.batchItems[0].CDB_IOMB*2 : 0}`"
                            :start_date="this.start_date"
                    :end_date="this.end_date"
                    :start_date_min="this.start_date_min"
                    :end_date_max="this.end_date_max"
                    :showDateRange="true"
                          ></timechart2container>

                </div>
                



              <b-card>
                <b-form-group label="Auto Suggest Algorithm:" label-cols="3" >
                  <b-form-select v-model="form.iomb_algo"  @change="autosuggest('IOMB')" v-b-popover.hover.top="'Choose different algorithms to see the value suggested based on that algorithm'">
                    <!--<option value="iomb1">AVERAGE of the peaks</option>-->
                    <!--<option value="iomb1_plus10">AVERAGE of the peaks, plus 10%</option>-->
                    <option value="iomb2">P99 of the averages</option>
                    <option value="iomb2_plus10">P99 of the averages, plus 10%</option>
                    <option value="iomb3">P90 of the peaks</option>
                    <option value="iomb3_plus10">P90 of the peaks, plus 10%</option>
                    <option value="iomb5">Larger of the P99 of the averages OR the P50 of the peaks</option>
                    <option value="iomb5_plus10">Larger of the P99 of the averages OR the P50 of the peaks, plus 10%</option>
                    <option value="iomb4">Larger of the P99 of the averages OR the P90 of the peaks</option>
                    <option value="iomb4_plus10">Larger of the P99 of the averages OR the P90 of the peaks, plus 10%</option>
                    <option value="iomb6">Larger of the P99 of the averages OR the P97 of the peaks</option>
                    <option value="iomb6_plus10">Larger of the P99 of the averages OR the P97 of the peaks, plus 10%</option>
                  </b-form-select>
                </b-form-group>
                
              <b-form-group v-if="IS_EXADATA" label="Assume post-Exadata tuning?:" label-cols="3" label-size="sm" v-b-tooltip.top="'One or more of these databases run on Exadata.  Exadata can favor the use of I/O intensive SmartScans in lieu of more I/O-friendly techniques such as index lookups.  Some customers will take the time/effort to do some post-Exadata tuning to convert their heaviest SQL queries from SmartScans(Full-Table Scans) to indexes or materialized views because the benefits (smaller configurations and more managable I/O demands) outweigh the effort of tuning.'">
                <b-form-select v-model="form.smartscan_algo" size="sm"  @change="autosuggest('IOMB')">
                  <option value="ss1">No - assume no ex-SmartScan adjustments (such as query tuning, indexes, materialized views, ...)</option>
                  <option value="ss2a" >Yes(Light) - assume some light tuning to reduce I/O Throughput</option>
                  <option value="ss2" >Yes(Moderate) - assume some moderate tuning to reduce I/O Throughput</option>
                  <option value="ss3" >Yes(Heavy) - assume some heavy tuning to reduce I/O Throughput</option>
                  <option value="ss4" >Yes(Very Heavy) - assume some very heavy tuning to reduce I/O Throughput</option>
                </b-form-select>
              </b-form-group>
                
              <b-form-group v-if="IS_EXADATA" label="post-Exadata tuning IO Throughput minimum threshold (MB/s):" label-cols="3" label-size="sm"
                v-b-tooltip.hover="'This is the minimum IO Throughput needed to apply the post-Exadata tuning assumptions.  Databases with a smaller IO throughput will be ignored/skipped when applying the tuning assumptions.'">
                <b-form-input @change="autosuggest('IOMB')"
                      v-model="form.smartscan_minimum" size="sm" type="number"
                      step="1"
                      :placeholder="`minimum IO throughput (MB/s) before applying tuning assumption`">
                </b-form-input>
              </b-form-group>

                <b-form-group v-if="IS_PDB=='YES'" label="PDB Metric Data Source:" label-cols="3" label-size="sm" 
                  v-b-tooltip.hover.top="'You can use this control to tell DBCSI what Oracle AWR data source to use for PDB-level metrics.  In some cases, Oracle AWR seems to mis-report PDB-level metrics (such as surprisingly low or high values) and you can tell DBCSI to use data from the other AWR table to work-around this AWR problem.'">
                  <b-form-select v-model="form.pdb_algo" size="sm" @change="autosuggest('CPU')">
                    <option value="pdb1">Use Oracle's DBA_HIST_CON_SYSMETRIC_SUMM table for PDB-level IO Throughput </option>
                    <option value="pdb2">Use Oracle's DBA_HIST_RSRC_PDB_METRIC table for PDB-level IO Throughput </option>
                  </b-form-select>
                </b-form-group>
                
                Suggested Throughput: {{suggestions.Throughput}}
                <br/> <img v-if="(this.suggestions.iomb_target_comments!=undefined)&&(this.suggestions.iomb_target_comments!='')" src="@/assets/info.png" height="20px" v-b-popover.hover="`${this.suggestions.iomb_target_comments}`" title="Adjustments"></img> {{suggestions.iomb_target_comments}}
              </b-card>
              <br/>
                
              <b-form-group label="Desired Throughput (MB/s)" label-cols="4">
                <b-form-input
                  type="number"
                  v-model="ec2.Throughput"
                  class="col-6"
                  placeholder="Enter desired I/O throughput in MB/s"
                ></b-form-input>
              </b-form-group>

                <div
                  class="Chart"
                  v-b-popover.hover.top="'Use this chart, along with the above Average Throughput chart, to help select a target baseline for Throughput for this database.'"
                  title="About this chart"
                >
                  <h2>Peak (non-sustained) Throughput (MB/s) {{this.instanceLabel}}</h2>
                  <div style="margin: 25px">
                      <p style="font-size:14px">
                      This shows the peak (non-sustained) IO throughput rate (MB/s) during each snapshot time period using the Oracle metrics: (Physical Read Total Bytes Per Sec, Physical Write Total Bytes Per Sec).  For a RAC Cluster, the chart aggregates the metrics across all the instances. For an Exadata system, this does include I/O from the storage cells even I/O avoided via storage index use. Use this chart, along with the above Average Throughput chart, to help select a target baseline for Throughput for this database.  This is a stacked chart.</p>
                    </div>
                  
                  <timechart2container
                    v-if="showCollapseIOMB"
                    :collection_id="collection_id"
                    :collection_type="collection_type"
                    :user="user"
                    label="max writes:max reads"
                    chart_id="IO_MBS_RW_MAX"
                    stacked="true"
                    :reflines="this.showReflines"
                    :instance_num="this.instanceMetrics"
                    :start_date="this.start_date"
                    :end_date="this.end_date"
                    :start_date_min="this.start_date_min"
                    :end_date_max="this.end_date_max"
                    :showDateRange="true"
                  ></timechart2container>
                </div>
              </div>



              <b-row>
                <b-col
                  v-if="ec2.Throughput>0 && ebs.IOPS>0"
                >Implied average database request size: {{(ec2.Throughput*1024/ebs.IOPS).toFixed(0)}} KB</b-col>
              </b-row>

              <b-form-textarea
                id="textarea3"
                v-model="comments.IO"
                placeholder="Type your I/O comments/notes here."
                :rows="3"
                :max-rows="6"
              ></b-form-textarea>
              <b-button
                type="submit"
                v-b-tooltip.hover
                title="Save user inputs to the database"
                block
                variant="outline-success"
              >Save Page</b-button>
              <a href="#" class="card-link">Top of Page</a>
              <b-link href="/" class="card-link">Home Page</b-link>
            </b-card-body>
          </b-collapse>
        </b-card>

        <!-- Disk Space Metrics -->
        <b-card
          no-body
          class="mb-1"
          border-variant="primary"
          header-bg-variant="primary"
          header-text-variant="white"
        >
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-btn block href="#" v-b-toggle.accordionDiskSpace variant="info">Disk Space Metrics &nbsp;
              <span class="float-right">{{ !showCollapseDiskSpace ? '▶' : '▼' }}</span></b-btn>
          </b-card-header>
          <b-collapse id="accordionDiskSpace" v-model="showCollapseDiskSpace" role="tabpanel">
            <b-card-body>
              This section provides disk space metrics for the database. It shows the total allocated space of the non-TEMP tablespaces for the database.
              <div class="Chart__list">
                <div
                  class="Chart"
                  v-b-popover.hover.top="'This shows the aggregate size of all tablespaces over time.  It does not count TEMP tablespaces or REDO logs.  In some cases, our script may not be able to collect data and this chart will be empty.  If needed, you can find TOTAL_DB_SIZE_GB and USED_DB_SIZE_GB metrics in the General Information section.'"
                  title="About this chart"
                >
                  <h2>Disk Space Metrics (GB) over Time</h2>
                  <timechart2container
                    v-if="showCollapseDiskSpace"
                    :collection_id="collection_id"
                    :collection_type="collection_type"
                    :user="user"
                    label="Disk Space (GB)"
                    chart_id="DISK_SPACE"
                    reflines="false"
                    :start_date="this.start_date"
                    :end_date="this.end_date"
                    :start_date_min="this.start_date_min"
                    :end_date_max="this.end_date_max"
                    :showDateRange="true"
                  ></timechart2container>
                </div>
                
                Total Database Disk Space when data collection script was run (GB): {{gen_db_size}}
                
              </div>

              <br>

              <b-form-group label="Desired Disk Space (GB)" label-cols="4">
                <b-form-input
                  type="number"
                  v-model="ebs.DiskSpace"
                  class="col-6"
                  placeholder="Enter desired disk space in GB"
                ></b-form-input>
              </b-form-group>

              <b-form-textarea
                id="textarea2"
                v-model="comments.DiskSpace"
                placeholder="Type your disk space comments/notes here."
                :rows="3"
                :max-rows="6"
              ></b-form-textarea>
              <b-button
                type="submit"
                v-b-tooltip.hover
                title="Save user inputs to the database"
                block
                variant="outline-success"
              >Save Page</b-button>
              <a href="#" class="card-link">Top of Page</a>
              <b-link href="/" class="card-link">Home Page</b-link>
            </b-card-body>
          </b-collapse>
        </b-card>


        <!-- Backup Metrics -->
        <b-card
          no-body
          class="mb-1"
          border-variant="primary"
          header-bg-variant="primary"
          header-text-variant="white"
        >
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-btn block href="#" v-b-toggle.accordionBackup variant="info">Backup Metrics &nbsp;
              <span class="float-right">{{ !showCollapseBackup ? '▶' : '▼' }}</span></b-btn>
          </b-card-header>
          <b-collapse id="accordionBackup" v-model="showCollapseBackup" role="tabpanel">
            <b-card-body>
              These metrics show the rates of Redo Generation and Physical Writes, which can help you plan for the amount of backup storage that may be desired.
              <div class="Chart__list">
                <div
                  class="Chart"
                  v-b-popover.hover.top="'This shows the average redo generation rate (MB/s) during each snapshot time period of these two metrics: (Redo Generated Per Sec)'"
                  title="About this chart"
                >
                  <h2>Redo Generation Rate (MB/s) over Time</h2>
                  <timechart2container
                    v-if="showCollapseBackup"
                    :collection_id="collection_id"
                    :collection_type="collection_type"
                    :user="user"
                    label="Redo Generation Rate (MB/s)"
                    chart_id="redo_mb_s"
                    reflines="false"
                    :start_date="this.start_date"
                    :end_date="this.end_date"
                    :start_date_min="this.start_date_min"
                    :end_date_max="this.end_date_max"
                    :showDateRange="true"
                  ></timechart2container>
                </div>

                <div
                  class="Chart"
                  v-b-popover.hover.top="'This shows the average write rate (MB/s) during each snapshot time period of these two metrics: (Physical Write Total IO Requests Per Sec)'"
                  title="About this chart"
                >
                  <h2>Physical Write Rate (MB/s) over Time</h2>
                  <timechart2container
                    v-if="showCollapseBackup"
                    :collection_id="collection_id"
                    :collection_type="collection_type"
                    :user="user"
                    label="Physical Write Rate (MB/s)"
                    chart_id="write_mb_s"
                    reflines="false"
                    :start_date="this.start_date"
                    :end_date="this.end_date"
                    :start_date_min="this.start_date_min"
                    :end_date_max="this.end_date_max"
                    :showDateRange="true"
                  ></timechart2container>
                </div>
              </div>

              <!--<b-form-group-->
              <!--  label="Average Change Rate to use to estimate EBS Snapshot sizes"-->
              <!--  label-cols="4">-->
              <!--  <b-form-input-->
              <!--    type="number"-->
              <!--    step="0.01"-->
              <!--    v-model="ebs.Backup"-->
              <!--    class="col-6"-->
              <!--    placeholder="Desired average rate of change in MB/s"></b-form-input>-->
              <!--</b-form-group>-->

              <b-row>
                <b-col
                  v-if="ebs.Backup>0"
                >Implied EBS hourly changes: {{(ebs.Backup*3600/1024).toFixed(2)}} GB</b-col>
                <b-col
                  v-if="ebs.Backup>0 && ebs.DiskSpace>0"
                >Implied % Change for Hourly EBS Snapshots: {{(ebs.Backup*3600/1024/ebs.DiskSpace*100).toFixed(2)}}%</b-col>
              </b-row>

              <b-form-textarea
                id="textarea3"
                v-model="comments.Backup"
                placeholder="Type your Backup comments/notes here."
                :rows="3"
                :max-rows="6"
              ></b-form-textarea>
              <b-button
                type="submit"
                v-b-tooltip.hover
                title="Save user inputs to the database"
                block
                variant="outline-success"
              >Save Page</b-button>
              <a href="#" class="card-link">Top of Page</a>
              <b-link href="/" class="card-link">Home Page</b-link>
            </b-card-body>
          </b-collapse>
        </b-card>

        <!-- Wait metrics -->
        <b-card
          no-body
          class="mb-1"
          border-variant="primary"
          header-bg-variant="primary"
          header-text-variant="white"
        >
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-btn block href="#" v-b-toggle.accordionSessions variant="info">Wait Metrics &nbsp;
              <span class="float-right">{{ !showCollapseSessions ? '▶' : '▼' }}</span></b-btn>
          </b-card-header>
          <b-collapse id="accordionSessions" v-model="showCollapseSessions" role="tabpanel">
            <b-card-body>
              This shows the top 10 wait events across all snapshots.  Each bar represents the wait time (in seconds) spent {{ this.collection_id>20830 ? 'per second ' : ''}}for that wait event during the individual snapshot time period.  Bars are displayed stacked.  Click on the legend to remove a wait event from the chart.
              <div class="Chart__list">
                <div
                  class="Chart"
                >
                  <h2>Top Waits - Wait time(seconds) per {{ this.collection_id>20830 ? 'second' : 'snapshot interval'}}</h2>
                  <timebarchartncontainer
                    v-if="showCollapseSessions"
                    :collection_id="collection_id"
                    :collection_type="collection_type"
                    :user="user"
                    label="notused"
                    chart_id="TOP_WAITS2"
                    stacked="true"
                    :start_date="this.start_date"
                    :end_date="this.end_date"
                    :start_date_min="this.start_date_min"
                    :end_date_max="this.end_date_max"
                    :showDateRange="true"
                  ></timebarchartncontainer>
                </div>
              </div>
              <b-form-textarea
                id="textareaWait"
                v-model="comments.Waits"
                placeholder="Type your Waits comments/notes here."
                :rows="3"
                :max-rows="6"
              ></b-form-textarea>
              <b-button
                type="submit"
                v-b-tooltip.hover
                title="Save user inputs to the database"
                block
                variant="outline-success"
              >Save Page</b-button>
              <a href="#" class="card-link">Top of Page</a>
              <b-link href="/" class="card-link">Home Page</b-link>
            </b-card-body>
          </b-collapse>
        </b-card>

        <!-- Exadata/RAC Metrics -->
        <b-card
          no-body
          class="mb-1"
          border-variant="primary"
          header-bg-variant="primary"
          header-text-variant="white"
        >
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-btn block href="#" v-b-toggle.accordionExa variant="info">Exadata Observations &nbsp;
              <span class="float-right">{{ !showCollapseExa ? '▶' : '▼' }}</span></b-btn>
          </b-card-header>
          
          <b-collapse id="accordionExa" v-model="showCollapseExa" role="tabpanel">
            
            <span v-if="(this.batchItems[0].Exadata!='Yes')">This does not appear to be an Exadata database<br/></span>
            <exadataobservations
              v-if="this.loaded && this.showCollapseExa && (this.batchItems[0].Exadata=='Yes') && (this.batchItems[0].additional_datapoints != undefined)"
              :param_collection_id="`${this.collection_id}`"
              :param_item="`${JSON.stringify(this.batchItems[0])}`"
              collection_type="ora_v1"
              :user="user"
            ></exadataobservations>
            
            
<!--<div v-if="(this.batchItems[0].Exadata=='Yes')&&(this.batchItems[0].SmartScanEligible==undefined)"><img v-if="(this.batchItems[0].Exadata=='Yes')&&(this.batchItems[0].SmartScanEligible==undefined)" src="@/assets/Exadata.png" height="20px" v-b-popover.hover="`This database runs on Exadata.`" title="Exadata"></img> This database runs on Exadata. </div>-->
<!--<div v-if="(this.batchItems[0].Exadata=='Yes')&&(this.batchItems[0].SmartScanEligible!=undefined)&&(this.batchItems[0].SmartScanEligible<=500)"><img v-if="(this.batchItems[0].Exadata=='Yes')&&(this.batchItems[0].SmartScanEligible!=undefined)&&(this.batchItems[0].SmartScanEligible<=500)" src="@/assets/Exadata1.png" height="20px" v-b-popover.hover="`This database runs on Exadata. ${'Smart Scan Eligible= '+this.batchItems[0].SmartScanEligible.toFixed(0)+'MB/s Storage Index Savings= '+this.batchItems[0].StorageIndexSavings.toFixed(0)+'MB/s'}  ${(this.batchItems[0].ExadataAdjustmentText==undefined) ? '' : this.batchItems[0].ExadataAdjustmentText}`" title="Exadata - Minimal SmartScan Offload"></img> Exadata - Minimal SmartScan Offload: <br/>{{'Smart Scan Eligible= '+batchItems[0].SmartScanEligible.toFixed(0)+'MB/s Storage Index Savings= '+batchItems[0].StorageIndexSavings.toFixed(0)+'MB/s'}}</div>-->
<!--<div v-if="(this.batchItems[0].Exadata=='Yes')&&(this.batchItems[0].SmartScanEligible!=undefined)&&(this.batchItems[0].SmartScanEligible>500)&&  (this.batchItems[0].SmartScanEligible<2000)"><img v-if="(this.batchItems[0].Exadata=='Yes')&&(this.batchItems[0].SmartScanEligible!=undefined)&&(this.batchItems[0].SmartScanEligible>500)&&  (this.batchItems[0].SmartScanEligible<2000)" src="@/assets/Exadata2.png" height="20px" v-b-popover.hover="`This database runs on Exadata. ${'Smart Scan Eligible= '+this.batchItems[0].SmartScanEligible.toFixed(0)+'MB/s Storage Index Savings= '+this.batchItems[0].StorageIndexSavings.toFixed(0)+'MB/s'}  ${(this.batchItems[0].ExadataAdjustmentText==undefined) ? '' : this.batchItems[0].ExadataAdjustmentText}`" title="Exadata - Moderate SmartScan Offload"></img> Exadata - Moderate SmartScan Offload: <br/>{{'Smart Scan Eligible= '+batchItems[0].SmartScanEligible.toFixed(0)+'MB/s Storage Index Savings= '+batchItems[0].StorageIndexSavings.toFixed(0)+'MB/s'}}</div>-->
<!--<div v-if="(this.batchItems[0].Exadata=='Yes')&&(this.batchItems[0].SmartScanEligible!=undefined)&&(this.batchItems[0].SmartScanEligible>2000)&&  (this.batchItems[0].SmartScanEligible<8000)"><img v-if="(this.batchItems[0].Exadata=='Yes')&&(this.batchItems[0].SmartScanEligible!=undefined)&&(this.batchItems[0].SmartScanEligible>2000)&&  (this.batchItems[0].SmartScanEligible<8000)" src="@/assets/Exadata3.png" height="20px" v-b-popover.hover="`This database runs on Exadata. ${'Smart Scan Eligible= '+this.batchItems[0].SmartScanEligible.toFixed(0)+'MB/s Storage Index Savings= '+this.batchItems[0].StorageIndexSavings.toFixed(0)+'MB/s'}  ${(this.batchItems[0].ExadataAdjustmentText==undefined) ? '' : this.batchItems[0].ExadataAdjustmentText}`" title="Exadata - Medium SmartScan Offload"></img> Exadata - Medium SmartScan Offload: <br/>{{'Smart Scan Eligible= '+batchItems[0].SmartScanEligible.toFixed(0)+'MB/s Storage Index Savings= '+batchItems[0].StorageIndexSavings.toFixed(0)+'MB/s'}}</div>-->
<!--<div v-if="(this.batchItems[0].Exadata=='Yes')&&(this.batchItems[0].SmartScanEligible!=undefined)&&(this.batchItems[0].SmartScanEligible>8000)"><img v-if="(this.batchItems[0].Exadata=='Yes')&&(this.batchItems[0].SmartScanEligible!=undefined)&&(this.batchItems[0].SmartScanEligible>8000)" src="@/assets/Exadata4.png" height="20px" v-b-popover.hover="`This database runs on Exadata. ${'Smart Scan Eligible= '+this.batchItems[0].SmartScanEligible.toFixed(0)+'MB/s Storage Index Savings= '+this.batchItems[0].StorageIndexSavings.toFixed(0)+'MB/s'}  ${(this.batchItems[0].ExadataAdjustmentText==undefined) ? '' : this.batchItems[0].ExadataAdjustmentText}`" title="Exadata - Heavy SmartScan Offload"></img> Exadata - Heavy SmartScan Offload: <br/>{{'Smart Scan Eligible= '+batchItems[0].SmartScanEligible.toFixed(0)+'MB/s Storage Index Savings= '+batchItems[0].StorageIndexSavings.toFixed(0)+'MB/s'}}</div>-->
<!--<br/>-->
<!--<div v-if="(this.batchItems[0].IOPS*1>0) && (this.batchItems[0].Throughput/this.batchItems[0].IOPS*1024 <= 30)"><img v-if="(this.batchItems[0].IOPS*1>0) && (this.batchItems[0].Throughput/this.batchItems[0].IOPS*1024 <= 30)" src="@/assets/OLTP1.png" height="20px" v-b-popover.hover="`The estimated typical IO request size is ${Math.round(this.batchItems[0].Throughput/this.batchItems[0].IOPS*1024)} KB, which makes this database appear to be supporting OLTP-style workloads.`" title="OLTP-DW Spectrum Estimation"></img>The estimated typical IO request size is {{Math.round(batchItems[0].Throughput/batchItems[0].IOPS*1024)}} KB, which makes this database appear to be supporting OLTP-style workloads</div>-->
<!--<div v-if="(this.batchItems[0].IOPS*1>0) && (this.batchItems[0].Throughput/this.batchItems[0].IOPS*1024 > 30) && (this.batchItems[0].Throughput/this.batchItems[0].IOPS*1024 <= 120)"><img v-if="(this.batchItems[0].IOPS*1>0) && (this.batchItems[0].Throughput/this.batchItems[0].IOPS*1024 > 30) && (this.batchItems[0].Throughput/this.batchItems[0].IOPS*1024 <= 120)" src="@/assets/OLTP2.png" height="20px" v-b-popover.hover="`The estimated typical IO request size is ${Math.round(this.batchItems[0].Throughput/this.batchItems[0].IOPS*1024)} KB, which makes this database appear to be supporting OLTP-style workloads with some mixed workloads.`" title="OLTP-DW Spectrum Estimation"></img>The estimated typical IO request size is {{Math.round(batchItems[0].Throughput/batchItems[0].IOPS*1024)}} KB, which makes this database appear to be supporting OLTP-style workloads with some mixed workloads.</div>-->
<!--<div v-if="(this.batchItems[0].IOPS*1>0) && (this.batchItems[0].Throughput/this.batchItems[0].IOPS*1024 > 120) && (this.batchItems[0].Throughput/this.batchItems[0].IOPS*1024 <= 400)"><img v-if="(this.batchItems[0].IOPS*1>0) && (this.batchItems[0].Throughput/this.batchItems[0].IOPS*1024 > 120) && (this.batchItems[0].Throughput/this.batchItems[0].IOPS*1024 <= 400)" src="@/assets/OLTP3.png" height="20px" v-b-popover.hover="`The estimated typical IO request size is ${Math.round(this.batchItems[0].Throughput/this.batchItems[0].IOPS*1024)} KB, which makes this database appear to be supporting mixed and/or DW workloads.`" title="OLTP-DW Spectrum Estimation"></img>The estimated typical IO request size is {{Math.round(batchItems[0].Throughput/batchItems[0].IOPS*1024)}} KB, which makes this database appear to be supporting mixed and/or DW workloads.</div>-->
<!--<div v-if="(this.batchItems[0].IOPS*1>0) && (this.batchItems[0].Throughput/this.batchItems[0].IOPS*1024 > 400)"><img v-if="(this.batchItems[0].IOPS*1>0) && (this.batchItems[0].Throughput/this.batchItems[0].IOPS*1024 > 400)" src="@/assets/OLTP4.png" height="20px" v-b-popover.hover="`The estimated typical IO request size is ${Math.round(this.batchItems[0].Throughput/this.batchItems[0].IOPS*1024)} KB, which makes this database appear to be supporting DW-style workloads.`" title="OLTP-DW Spectrum Estimation"></img>The estimated typical IO request size is {{Math.round(batchItems[0].Throughput/batchItems[0].IOPS*1024)}} KB, which makes this database appear to be supporting DW-style workloads.</div>-->
<!--           <br/>-->
<!--           <br/>-->
<!--            <b-card-body>-->
<!--              This section provides metrics about Exadata.  Smart Scan Eligible (cell physical IO bytes eligible for predicate offload) is the amount of data that needs to be potentially touched by smart scan requests.  Returned by Smart Scan (cell physical IO interconnect bytes returned by smart scan) is the actual amount of data returned by smart scan requests after storage index optimizations and cell filtering occur.  Saved by Storage Indexes (cell physical IO bytes saved by storage index) is a metric which indicates how much data processing was skipped by the storage index optimization.  Total Interconnect (cell physical IO interconnect bytes) is the amount of data sent in either direction between the database and the storage cells.  It includes read and write traffic.  HCC Bytes Uncompressed (HCC scan cell bytes decompressed) is the amount of Hybrid Columnar Compressed table data that the storage cells needed to decompress.-->
<!--              <div class="Chart__list">-->


<!--                <div-->
<!--                  class="Chart"-->
<!--                  v-b-popover.hover.top="'A large value of Smart Scan Eligible indicates storage cell processing that should be taken into account when sizing on AWS.  A large value indicates that you may want to allocate additional database server CPU in a non-Exadata configuration.  Furthermore, a large value of Smart Scan Eligible indicates that you should consider a Lift-Shift-and-Tune motion to tune top queries away from excessive full-table scans towards more index-based retrievals.'"-->
<!--                  title="About this chart"-->
<!--                >-->
<!--                  <h2>Exadata Metrics - Smartscan Usage (MB/s)</h2>-->
<!--                  <timechart2container-->
<!--                    v-if="showCollapseExa"-->
<!--                    :collection_id="collection_id"-->
<!--                    :collection_type="collection_type"-->
<!--                    :user="user"-->
<!--                    label="Smart Scan Bytes Eligible:Bytes Returned by Smart Scan"-->
<!--                    chart_id="EXADATA1"-->
<!--                    stacked="false"-->
<!--                    reflines="false"-->
<!--                  ></timechart2container>-->
<!--                </div>-->

<!--                <div-->
<!--                  class="Chart"-->
<!--                  v-b-popover.hover.top="'This chart shows you how much the total traffic between the database and the storage cells compares to the SmartScan traffic.  When the Total Interconnect is much bigger, that indicates that you are doing more than SmartScan queries.  Examples can include non-SmartScan reads, but also mirrored writes, temporary tablespace usage, and backup traffic.'"-->
<!--                  title="About this chart"-->
<!--                >-->
<!--                  <h2>Exadata Metrics - Beyond Smartscan (MB/s)</h2>-->
<!--                  <timechart2container-->
<!--                    v-if="showCollapseExa"-->
<!--                    :collection_id="collection_id"-->
<!--                    :collection_type="collection_type"-->
<!--                    :user="user"-->
<!--                    label="Total Interconnect Bytes:Bytes Returned by Smart Scan"-->
<!--                    chart_id="EXADATA2"-->
<!--                    stacked="false"-->
<!--                    reflines="false"-->
<!--                  ></timechart2container>-->
<!--                </div>-->

<!--                <div-->
<!--                  class="Chart"-->
<!--                  v-b-popover.hover.top="'This chart shows you the usage (in terms of MB/s) of Storage Indexes and Hybrid Columnar Compression.  A large value for Storage Index savings suggests that it may be relatively easy to achieve similar I/O reduction benefits off Exadata with a suitable index or partitioning scheme.  A large value of HCC usage suggests that frequently accessed tables are using HCC, so be sure to account for some growth in storage disk requirements for moving to non-Exadata.'"-->
<!--                  title="About this chart"-->
<!--                >-->
<!--                  <h2>Exadata Metrics - Other Features (MB/s)</h2>-->
<!--                  <timechart2container-->
<!--                    v-if="showCollapseExa"-->
<!--                    :collection_id="collection_id"-->
<!--                    :collection_type="collection_type"-->
<!--                    :user="user"-->
<!--                    label="Bytes Saved by Storage Index:HCC Bytes Uncompressed"-->
<!--                    chart_id="EXADATA3"-->
<!--                    stacked="false"-->
<!--                    reflines="false"-->
<!--                  ></timechart2container>-->
<!--                </div>-->

<!--                <div-->
<!--                  class="Chart"-->
<!--                  v-b-popover.hover.top="'This chart shows you the metrics (in terms of MB/s) of Total Physical Reads and Optimized Total Physical Reads.  Optimized reads are those are attributed to Storage Indexes and Smart Flash Cache.'"-->
<!--                  title="About this chart"-->
<!--                >-->
<!--                  <h2>Exadata Metrics - Physical Read and Read Optimized (MB/s)</h2>-->
<!--                  <timechart2container-->
<!--                    v-if="showCollapseExa"-->
<!--                    :collection_id="collection_id"-->
<!--                    :collection_type="collection_type"-->
<!--                    :user="user"-->
<!--                    label="physical read total bytes optimized:physical read total bytes"-->
<!--                    chart_id="EXADATA4"-->
<!--                    stacked="false"-->
<!--                    reflines="false"-->
<!--                  ></timechart2container>-->
<!--                </div>-->

<!--              </div>-->
<!--              <b-form-textarea-->
<!--                id="textareaExa"-->
<!--                v-model="comments.Exadata"-->
<!--                placeholder="Type your Exadata comments/notes here."-->
<!--                :rows="3"-->
<!--                :max-rows="6"-->
<!--              ></b-form-textarea>-->
<!--              <b-button-->
<!--                type="submit"-->
<!--                v-b-tooltip.hover-->
<!--                title="Save user inputs to the database"-->
<!--                block-->
<!--                variant="outline-success"-->
<!--              >Save Page</b-button>-->
              <a href="#" class="card-link">Top of Page</a>
              <b-link href="/" class="card-link">Home Page</b-link>
            </b-card-body>
          </b-collapse>
        </b-card>




        <!-- Adhoc Charts -->
        <b-card
          no-body
          class="mb-1"
          border-variant="primary"
          header-bg-variant="primary"
          header-text-variant="white"
        >

          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-btn block href="#" v-b-toggle.accordionAdhoc variant="info">Adhoc Charts &nbsp;
              <span class="float-right">{{ !showCollapseAdhoc ? '▶' : '▼' }}</span></b-btn>
          </b-card-header>
          
          <b-collapse id="accordionAdhoc" v-model="showCollapseAdhoc" role="tabpanel">



        <b-card
          no-body
          class="mb-1"
          border-variant="primary"
          header-bg-variant="primary"
          header-text-variant="white"
        >
          <b-card-header header-tag="header" class="p-1" role="tab">
            Chart 1
          </b-card-header>
            <b-card-body>


              <b-form-group label="Chart Type:" label-cols="3" label-size="sm" 
                v-b-tooltip.hover="'Pick one of the available chart types'">
                <b-form-select v-model="chart1_type" size="sm" @change="showchart1=false">
                  <option value="single">Single Metric</option>
                  <option value="singleRAC" v-if="this.instances>1 && (chart1_group!='SYSSTAT')">Single Metric - broken out by RAC instances</option>
                  <option value="dual">Two Metrics with a single Y axis</option>
                  <option value="dual_stacked">Two Metrics Stacked with a single Y axis</option>
                  <!--<option value="dual_y">Two Metrics with dual Y axis</option>-->
                </b-form-select>
              </b-form-group>

              <b-form-group label="Metric Group:" label-cols="3" label-size="sm" 
                v-b-tooltip.hover="'Pick one of the available metric groups'">
                <b-form-select v-model="chart1_group" size="sm" @change="changeAdhocMetricGroup1">
                  <option value="MAIN_METRICS">Main Metrics</option>
                  <option value="SYSSTAT">SYSSTAT Metrics</option>
                </b-form-select>
              </b-form-group>

              <b-form-group label="Metric1:" label-cols="3" label-size="sm" 
                v-b-tooltip.hover="'Pick one of the available metrics to use in the chart'">
                <b-form-select v-model="chart1_metric1" size="sm" @change="showchart1=false" :options="column_lov1">
                </b-form-select>

              </b-form-group>

              <b-form-group v-if="(chart1_type=='dual')||(chart1_type=='dual_stacked')" label="Metric2:" label-cols="3" label-size="sm" 
                v-b-tooltip.hover="'Pick one of the available metrics to use in the chart'">
                <b-form-select v-model="chart1_metric2" size="sm" @change="showchart1=false" :options="column_lov1">
                </b-form-select>
              </b-form-group>

              <b-form-group v-if="(chart1_type!='singleRAC') && (chart1_group!='SYSSTAT') && this.instances>1" label="RAC Instance:" label-cols="3" label-size="sm" 
                v-b-tooltip.hover="'Pick the RAC Instance to chart, or pick the entire cluster.'">
                <b-form-select v-if="this.instances>1" v-model="chart1_instances" :options="instanceChoices" size="sm" @change="showchart1=false" >
                </b-form-select>  
              </b-form-group>


              <b-form-checkbox v-if="(chart1_type=='single')" v-model="showReflineschart1" switch @change="showchart1=false" >Show Reference Lines</b-form-checkbox>

              <b-button v-if="!showchart1" v-model="showchart1" @click="showchart1 = !showchart1">Draw/Update Chart</b-button>
<br/>
                  <timechart2container
                  v-if="showchart1 && (chart1_type=='single')"
                    :collection_id="collection_id"
                    :collection_type="collection_type"
                    :user="user"
                    :label="chart1_metric1 + instanceLabel"
                    :chart_id="chart1_group + '~' + chart1_metric1"
                    colorScheme="adhoc1"
                    :reflines="this.showReflineschart1"
                    :instance_num="this.chart1_instances"
                    :start_date="this.start_date"
                    :end_date="this.end_date"
                    :start_date_min="this.start_date_min"
                    :end_date_max="this.end_date_max"
                    :showDateRange="true"
                  ></timechart2container>


                  <timechartRACcontainer
                  v-if="showchart1 && (chart1_type=='singleRAC')"
                    :collection_id="collection_id"
                    :collection_type="collection_type"
                    :user="user"
                    :label="chart1_metric1 + instanceLabel"
                    :chart_id="chart1_group + '~' + chart1_metric1"
                    colorScheme="adhoc1"
                    stacked=false
                    :num_instances="this.instances"
                    :instancenum_list="this.instancenums"
                    :start_date="this.start_date"
                    :end_date="this.end_date"
                    :start_date_min="this.start_date_min"
                    :end_date_max="this.end_date_max"
                    :showDateRange="true"
                  ></timechartRACcontainer>


                  <timechart2container 
                    v-if="showchart1 && (chart1_type=='dual')"
                    :collection_id="collection_id"
                    :collection_type="collection_type"
                    :user="user"
                    :label="chart1_metric1 + instanceLabel+':'+chart1_metric2 + instanceLabel"
                    :chart_id="chart1_group + '~' + chart1_metric1+':'+chart1_metric2"
                    stacked="false"
                    colorScheme="adhoc2"
                    reflines=false
                    :instance_num="this.chart1_instances"
                    :start_date="this.start_date"
                    :end_date="this.end_date"
                    :start_date_min="this.start_date_min"
                    :end_date_max="this.end_date_max"
                    :showDateRange="true"
                  ></timechart2container>

                  <timechart2container 
                    v-if="showchart1 && (chart1_type=='dual_stacked')"
                    :collection_id="collection_id"
                    :collection_type="collection_type"
                    :user="user"
                    :label="chart1_metric1 + instanceLabel+':'+chart1_metric2 + instanceLabel"
                    :chart_id="chart1_group + '~' + chart1_metric1+':'+chart1_metric2"
                    stacked="true"
                    colorScheme="adhoc2stacked"
                    reflines=false
                    :instance_num="this.chart1_instances"
                    :start_date="this.start_date"
                    :end_date="this.end_date"
                    :start_date_min="this.start_date_min"
                    :end_date_max="this.end_date_max"
                    :showDateRange="true"
                  ></timechart2container>

      
            </b-card-body>
          </b-card>


        <b-card
          no-body
          class="mb-1"
          border-variant="primary"
          header-bg-variant="primary"
          header-text-variant="white"
        >
          <b-card-header header-tag="header" class="p-1" role="tab">
            Chart 2
          </b-card-header>
            <b-card-body>

              <b-form-group label="Chart Type:" label-cols="3" label-size="sm" 
                v-b-tooltip.hover="'Pick one of the available chart types'">
                <b-form-select v-model="chart2_type" size="sm" @change="showchart2=false">
                  <option value="single">Single Metric</option>
                  <option value="singleRAC" v-if="this.instances>1 && (chart2_group!='SYSSTAT')">Single Metric - broken out by RAC instances</option>
                  <option value="dual">Two Metrics with a single Y axis</option>
                  <option value="dual_stacked">Two Metrics Stacked with a single Y axis</option>
                  <!--<option value="dual_y">Two Metrics with dual Y axis</option>-->
                </b-form-select>
              </b-form-group>

              <b-form-group label="Metric Group:" label-cols="3" label-size="sm" 
                v-b-tooltip.hover="'Pick one of the available metric groups'">
                <b-form-select v-model="chart2_group" size="sm" @change="changeAdhocMetricGroup2">
                  <option value="MAIN_METRICS">Main Metrics</option>
                  <option value="SYSSTAT">SYSSTAT Metrics</option>
                </b-form-select>
              </b-form-group>

              <b-form-group label="Metric1:" label-cols="3" label-size="sm" 
                v-b-tooltip.hover="'Pick one of the available metrics to use in the chart'">
                <b-form-select v-model="chart2_metric1" size="sm" @change="showchart2=false" :options="column_lov2">
                </b-form-select>

              </b-form-group>

              <b-form-group v-if="(chart2_type=='dual')||(chart2_type=='dual_stacked')" label="Metric2:" label-cols="3" label-size="sm" 
                v-b-tooltip.hover="'Pick one of the available metrics to use in the chart'">
                <b-form-select v-model="chart2_metric2" size="sm" @change="showchart2=false" :options="column_lov2">
                </b-form-select>
              </b-form-group>

              <b-form-group v-if="(chart2_type!='singleRAC') && (chart2_group!='SYSSTAT') && this.instances>1"  label="RAC Instance:" label-cols="3" label-size="sm" 
                v-b-tooltip.hover="'Pick the RAC Instance to chart, or pick the entire cluster.'">
                <b-form-select v-if="this.instances>1" v-model="chart2_instances" :options="instanceChoices" size="sm" @change="showchart2=false" >
                </b-form-select>  
              </b-form-group>


              <b-form-checkbox v-if="(chart2_type=='single')" v-model="showReflineschart2" switch @change="showchart2=false" >Show Reference Lines</b-form-checkbox>

              <b-button v-if="!showchart2" v-model="showchart2" @click="showchart2 = !showchart2">Draw/Update Chart</b-button>
<br/>
                  <timechart2container
                  v-if="showchart2 && (chart2_type=='single')"
                    :collection_id="collection_id"
                    :collection_type="collection_type"
                    :user="user"
                    :label="chart2_metric1 + instanceLabel"
                    :chart_id="chart2_group + '~' + chart2_metric1"
                    colorScheme="adhoc1"
                    :reflines="this.showReflineschart2"
                    :instance_num="this.chart2_instances"
                    :start_date="this.start_date"
                    :end_date="this.end_date"
                    :start_date_min="this.start_date_min"
                    :end_date_max="this.end_date_max"
                    :showDateRange="true"
                  ></timechart2container>


                  <timechartRACcontainer
                  v-if="showchart2 && (chart2_type=='singleRAC')"
                    :collection_id="collection_id"
                    :collection_type="collection_type"
                    :user="user"
                    :label="chart2_metric1 + instanceLabel"
                    :chart_id="chart2_group + '~' + chart2_metric1"
                    colorScheme="adhoc1"
                    stacked=false
                    :num_instances="this.instances"
                    :instancenum_list="this.instancenums"
                    :start_date="this.start_date"
                    :end_date="this.end_date"
                    :start_date_min="this.start_date_min"
                    :end_date_max="this.end_date_max"
                    :showDateRange="true"
                  ></timechartRACcontainer>


                  <timechart2container 
                    v-if="showchart2 && (chart2_type=='dual')"
                    :collection_id="collection_id"
                    :collection_type="collection_type"
                    :user="user"
                    :label="chart2_metric1 + instanceLabel+':'+chart2_metric2 + instanceLabel"
                    :chart_id="chart2_group + '~' + chart2_metric1+':'+chart2_metric2"
                    stacked="false"
                    colorScheme="adhoc2"
                    reflines=false
                    :instance_num="this.chart2_instances"
                    :start_date="this.start_date"
                    :end_date="this.end_date"
                    :start_date_min="this.start_date_min"
                    :end_date_max="this.end_date_max"
                    :showDateRange="true"
                  ></timechart2container>

                  <timechart2container 
                    v-if="showchart2 && (chart2_type=='dual_stacked')"
                    :collection_id="collection_id"
                    :collection_type="collection_type"
                    :user="user"
                    :label="chart2_metric1 + instanceLabel+':'+chart2_metric2 + instanceLabel"
                    :chart_id="chart2_group + '~' + chart2_metric1+':'+chart2_metric2"
                    stacked="true"
                    colorScheme="adhoc2stacked"
                    reflines=false
                    :instance_num="this.chart2_instances"
                    :start_date="this.start_date"
                    :end_date="this.end_date"
                    :start_date_min="this.start_date_min"
                    :end_date_max="this.end_date_max"
                    :showDateRange="true"
                  ></timechart2container>

      
            </b-card-body>
          </b-card>


        <b-card
          no-body
          class="mb-1"
          border-variant="primary"
          header-bg-variant="primary"
          header-text-variant="white"
        >
          <b-card-header header-tag="header" class="p-1" role="tab">
            Chart 3
          </b-card-header>
            <b-card-body>

              <b-form-group label="Chart Type:" label-cols="3" label-size="sm" 
                v-b-tooltip.hover="'Pick one of the available chart types'">
                <b-form-select v-model="chart3_type" size="sm" @change="showchart3=false">
                  <option value="single">Single Metric</option>
                  <option value="singleRAC" v-if="this.instances>1 && (chart3_group!='SYSSTAT')">Single Metric - broken out by RAC instances</option>
                  <option value="dual">Two Metrics with a single Y axis</option>
                  <option value="dual_stacked">Two Metrics Stacked with a single Y axis</option>
                  <!--<option value="dual_y">Two Metrics with dual Y axis</option>-->
                </b-form-select>
              </b-form-group>

              <b-form-group label="Metric Group:" label-cols="3" label-size="sm" 
                v-b-tooltip.hover="'Pick one of the available metric groups'">
                <b-form-select v-model="chart3_group" size="sm" @change="changeAdhocMetricGroup3">
                  <option value="MAIN_METRICS">Main Metrics</option>
                  <option value="SYSSTAT">SYSSTAT Metrics</option>
                </b-form-select>
              </b-form-group>

              <b-form-group label="Metric1:" label-cols="3" label-size="sm" 
                v-b-tooltip.hover="'Pick one of the available metrics to use in the chart'">
                <b-form-select v-model="chart3_metric1" size="sm" @change="showchart3=false" :options="column_lov3">
                </b-form-select>

              </b-form-group>

              <b-form-group v-if="(chart3_type=='dual')||(chart3_type=='dual_stacked')" label="Metric2:" label-cols="3" label-size="sm" 
                v-b-tooltip.hover="'Pick one of the available metrics to use in the chart'">
                <b-form-select v-model="chart3_metric2" size="sm" @change="showchart3=false" :options="column_lov3">
                </b-form-select>
              </b-form-group>

              <b-form-group v-if="(chart3_type!='singleRAC') && (chart3_group!='SYSSTAT') && this.instances>1" label="RAC Instance:" label-cols="3" label-size="sm" 
                v-b-tooltip.hover="'Pick the RAC Instance to chart, or pick the entire cluster.'">
                <b-form-select v-if="this.instances>1" v-model="chart3_instances" :options="instanceChoices" size="sm" @change="showchart3=false" >
                </b-form-select>  
              </b-form-group>


              <b-form-checkbox v-if="(chart3_type=='single')" v-model="showReflineschart3" switch @change="showchart3=false" >Show Reference Lines</b-form-checkbox>

              <b-button v-if="!showchart3" v-model="showchart3" @click="showchart3 = !showchart3">Draw/Update Chart</b-button>
<br/>
                  <timechart2container
                  v-if="showchart3 && (chart3_type=='single')"
                    :collection_id="collection_id"
                    :collection_type="collection_type"
                    :user="user"
                    :label="chart3_metric1 + instanceLabel"
                    :chart_id="chart3_group + '~' + chart3_metric1"
                    colorScheme="adhoc1"
                    :reflines="this.showReflineschart3"
                    :instance_num="this.chart3_instances"
                    :start_date="this.start_date"
                    :end_date="this.end_date"
                    :start_date_min="this.start_date_min"
                    :end_date_max="this.end_date_max"
                    :showDateRange="true"
                  ></timechart2container>


                  <timechartRACcontainer
                  v-if="showchart3 && (chart3_type=='singleRAC')"
                    :collection_id="collection_id"
                    :collection_type="collection_type"
                    :user="user"
                    :label="chart3_metric1 + instanceLabel"
                    :chart_id="chart3_group + '~' + chart3_metric1"
                    colorScheme="adhoc1"
                    stacked=false
                    :num_instances="this.instances"
                    :instancenum_list="this.instancenums"
                    :start_date="this.start_date"
                    :end_date="this.end_date"
                    :start_date_min="this.start_date_min"
                    :end_date_max="this.end_date_max"
                    :showDateRange="true"
                  ></timechartRACcontainer>


                  <timechart2container 
                    v-if="showchart3 && (chart3_type=='dual')"
                    :collection_id="collection_id"
                    :collection_type="collection_type"
                    :user="user"
                    :label="chart3_metric1 + instanceLabel+':'+chart3_metric2 + instanceLabel"
                    :chart_id="chart3_group + '~' + chart3_metric1+':'+chart3_metric2"
                    stacked="false"
                    colorScheme="adhoc2"
                    reflines=false
                    :instance_num="this.chart3_instances"
                    :start_date="this.start_date"
                    :end_date="this.end_date"
                    :start_date_min="this.start_date_min"
                    :end_date_max="this.end_date_max"
                    :showDateRange="true"
                  ></timechart2container>

                  <timechart2container 
                    v-if="showchart3 && (chart3_type=='dual_stacked')"
                    :collection_id="collection_id"
                    :collection_type="collection_type"
                    :user="user"
                    :label="chart3_metric1 + instanceLabel+':'+chart3_metric2 + instanceLabel"
                    :chart_id="chart3_group + '~' + chart3_metric1+':'+chart3_metric2"
                    stacked="true"
                    colorScheme="adhoc2stacked"
                    reflines=false
                    :instance_num="this.chart3_instances"
                    :start_date="this.start_date"
                    :end_date="this.end_date"
                    :start_date_min="this.start_date_min"
                    :end_date_max="this.end_date_max"
                    :showDateRange="true"
                  ></timechart2container>

      
            </b-card-body>
          </b-card>


        <b-card
          no-body
          class="mb-1"
          border-variant="primary"
          header-bg-variant="primary"
          header-text-variant="white"
        >
          <b-card-header header-tag="header" class="p-1" role="tab">
            Chart 4
          </b-card-header>
            <b-card-body>

              <b-form-group label="Chart Type:" label-cols="3" label-size="sm" 
                v-b-tooltip.hover="'Pick one of the available chart types'">
                <b-form-select v-model="chart4_type" size="sm" @change="showchart4=false">
                  <option value="single">Single Metric</option>
                  <option value="singleRAC" v-if="this.instances>1 && (chart4_group!='SYSSTAT')">Single Metric - broken out by RAC instances</option>
                  <option value="dual">Two Metrics with a single Y axis</option>
                  <option value="dual_stacked">Two Metrics Stacked with a single Y axis</option>
                  <!--<option value="dual_y">Two Metrics with dual Y axis</option>-->
                </b-form-select>
              </b-form-group>

              <b-form-group label="Metric Group:" label-cols="3" label-size="sm" 
                v-b-tooltip.hover="'Pick one of the available metric groups'">
                <b-form-select v-model="chart4_group" size="sm" @change="changeAdhocMetricGroup4">
                  <option value="MAIN_METRICS">Main Metrics</option>
                  <option value="SYSSTAT">SYSSTAT Metrics</option>
                </b-form-select>
              </b-form-group>

              <b-form-group label="Metric1:" label-cols="3" label-size="sm" 
                v-b-tooltip.hover="'Pick one of the available metrics to use in the chart'">
                <b-form-select v-model="chart4_metric1" size="sm" @change="showchart4=false" :options="column_lov4">
                </b-form-select>

              </b-form-group>

              <b-form-group v-if="(chart4_type=='dual')||(chart4_type=='dual_stacked')" label="Metric2:" label-cols="3" label-size="sm" 
                v-b-tooltip.hover="'Pick one of the available metrics to use in the chart'">
                <b-form-select v-model="chart4_metric2" size="sm" @change="showchart4=false" :options="column_lov4">
                </b-form-select>
              </b-form-group>

              <b-form-group v-if="(chart4_type!='singleRAC') && (chart4_group!='SYSSTAT') && this.instances>1" label="RAC Instance:" label-cols="3" label-size="sm" 
                v-b-tooltip.hover="'Pick the RAC Instance to chart, or pick the entire cluster.'">
                <b-form-select v-if="this.instances>1" v-model="chart4_instances" :options="instanceChoices" size="sm" @change="showchart4=false" >
                </b-form-select>  
              </b-form-group>


              <b-form-checkbox v-if="(chart4_type=='single')" v-model="showReflineschart4" switch @change="showchart4=false" >Show Reference Lines</b-form-checkbox>

              <b-button v-if="!showchart4" v-model="showchart4" @click="showchart4 = !showchart4">Draw/Update Chart</b-button>
<br/>
                  <timechart2container
                  v-if="showchart4 && (chart4_type=='single')"
                    :collection_id="collection_id"
                    :collection_type="collection_type"
                    :user="user"
                    :label="chart4_metric1 + instanceLabel"
                    :chart_id="chart4_group + '~' + chart4_metric1"
                    colorScheme="adhoc1"
                    :reflines="this.showReflineschart4"
                    :instance_num="this.chart4_instances"
                    :start_date="this.start_date"
                    :end_date="this.end_date"
                    :start_date_min="this.start_date_min"
                    :end_date_max="this.end_date_max"
                    :showDateRange="true"
                  ></timechart2container>


                  <timechartRACcontainer
                  v-if="showchart4 && (chart4_type=='singleRAC')"
                    :collection_id="collection_id"
                    :collection_type="collection_type"
                    :user="user"
                    :label="chart4_metric1 + instanceLabel"
                    :chart_id="chart4_group + '~' + chart4_metric1"
                    colorScheme="adhoc1"
                    stacked=false
                    :num_instances="this.instances"
                    :instancenum_list="this.instancenums"
                    :start_date="this.start_date"
                    :end_date="this.end_date"
                    :start_date_min="this.start_date_min"
                    :end_date_max="this.end_date_max"
                    :showDateRange="true"
                  ></timechartRACcontainer>


                  <timechart2container 
                    v-if="showchart4 && (chart4_type=='dual')"
                    :collection_id="collection_id"
                    :collection_type="collection_type"
                    :user="user"
                    :label="chart4_metric1 + instanceLabel+':'+chart4_metric2 + instanceLabel"
                    :chart_id="chart4_group + '~' + chart4_metric1+':'+chart4_metric2"
                    stacked="false"
                    colorScheme="adhoc2"
                    reflines=false
                    :instance_num="this.chart4_instances"
                    :start_date="this.start_date"
                    :end_date="this.end_date"
                    :start_date_min="this.start_date_min"
                    :end_date_max="this.end_date_max"
                    :showDateRange="true"
                  ></timechart2container>

                  <timechart2container 
                    v-if="showchart4 && (chart4_type=='dual_stacked')"
                    :collection_id="collection_id"
                    :collection_type="collection_type"
                    :user="user"
                    :label="chart4_metric1 + instanceLabel+':'+chart4_metric2 + instanceLabel"
                    :chart_id="chart4_group + '~' + chart4_metric1+':'+chart4_metric2"
                    stacked="true"
                    colorScheme="adhoc2stacked"
                    reflines=false
                    :instance_num="this.chart4_instances"
                    :start_date="this.start_date"
                    :end_date="this.end_date"
                    :start_date_min="this.start_date_min"
                    :end_date_max="this.end_date_max"
                    :showDateRange="true"
                  ></timechart2container>

      
            </b-card-body>
          </b-card>



          </b-collapse>
        </b-card>




        <!-- Custom Date Range for Chart -->
        <b-card
          no-body
          class="mb-1"
          border-variant="primary"
          header-bg-variant="primary"
          header-text-variant="white"
        >
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-btn block href="#" variant="info">Custom Date Range for Charts</b-btn>
          </b-card-header>

          <a name="daterange"></a>
          <div>
            <b-card >
          <b-card-text>
          <p style="font-size:14px">You can use the following controls if you want to narrow down the date range shown in the various charts on this page.
          <br/><br/>
           Note: The custom date range you specify below only affects the data shown in the charts.  The auto sizing suggestion algorithms will continue to use the full date range when calculating target values.  But you can use the custom date range with charts as a tool to help when you manually pick your own target values.</p>
          </b-card-text>
          <b-container class="bv-example-row">
            <b-row>
              <b-col>
                Chart Start Date
              </b-col><b-col>
                Chart End Date
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-datepicker id="start-datepicker" v-model="start_date" :min="start_date_min" :max="end_date_max" class="mb-2" size="sm" @input="changeAdhocMetricGroupAll"></b-form-datepicker>
              </b-col><b-col>
                <b-form-datepicker id="end-datepicker" v-model="end_date" :min="start_date_min" :max="end_date_max" class="mb-2" size="sm" @input="changeAdhocMetricGroupAll"></b-form-datepicker>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-button @click="start_date = start_date_min; end_date = end_date_max; changeAdhocMetricGroupAll('x')" size="sm" >Reset Dates</b-button>
              </b-col>  
            </b-row>
            
          </b-container>
            
          </b-card>  
            </div>

        </b-card>





        <!-- Mapping to AWS Section -->
        <b-card
          no-body
          class="mb-1"
          border-variant="warning"
          header-bg-variant="warning"
          header-text-variant="white"
        >
          <b-card-header border-variant="warning" header-tag="header" class="p-1" role="tab">
            <b-btn
              block
              href="#"
              v-b-toggle.accordionMap
              variant="warning"
            >Mapping to AWS (experimental) &nbsp;
              <span class="float-right">{{ !showCollapseMap ? '▶' : '▼' }}</span></b-btn>
          </b-card-header>

          <b-collapse id="accordionMap" v-model="showCollapseMap" role="tabpanel" >
            We now recommend you use the Auto-Right-Sizer for sizing.  The sizing tools on this page are not being updated with new logic or features.<br/>
            <router-link :to="{ name: 'Batch', params: {batch_id: this.shareMode ? this.param_collection_id : ('C' + this.collection_id) } }">Go to the Auto-Right-Sizer for this database</router-link>
            <br/><br/>
            <b-form-checkbox v-model="showSizing" switch>Continue to use older sizing tools on this page anyways.</b-form-checkbox>
            <b-card-body v-if="showSizing">
              <!-- The Overview of AWS Mapping -->
              <b-card
                no-body
                class="mb-1"
                border-variant="warning"
                header-bg-variant="warning"
                header-text-variant="white"
              >
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-btn
                    block
                    href="#"
                    v-b-toggle.accordionMapOverview
                    variant="warning"
                  >Mapping to AWS Overview &nbsp;
              <span class="float-right">{{ !showCollapseMapOverview ? '▶' : '▼' }}</span></b-btn>
                </b-card-header>

                <b-collapse
                  id="accordionMapOverview"
                  v-model="showCollapseMapOverview"
                  role="tabpanel"
                >
                  <b-card-body>
                    This section provides an experimental tool to help map your desired vCPU, Memory, and IO Throughput to an AWS shape.
                    <br>
                    <br>The sizing should be considered to be a starting-point, not an exact final configuration. As you implement your database on AWS, you can measure the performance and make adjustments easily to fine-tune the performance to the desired cost/performance combination.
                    <br>
                    <br>There are 3 basic approaches that this tool tries to help you estimate:
                    <b>Re-host</b> to Oracle DB on EC2,
                    <b>Re-platform</b> to RDS-Oracle, or
                    <b>Re-architect</b> to Aurora.
                    <br>
                    <img src="@/assets/oracleOptions.png" height="400px">
                    <br>
                    <br>
                    <img src="@/assets/oracleTimeline.png" height="400px">
                    <br>
                  </b-card-body>
                </b-collapse>
              </b-card>

              <!-- The EC2 Mapping section -->
              <b-card
                no-body
                class="mb-1"
                border-variant="warning"
                header-bg-variant="warning"
                header-text-variant="white"
              >
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-btn
                    block
                    href="#"
                    v-b-toggle.accordionEC2
                    variant="warning"
                  >Re-host to EC2 and EBS Storage Mapping Tool (experimental) &nbsp;
              <span class="float-right">{{ !showCollapseEC2 ? '▶' : '▼' }}</span></b-btn>
                </b-card-header>

                <b-collapse id="accordionEC2" v-model="showCollapseEC2" role="tabpanel">
                  <b-card-body>
                    This section provides an experimental tool to help map your desired vCPU, Memory, and IO Throughput to an EC2 shape and accompanying EBS storage.
                    <br>
                    <br>
                    <div>
                      <b-card title="AWS Mapping to EC2 Summary" bg-variant="warning">
                        <div v-if="selected.length==0">
                          <b-row>
                            <b-col>
                              <b>INSTRUCTIONS:</b> Confirm/adjust the performance requirement inputs, and choose an EC2 shape from the candidate EC2 shape list below...
                            </b-col>
                          </b-row>
                        </div>
                        <div v-if="selected.length>0">
                          <b-row>
                            <b-col>
                              EC2 Shape: {{targetconfig_ec2.shape}}
                              <br>
                              {{targetconfig_ec2.shape_summaryText}}
                            </b-col>
                          </b-row>
                          <br>

                          <b-row>
                            <b-col>
                              {{targetconfig_ec2.ebs_data_summaryText1}}
                              <br>
                              {{targetconfig_ec2.ebs_data_summaryText2}}
                            </b-col>
                          </b-row>
                          <br>
                          <!--<b-row>-->
                          <!--  <b-col>-->
                          <!--    {{targetconfig_ec2.ebs_backup_summaryText1}}-->
                          <!--    <br>-->
                          <!--    {{targetconfig_ec2.ebs_backup_summaryText2}}-->
                          <!--  </b-col>-->
                          <!--</b-row>-->
                          <!--<br>-->
                      

                          <b-row>
                            <b-col>
                              <b>License: {{targetconfig_ec2.license_summaryText}}</b>
                              <br/>
                            </b-col>
                          </b-row>
                          <br>


                          <b-row>
                            <b-col>
                              <b>Summary Estimate: {{targetconfig_ec2.summaryText}}</b>
                              <br>
                            </b-col>
                          </b-row>
                          <b-row v-if="targetconfig_ec2.iops_warnings!=''">
                            <b-col>
                              <br/>
                              <b-card bg-variant="info" text-variant="white" header="IOPS Info" class="text-center">
                              <b-card-text>
                              {{targetconfig_ec2.iops_warnings}}
                              </b-card-text>
                              </b-card>
                            </b-col>
                          </b-row>
                          <b-row v-if="targetconfig_ec2.iomb_warnings!=''">
                            <b-col>
                              <br/>
                              <b-card bg-variant="info" text-variant="white" header="IO Throughput Info" class="text-center">
                              <b-card-text>
                              {{targetconfig_ec2.iomb_warnings}}
                              </b-card-text>
                              </b-card>
                            </b-col>
                          </b-row>
                          <b-row v-if="targetconfig_ec2.cpu_warnings!=''">
                            <b-col>
                              <br/>
                              <b-card bg-variant="danger" text-variant="white" header="Warning" class="text-center">
                              <b-card-text>
                              {{targetconfig_ec2.cpu_warnings}}
                              </b-card-text>
                              </b-card>
                            </b-col>
                          </b-row>
                          <br/>
                          <b-button
                            type="submit"
                            v-b-tooltip.hover
                            title="Save user inputs to the database"
                            block
                            variant="success"
                          >Save Page</b-button>

                          <br>
                        </div>
                      </b-card>
                      <br>
                      <br>

                      <b-card header="Performance Requirement Inputs">
                        <b-form-group label="VPCUs" label-cols="4" label-size="sm" >
                          <b-form-input
                            type="number"
                            v-model="ec2.VCPU"
                            class="col-6"
                            size="sm"
                            placeholder="Type to Search"
                          ></b-form-input>
                        </b-form-group>
                        <b-form-group label="Memory (GB)" label-cols="4" label-size="sm">
                          <b-form-input
                            type="number"
                            v-model="ec2.Memory"
                            class="col-6"
                            size="sm"
                            placeholder="Type to Search"
                          ></b-form-input>
                        </b-form-group>
                        <b-form-group label="Throughput (MB/s)" label-cols="4" label-size="sm">
                          <b-form-input
                            type="number"
                            v-model="ec2.Throughput"
                            class="col-6"
                            size="sm"
                            placeholder="Type to Search"
                          ></b-form-input>
                        </b-form-group>
                        <b-form-group label="IOPS" label-cols="4" label-size="sm">
                          <b-form-input
                            type="number"
                            v-model="ebs.IOPS"
                            class="col-6"
                            size="sm"
                            placeholder="Enter desired IOPS"
                          ></b-form-input>
                        </b-form-group>
                        <b-form-group label="Disk Space (GB)" label-cols="4" label-size="sm">
                          <b-form-input
                            type="number"
                            v-model="ebs.DiskSpace"
                            class="col-6"
                            size="sm"
                            placeholder="Enter size of database"
                          ></b-form-input>
                        </b-form-group>

                        <b-form-group
                          label="Volume Type of EBS Storage"
                          label-cols="4"
                          label-size="sm"
                        >
                          <b-form-select v-model="ebs.VolumeType" size="sm">
                            <option value disabled>Please select an option</option>
                            <option value="gp2">General Purpose SSD (gp2)</option>
                            <option value="gp3">General Purpose SSD (gp3)</option>
                            <option value="io1">Provisioned IOPS SSD (io1)</option>
                            <option value="io2">Provisioned IOPS SSD (io2)</option>
                          </b-form-select>
                        </b-form-group>

                        <!--<b-form-group-->
                        <!--  label="Backup Approach to estimate"-->
                        <!--  label-cols="4"-->
                        <!--  label-size="sm">-->
                        <!--  <b-form-select v-model="ebs.BackupType" size="sm">-->
                        <!--    <option value disabled>Please select an option</option>-->
                        <!--    <option value="none">Do not model a backup approach</option>-->
                        <!--    <option value="datasnap">EBS Snapshots of the DATA volumes</option>-->
                        <!--    <option value="fra">EBS-based Flash Recovery Area</option>-->
                        <!--    <option-->
                        <!--      value="frasnap">EBS-based Flash Recovery Area with Snapshots of FRA</option>-->
                        <!--  </b-form-select>-->
                        <!--</b-form-group>-->

                        <!--<b-form-group-->
                        <!--  label="Average Change Rate (MB/s)"-->
                        <!--  label-cols="4"-->
                        <!--  label-size="sm"-->
                        <!--  v-if="ebs.BackupType=='datasnap' || ebs.BackupType=='frasnap'">-->
                        <!--  <b-form-input-->
                        <!--    type="number"-->
                        <!--    step="0.01"-->
                        <!--    v-model="ebs.Backup"-->
                        <!--    class="col-6"-->
                        <!--    size="sm"-->
                        <!--    placeholder="Enter desired change rate"></b-form-input>-->
                        <!--</b-form-group>-->
                        <!--<b-form-group-->
                        <!--  label="Snapshot Retention Days"-->
                        <!--  label-cols="4"-->
                        <!--  label-size="sm"-->
                        <!--  v-if="ebs.BackupType=='datasnap' || ebs.BackupType=='frasnap'">-->
                        <!--  <b-form-input-->
                        <!--    type="number"-->
                        <!--    step="0.01"-->
                        <!--    v-model="ebs.SnapshotDays"-->
                        <!--    class="col-6"-->
                        <!--    size="sm"-->
                        <!--    placeholder="Days to retain incremental snapshots"></b-form-input>-->
                        <!--</b-form-group>-->

                        <b-form-group v-if="showOptCPU" label="Optimize CPU Preference" label-cols="4" label-size="sm" 
                          v-b-tooltip.hover="'You can use this control to tell DBCSI your preference for the Optimize CPU capability of EC2'">
                          <b-form-select v-model="form.optgoal_algo" size="sm" @change="showCalculateMessage">
                            <option value="Y">Use Optimize CPU</option>
                            <option value="min_cost">Ignore Optimize CPU</option>
                            <!--<option value="min_license">Ignore Optimize CPU and pick RDS shape to minimize VCPU (even if shape costs more)</option>-->
                          </b-form-select>
                        </b-form-group>
              <b-form-group label="AWS Pricing Preference:" label-cols="4" label-size="sm" 
                v-b-tooltip.hover="'You can use this control to tell DBCSI your preference for pricing AWS compute instances'">
                <b-form-select v-model="form.useRI_algo" size="sm" @change="showCalculateMessage">
                  <option value="RI">Use 1yr No-Upfront Reserved Instance pricing if available</option>
                  <option value="OD">Use On-Demand pricing</option>
                </b-form-select>
              </b-form-group>

                        <b-form-group label="Use High-Availability (2-node Data Guard)" label-cols="4" label-size="sm" 
                          v-b-tooltip.hover="'You can use this control to tell DBCSI your preference for a self-managed 2-node HA equivalent to RDS MultiAZ'">
                          <b-form-select v-model="UseMAZ" size="sm">
                            <option value="No">No</option>
                            <option value="Yes">Yes</option>
                          </b-form-select>
                        </b-form-group>

              <b-form-group label="AWS Region for Pricing:" label-cols="4" label-size="sm">

                <b-form-select v-model="regionCode" size="sm" @change="changeRegion" :options="region_lov"/>
              </b-form-group>



                        <b-form-textarea
                          id="textarea10"
                          v-model="comments.EC2"
                          placeholder="Type your EC2/EBS configuration comments/notes here."
                          :rows="3"
                          size="sm"
                          :max-rows="6"
                        ></b-form-textarea>

                        <br>
                        <b-card header="Candidate EC2 Shape List">
                          Click on your desired EC2 shape to select it. The list of candidate EC2 shapes is filtered based on your performance requirement inputs and ordered by default by increasing cost.
                          <br>
                          <br>

                          <!-- https://bootstrap-vue.js.org/docs/components/table/ -->

                          <b-table
                            :per-page="perPage"
                            :current-page="currentPage"
                            selectable
                            responsive
                            select-mode="single"
                            selectedVariant="success"
                            hover
                            :items="filtered"
                            :fields="fields"
                            :sort-by.sync="sortBy"
                            @row-selected="rowSelected"
                          >
                            <template v-slot:cell(show_details)="row">
                              <b-button
                                size="sm"
                                @click="row.toggleDetails"
                                class="mr-2"
                              >{{ row.detailsShowing ? 'Hide' : 'Show'}} Details</b-button>
                            </template>
                            <template v-slot:row-details="row">
                              <b-card>
                                <b-row class="mb-2">
                                  <b-col sm="3" class="text-sm-right">
                                    <b>Name:</b>
                                  </b-col>
                                  <b-col>{{ row.item.Name }}</b-col>
                                </b-row>
                                <b-row class="mb-2">
                                  <b-col sm="3" class="text-sm-right">
                                    <b>vCPUs:</b>
                                  </b-col>
                                  <b-col>{{ row.item.vCPU_Details }}</b-col>
                                </b-row>
                                <b-row class="mb-2" v-b-tooltip.hover title="Optimize vCPUs (assuming hyperthreading)">
                                  <b-col sm="3" class="text-sm-right">
                                    <b>Optimize vCPU choices:</b>
                                  </b-col>
                                  <b-col>{{ row.item.OptimizeVCPUs }}</b-col>
                                </b-row>
                                <b-row class="mb-2">
                                  <b-col sm="3" class="text-sm-right">
                                    <b>Processor:</b>
                                  </b-col>
                                  <b-col>{{ row.item.Processor }}</b-col>
                                </b-row>

                                <b-row class="mb-2">
                                  <b-col sm="3" class="text-sm-right">
                                    <b>Clockspeed:</b>
                                  </b-col>
                                  <b-col>{{ row.item.Clockspeed }}</b-col>
                                </b-row>
                                <b-row class="mb-2">
                                  <b-col sm="3" class="text-sm-right">
                                    <b>Instance Storage:</b>
                                  </b-col>
                                  <b-col>{{ row.item.InstanceStorage }}</b-col>
                                </b-row>
                                <b-row class="mb-2" >
                                  <b-col sm="3" class="text-sm-right">
                                    <b>Max IO Throughput:</b>
                                  </b-col>
                                  <b-col>{{ row.item.Throughput }}</b-col>
                                </b-row>
                                <b-row class="mb-2" v-if="row.item.BaselineThroughput>0" v-b-tooltip.hover title="This instance size uses EBS bursting">
                                  <b-col sm="3" class="text-sm-right">
                                    <b>Baseline IO Throughput:</b>
                                  </b-col>
                                  <b-col>{{ row.item.BaselineThroughput }}</b-col>
                                </b-row>
                                <b-row class="mb-2">
                                  <b-col sm="3" class="text-sm-right">
                                    <b>Network Throughput (in megabits/sec):</b>
                                  </b-col>
                                  <b-col>{{ row.item.Network }}</b-col>
                                </b-row>
                                <b-row class="mb-2">
                                  <b-col sm="3" class="text-sm-right">
                                    <b>Network Throughput - Baseline (in megabits/sec):</b>
                                  </b-col>
                                  <b-col>{{ row.item.BaselineNetwork}}</b-col>
                                </b-row>

                                <!-- <b-button size="sm" @click="row.toggleDetails">Hide Details</b-button> -->
                              </b-card>
                            </template>
                          </b-table>
                          <b-pagination
                            :total-rows="filtered.length"
                            :per-page="perPage"
                            v-model="currentPage"
                            class="my-0"
                          />

                          <b-row>
                            <b-col class="mt-3 text-left">
                              <br/>
                              <span v-for="(list, index) in disclaimers_ec2" :key="list">
                                <span>{{ list }}</span><br/>
                              </span>
                              <br>
                            </b-col>
                          </b-row>

                        </b-card>
                      </b-card>
                      <br>
                    </div>
                    <a href="#" class="card-link">Top of Page</a>
                    <b-link href="/" class="card-link">Home Page</b-link>
                  </b-card-body>
                </b-collapse>
              </b-card>

              <!-- end of rehost to ec2 mapping section -->

<!-- The EC2FSXN Mapping section -->
<b-card
  no-body
  class="mb-1"
  border-variant="warning"
  header-bg-variant="warning"
  header-text-variant="white"
>
  <b-card-header header-tag="header" class="p-1" role="tab">
    <b-btn
      block
      href="#"
      v-b-toggle.accordionEC2FSXN
      variant="warning"
    >Re-host to EC2 and FSx-OnTap Mapping Tool (experimental) &nbsp;
              <span class="float-right">{{ !showCollapseEC2FSXN ? '▶' : '▼' }}</span></b-btn>
  </b-card-header>

  <b-collapse id="accordionEC2FSXN" v-model="showCollapseEC2FSXN" role="tabpanel">
    <b-card-body>
      This section provides an experimental tool to help map your desired vCPU, Memory, and IO Throughput to an EC2 shape and accompanying FSx-OnTap storage.
      <br>
      <br>
      <b-form-group label="EC2 Shape Scope?:" label-cols="3" label-size="sm"
        v-b-popover.hover.top="'This tells DBCSI which EC2 shapes to consider. EC2 Bare Metal only, or any EC2 shape (regular or Bare Metal). Regular EC2 requires Bring-Your-Own-License Oracle and is vCPU-licensed (2 vCPU = 1 Oracle processor license with hyperthreading; 1 vCPU = 1 Oracle processor license for shapes without hyperthreading, such as m7a, r7a and r8a). Graviton (ARM) shapes are never considered because Oracle DB is not supported on Graviton.'">
        <b-form-select v-model="form.ec2fsxn_shape_scope" size="sm">
          <option value="baremetal">EC2 Bare Metal shapes only</option>
          <option value="all">Any EC2 shape (regular or Bare Metal)</option>
        </b-form-select>
      </b-form-group>
      <b-form-group label="FSx-OnTap Generation?:" label-cols="3" label-size="sm"
        v-b-popover.hover.top="'This tells DBCSI which generation of FSx-OnTap file system to size and price. Gen1 (Single-AZ 1 / Multi-AZ 1) uses one HA pair with 128 - 4096 MB/s of throughput capacity and is typically less expensive. Gen2 (Single-AZ 2 / Multi-AZ 2) offers 384 - 6144 MB/s and up to 200,000 SSD IOPS per HA pair, much higher burst rates on its smaller sizes, and Single-AZ 2 can scale out to 12 HA pairs; it costs more per MB/s and is not available in every region. Auto prices both and uses the less expensive one.'">
        <b-form-select v-model="form.ec2fsxn_fsxn_generation" size="sm">
          <option value="Gen1">Gen1 - first-generation FSx-OnTap (typically less expensive)</option>
          <option value="Gen2">Gen2 - second-generation FSx-OnTap (higher per-HA-pair limits and bursts; Single-AZ scale-out)</option>
          <option value="auto">Auto - price both Gen1 and Gen2 and use the less expensive one</option>
        </b-form-select>
      </b-form-group>
      <b-form-group label="FSx-OnTap Maximum File Systems?:" label-cols="3" label-size="sm"
        v-b-popover.hover.top="'This tells DBCSI the most FSx-OnTap file systems it may use to lower cost. DBCSI first finds the fewest file systems that meet your targets, then uses more (up to this limit) only when that saves at least 20% per month, e.g. 2 x 2048 MB/s instead of 1 x 4096 MB/s (which requires 160,000 provisioned SSD IOPS). Multiple file systems mean striping the database (e.g. Oracle ASM) across them, and snapshots/replication are per file system. Gen2 Single-AZ scales out with HA pairs inside one file system instead. DBCSI still uses more file systems than this limit if fewer cannot meet your targets.'">
        <b-form-select v-model="form.ec2fsxn_fsxn_max_filesystems" size="sm">
          <option value="1">1 - only use more file systems when one cannot meet the targets</option>
          <option value="2">Up to 2 file systems</option>
          <option value="4">Up to 4 file systems</option>
          <option value="8">Up to 8 file systems</option>
        </b-form-select>
      </b-form-group>
      <b-form-group label="Bursting IO Preference:" label-cols="3" label-size="sm"
        v-b-popover.hover.top="'This tells DBCSI if you want to consider bursting IO characteristics (the EC2 network bandwidth and the FSx-OnTap throughput tier) as a way to meet IO target values. Burst rates only last for short periods, so DBCSI only relies on FSx-OnTap bursting for targets up to 2x the baseline.'">
        <b-form-select v-model="form.bursting_algo" size="sm">
          <option value="Y">Consider burstable IO performance for EC2 network and FSx-OnTap storage</option>
          <option value="N">Evaluate EC2 network and FSx-OnTap storage only on their baseline IO performance</option>
        </b-form-select>
      </b-form-group>
      <br>
      <div>
        <b-card title="AWS Mapping to EC2 + FSxN Summary" bg-variant="warning">
          <div v-if="ec2fsxnSelected.length==0">
            <b-row>
              <b-col>
                <b>INSTRUCTIONS:</b> Confirm/adjust the performance requirement inputs, and choose an EC2 Bare Metal shape from the candidate shape list below...
              </b-col>
            </b-row>
          </div>
          <div v-if="ec2fsxnSelected.length>0">
            <b-row>
              <b-col>
                EC2 Shape: {{targetconfig_ec2fsxn.shape}}
                <br>
                {{targetconfig_ec2fsxn.shape_summaryText}}
              </b-col>
            </b-row>
            <br>

            <b-row>
              <b-col>
                {{targetconfig_ec2fsxn.fsxn_data_summaryText1}}
                <br>
                {{targetconfig_ec2fsxn.fsxn_warnings}}
              </b-col>
            </b-row>
            <b-row v-if="targetconfig_ec2fsxn.iomb_warnings_burst || targetconfig_ec2fsxn.iops_warnings_burst">
              <b-col>
                <img src="@/assets/burst.png" height="20px" title="Bursting">
                {{targetconfig_ec2fsxn.iomb_warnings_burst}} {{targetconfig_ec2fsxn.iops_warnings_burst}}
              </b-col>
            </b-row>
            <br>
            <!--<b-row>-->
            <!--  <b-col>-->
            <!--    {{targetconfig_ec2fsxn.ebs_backup_summaryText1}}-->
            <!--    <br>-->
            <!--    {{targetconfig_ec2fsxn.ebs_backup_summaryText2}}-->
            <!--  </b-col>-->
            <!--</b-row>-->
            <!--<br>-->
        

            <b-row>
              <b-col>
                <span v-if="targetconfig_ec2fsxn.shapeIsMetal">Cores: {{targetconfig_ec2fsxn.shape_cores_needed}} Suggested, {{targetconfig_ec2fsxn.shape_cores_available}} per {{targetconfig_ec2fsxn.shape}} Bare Metal Instance</span>
                <span v-else>VCPU: {{targetconfig_ec2fsxn.shape_max_vcpu}} per {{targetconfig_ec2fsxn.shape}} Instance</span>
                <br/>
                Processor: {{targetconfig_ec2fsxn.Processor}}
                <br/>
              </b-col>
            </b-row>
            <br>


            <b-row>
              <b-col>
                <b>Summary Estimate: {{targetconfig_ec2fsxn.summaryText}}</b>
                <br>
              </b-col>
            </b-row>
            
            <br/>
            

            <br>
          </div>
        </b-card>
        <br>
        <br>

        <b-card header="Performance Requirement Inputs">
          <b-form-group label="VPCUs" label-cols="4" label-size="sm" >
            <b-form-input
              type="number"
              v-model="ec2.VCPU"
              class="col-6"
              size="sm"
              placeholder="Type to Search"
            ></b-form-input>
          </b-form-group>
          <b-form-group label="Memory (GB)" label-cols="4" label-size="sm">
            <b-form-input
              type="number"
              v-model="ec2.Memory"
              class="col-6"
              size="sm"
              placeholder="Type to Search"
            ></b-form-input>
          </b-form-group>
          <b-form-group label="Throughput (MB/s)" label-cols="4" label-size="sm">
            <b-form-input
              type="number"
              v-model="ec2.Throughput"
              class="col-6"
              size="sm"
              placeholder="Type to Search"
            ></b-form-input>
          </b-form-group>
          <b-form-group label="IOPS" label-cols="4" label-size="sm">
            <b-form-input
              type="number"
              v-model="ebs.IOPS"
              class="col-6"
              size="sm"
              placeholder="Enter desired IOPS"
            ></b-form-input>
          </b-form-group>
          <b-form-group label="Disk Space (GB)" label-cols="4" label-size="sm">
            <b-form-input
              type="number"
              v-model="ebs.DiskSpace"
              class="col-6"
              size="sm"
              placeholder="Enter size of database"
            ></b-form-input>
          </b-form-group>

             
<b-form-group label="Configure for MultiAZ (FSx-OnTap)?:" label-cols="4" label-size="sm" 
            v-b-tooltip.hover="'This tells DBCSI if you want to configure the FSx-OnTap storage for MultiAZ'">
            <b-form-select v-model="UseMAZ" size="sm">
              <option value="No">No</option>
              <option value="Yes">Yes</option>
            </b-form-select>
          </b-form-group>              
              
              
              <b-form-group v-if="this.UseMAZ=='Yes'" label-cols="4" label-size="sm" 
                v-b-popover.hover="'This tells DBCSI how to estimate MultiAZ for the EC2 instance.  Given that FSx-OnTap\'s MultiAZ File System storage replication does not require you to run an EC2 instance in the secondary AZ, some customers with longer RTO requirements choose to not continually run an EC2 instance in the secondary AZ.'">
                <template slot="label">
                  EC2 Bare Metal MultiAZ Style?:
                </template>
                <b-form-select v-model="form.ec2fsxn_baremetal_HA" size="sm" >
                  <option value="single">Frugal (Longer RTO) - Only include an EC2 Bare Metal instance in the primary AZ</option>
                  <option value="Y">Shorter RTO - Include EC2 Bare Metal instance in both AZs</option>
                </b-form-select>
              </b-form-group>
          
<b-form-group label="AWS Pricing Preference:" label-cols="4" label-size="sm" 
  v-b-tooltip.hover="'You can use this control to tell DBCSI your preference for pricing AWS compute instances'">
  <b-form-select v-model="form.useRI_algo" size="sm" @change="showCalculateMessage">
    <option value="RI">Use 1yr No-Upfront Reserved Instance pricing if available</option>
    <option value="OD">Use On-Demand pricing</option>
  </b-form-select>
</b-form-group>

          

<b-form-group label="AWS Region for Pricing:" label-cols="4" label-size="sm">

  <b-form-select v-model="regionCode" size="sm" @change="changeRegion" :options="region_lov"/>
</b-form-group>



          
          <br>
          <b-card header="Candidate EC2 Shape List">
            Click on your desired EC2 shape to select it. The list of candidate shapes is filtered based on your performance requirement inputs and ordered by default by increasing cost.
            <br>
            <br>

            <!-- https://bootstrap-vue.js.org/docs/components/table/ -->

            <b-table
              :per-page="perPage"
              :current-page="currentPage"
              selectable
              responsive
              select-mode="single"
              selectedVariant="success"
              hover
              :items="ec2fsxnfiltered"
              :fields="ec2fsxnfields"
              :sort-by.sync="sortBy"
              @row-selected="ec2fsxnRowSelected"
            >
              <template v-slot:cell(Network)="row">
                {{ row.item.Network/8}}
              </template>

                  <template #cell(VCPU)="row">
                    <div v-b-popover.hover="`${row.item.Clockspeed} ${row.item.Processor}`" title="Processor">{{ row.item.VCPU }}</div>
                    
                    
                    
                  </template>
                  
                  <template #cell(OracleCoreFactor)="row">
                    <span style="font-size:12px" v-if="(row.item.OracleCoreFactor*1<1) && (row.item.OracleCoreFactorConfidence=='yes')" 
                      v-b-popover.hover="{title:`Core Factor Friendly?`, content:`Your customers should review <a href='https://www.oracle.com/assets/processor-core-factor-table-070634.pdf' target='_blank'>https://www.oracle.com/assets/processor-core-factor-table-070634.pdf</a> and decide if the ${row.item.Processor} CPU matches ${row.item.OracleCoreFactorString? 'what the document lists as: ' + row.item.OracleCoreFactorString : 'the CPUs listed in the document.'}`, html: true}"
                      >CFF (0.5)</span>
                    <span style="font-size:12px" v-if=" (row.item.OracleCoreFactor*1<1) && (row.item.OracleCoreFactorConfidence=='maybe')" 
                      v-b-popover.hover="{title:`Core Factor Friendly????`, content:`Your customer should review <a href='https://www.oracle.com/assets/processor-core-factor-table-070634.pdf' target='_blank'>https://www.oracle.com/assets/processor-core-factor-table-070634.pdf</a> and decide if the ${row.item.Processor} CPU matches ${row.item.OracleCoreFactorString? 'what the document lists as: ' + row.item.OracleCoreFactorString : 'the CPUs listed in the document.'}`, html: true}"
                      >CFF (0.5)??</span>  
                    <span style="font-size:12px" v-if=" (row.item.OracleCoreFactor*1==1) " 
                      v-b-popover.hover="{title:`Not Core Factor Friendly?`, content:`Your customer should review <a href='https://www.oracle.com/assets/processor-core-factor-table-070634.pdf' target='_blank'>https://www.oracle.com/assets/processor-core-factor-table-070634.pdf</a> and decide if the ${row.item.Processor} CPU does or does not match ${row.item.OracleCoreFactorString? 'what the document lists as: ' + row.item.OracleCoreFactorString : 'the CPUs listed in the document.'}`, html: true}"
                      >(1.0)??</span>  
                  </template>
              
                  <template #cell(Geekbench5CoreScoreRounded)="row">
                    <span v-if=" (row.item.Geekbench5CoreScoreRounded)" 
                      v-b-popover.hover="{title:`Geekbench v5 Single Core Performance`, content:`This is the <a href='https://browser.geekbench.com/search?k=v5_cpu&utf8=%E2%9C%93&q=ec2+metal' target='_blank'>Single Core CPU Performance benchmark (v5) from Geekbench</a>.  Higher values are better.  In some cases, the score has been harmonized to give different shapes using the same CPU (such as x2iezn and m5zn) the same exact value to make shape selection work better.  You can click on the score to see the actual benchmark report that was the original source of data.`, html: true}"
                      ><a :href=row.item.Geekbench5URL target="_blank">{{ row.item.Geekbench5CoreScoreRounded }}</a></span>    
                  </template>
                  
              <template v-slot:cell(show_details)="row">
                <b-button
                  size="sm"
                  @click="row.toggleDetails"
                  class="mr-2"
                >{{ row.detailsShowing ? 'Hide' : 'Show'}} Details</b-button>
              </template>
              <template v-slot:row-details="row">
                <b-card>
                  <b-row class="mb-2">
                    <b-col sm="3" class="text-sm-right">
                      <b>Name:</b>
                    </b-col>
                    <b-col>{{ row.item.Name }}</b-col>
                  </b-row>
                  <b-row class="mb-2">
                    <b-col sm="3" class="text-sm-right">
                      <b>vCPUs:</b>
                    </b-col>
                    <b-col>{{ row.item.vCPU_Details }}</b-col>
                  </b-row>
                  <b-row class="mb-2" v-b-tooltip.hover title="Optimize vCPUs (assuming hyperthreading)">
                    <b-col sm="3" class="text-sm-right">
                      <b>Optimize vCPU choices:</b>
                    </b-col>
                    <b-col>{{ row.item.OptimizeVCPUs }}</b-col>
                  </b-row>
                  <b-row class="mb-2">
                    <b-col sm="3" class="text-sm-right">
                      <b>Processor:</b>
                    </b-col>
                    <b-col>{{ row.item.Processor }}</b-col>
                  </b-row>

                  <b-row class="mb-2">
                    <b-col sm="3" class="text-sm-right">
                      <b>Clockspeed:</b>
                    </b-col>
                    <b-col>{{ row.item.Clockspeed }}</b-col>
                  </b-row>
                  <b-row class="mb-2">
                    <b-col sm="3" class="text-sm-right">
                      <b>Instance Storage:</b>
                    </b-col>
                    <b-col>{{ row.item.InstanceStorage }}</b-col>
                  </b-row>
                  <b-row class="mb-2" >
                    <b-col sm="3" class="text-sm-right">
                      <b>Max IO Throughput:</b>
                    </b-col>
                    <b-col>{{ row.item.Throughput }}</b-col>
                  </b-row>
                  <b-row class="mb-2" v-if="row.item.BaselineThroughput>0" v-b-tooltip.hover title="This instance size uses EBS bursting">
                    <b-col sm="3" class="text-sm-right">
                      <b>Baseline IO Throughput:</b>
                    </b-col>
                    <b-col>{{ row.item.BaselineThroughput }}</b-col>
                  </b-row>
                  <b-row class="mb-2">
                    <b-col sm="3" class="text-sm-right">
                      <b>Network Throughput (in megabits/sec):</b>
                    </b-col>
                    <b-col>{{ row.item.Network }}</b-col>
                  </b-row>
                  <b-row class="mb-2">
                    <b-col sm="3" class="text-sm-right">
                      <b>Network Throughput - Baseline (in megabits/sec):</b>
                    </b-col>
                    <b-col>{{ row.item.BaselineNetwork}}</b-col>
                  </b-row>

                  <!-- <b-button size="sm" @click="row.toggleDetails">Hide Details</b-button> -->
                </b-card>
              </template>
            </b-table>
            <b-pagination
              :total-rows="ec2fsxnfiltered.length"
              :per-page="perPage"
              v-model="currentPage"
              class="my-0"
            />

            <b-row>
              <b-col class="mt-3 text-left">
                <br/>
                <span v-for="(list, index) in disclaimers_ec2fsxn" :key="list">
                  <span>{{ list }}</span><br/>
                </span>
                <br>
              </b-col>
            </b-row>

          </b-card>
        </b-card>
        <br>
      </div>
      <a href="#" class="card-link">Top of Page</a>
      <b-link href="/" class="card-link">Home Page</b-link>
    </b-card-body>
  </b-collapse>
</b-card>

<!-- end of rehost to ec2 bare metal mapping section -->



              <!-- The Replatform to RDS Mapping section -->
              <b-card
                no-body
                class="mb-1"
                border-variant="warning"
                header-bg-variant="warning"
                header-text-variant="white"
              >
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-btn
                    block
                    href="#"
                    v-b-toggle.accordionRDS
                    variant="warning"
                  >Re-platform to RDS-Oracle Mapping Tool (experimental) &nbsp;
              <span class="float-right">{{ !showCollapseRDS ? '▶' : '▼' }}</span></b-btn>
                </b-card-header>

                <b-collapse id="accordionRDS" v-model="showCollapseRDS" role="tabpanel">
                  <b-card-body>
                    This section provides an experimental tool to help map your desired vCPU, Memory, and IO Throughput to an RDS shape.
                    <br>
                    <br>This section is under construction.
                    <br>
                    <div>
                      <b-card title="AWS Mapping to RDS-Oracle Summary" bg-variant="warning">
                        <div v-if="rdsSelected.length==0">
                          <b-row>
                            <b-col>
                              <b>INSTRUCTIONS:</b> Confirm/adjust the performance requirement inputs, and choose an RDS shape from the candidate RDS shape list below...
                            </b-col>
                          </b-row>
                        </div>

                        <div v-if="rdsSelected.length>0">
                          <b-row>
                            <b-col>
                              RDS Compute Shape: {{targetconfig_rds.shape}}
                              <br>
                              {{targetconfig_rds.shape_summaryText}}
                            </b-col>
                          </b-row>
                          <br>

                          <b-row>
                            <b-col>
                              {{targetconfig_rds.ebs_data_summaryText1}}
                              <br>
                              {{targetconfig_rds.ebs_data_summaryText2}}
                            </b-col>
                          </b-row>
                          <br>
                          <!--<b-row>-->
                          <!--  <b-col>-->
                          <!--    {{targetconfig_rds.ebs_backup_summaryText1}}-->
                          <!--    <br>-->
                          <!--    {{targetconfig_rds.ebs_backup_summaryText2}}-->
                          <!--  </b-col>-->
                          <!--</b-row>-->

                          <!--<br>-->
                      

                          <b-row>
                            <b-col>
                              <b>License: {{targetconfig_rds.license_summaryText}}</b>
                              <br/>
                            </b-col>
                          </b-row>
                          <br>

                          <b-row>
                            <b-col>
                              <b>Summary Estimate: {{targetconfig_rds.summaryText}}</b>
                              <br>
                            </b-col>
                          </b-row>
                          <b-row v-if="targetconfig_rds.iops_warnings_alert!='' || targetconfig_rds.iops_warnings_burst!='' || targetconfig_rds.iops_warnings_info!=''">
                            <b-col>
                              <br/>
                              <b-card bg-variant="info" text-variant="white" header="IOPS Info" class="text-center">
                              <b-card-text>
                              {{targetconfig_rds.iops_warnings_alert}} {{targetconfig_rds.iops_warnings_burst}} {{targetconfig_rds.iops_warnings_info}}
                              </b-card-text>
                              </b-card>
                            </b-col>
                          </b-row>
                          <b-row v-if="targetconfig_rds.iomb_warnings_alert!='' || targetconfig_rds.iomb_warnings_burst!='' || targetconfig_rds.iomb_warnings_info!=''">
                            <b-col>
                              <br/>
                              <b-card bg-variant="info" text-variant="white" header="IO Throughput Info" class="text-center">
                              <b-card-text>
                              {{targetconfig_rds.iomb_warnings_alert}} {{targetconfig_rds.iomb_warnings_burst}} {{targetconfig_rds.iomb_warnings_info}}
                              </b-card-text>
                              </b-card>
                            </b-col>
                          </b-row>

                          <b-row v-if="targetconfig_rds.cpu_warnings_alert!='' || targetconfig_rds.cpu_warnings_burst!='' || targetconfig_rds.cpu_warnings_info!=''">
                            <b-col>
                              <br/>
                              <b-card bg-variant="info" text-variant="white" header="CPU Info" class="text-center">
                              <b-card-text>
                              {{targetconfig_rds.cpu_warnings_alert}} {{targetconfig_rds.cpu_warnings_burst}} {{targetconfig_rds.cpu_warnings_info}}
                              </b-card-text>
                              </b-card>
                            </b-col>
                          </b-row>

                          <b-row v-if="targetconfig_rds.memory_warnings_alert!='' ">
                            <b-col>
                              <br/>
                              <b-card bg-variant="info" text-variant="white" header="Memory Info" class="text-center">
                              <b-card-text>
                              {{targetconfig_rds.memory_warnings_alert}} 
                              </b-card-text>
                              </b-card>
                            </b-col>
                          </b-row>

                          <br>
                          <b-button
                            type="submit"
                            v-b-tooltip.hover
                            title="Save user inputs to the database"
                            block
                            variant="success"
                          >Save Page</b-button>
                        </div>
                      </b-card>
                      <br>
                      <br>

                      <b-card header="Performance Requirement Inputs">
                        <b-form-group label="VPCUs" label-cols="4" label-size="sm" >
                          <b-form-input
                            type="number"
                            v-model="ec2.VCPU"
                            class="col-6"
                            size="sm"
                            placeholder="Type to Search"
                          ></b-form-input>
                        </b-form-group>
                        <b-form-group label="Memory (GB)" label-cols="4" label-size="sm">
                          <b-form-input
                            type="number"
                            v-model="ec2.Memory"
                            class="col-6"
                            size="sm"
                            placeholder="Type to Search"
                          ></b-form-input>
                        </b-form-group>
                        <b-form-group label="Throughput (MB/s)" label-cols="4" label-size="sm">
                          <b-form-input
                            type="number"
                            v-model="ec2.Throughput"
                            class="col-6"
                            size="sm"
                            placeholder="Type to Search"
                          ></b-form-input>
                        </b-form-group>
                        <b-form-group label="IOPS" label-cols="4" label-size="sm">
                          <b-form-input
                            type="number"
                            v-model="ebs.IOPS"
                            class="col-6"
                            size="sm"
                            placeholder="Enter desired IOPS"
                          ></b-form-input>
                        </b-form-group>
                        <b-form-group label="Disk Space (GB)" label-cols="4" label-size="sm">
                          <b-form-input
                            type="number"
                            v-model="ebs.DiskSpace"
                            class="col-6"
                            size="sm"
                            placeholder="Enter size of database"
                          ></b-form-input>
                        </b-form-group>
                        
                        <b-form-group label-cols="4" label-size="sm" 
                          v-b-popover.hover="'This tells DBCSI if you want to size for RDS-Oracle Enterprise Edition (BYOL) or RDS-Oracle Standard Edition2 (License Included)'">
                            <template slot="label">
                              <img src="@/assets/Oracle.png" height="20px" ></img>
                              RDS-Oracle Preference:
                            </template>
                            <b-form-select v-model="form.rds_algo" size="sm" >
                              <option value="ee">Use EE BYOL</option>
                              <option value="se">Use SE2 License Included</option>
                              <option v-if="false" value="custom">Use RDS Custom for Oracle (BYOL)</option>
                              <option v-if="false && showRAC" value="rac">Use RDS Custom for Oracle Real Application Clusters (BYOL) - PREVIEW</option>
                            </b-form-select>
                        </b-form-group>
                         
                        
                        <!--<b-form-group label="Average Change Rate (MB/s)" label-cols="4" label-size="sm">-->
                        <!--  <b-form-input-->
                        <!--    type="number"-->
                        <!--    step="0.01"-->
                        <!--    v-model="ebs.Backup"-->
                        <!--    class="col-6"-->
                        <!--    size="sm"-->
                        <!--    placeholder="Enter desired change rate"></b-form-input>-->
                        <!--</b-form-group>-->
                        <!--<b-form-group-->
                        <!--  label="Snapshot Retention Days"-->
                        <!--  label-cols="4"-->
                        <!--  label-size="sm">-->
                        <!--  <b-form-input-->
                        <!--    type="number"-->
                        <!--    step="0.01"-->
                        <!--    v-model="ebs.SnapshotDays"-->
                        <!--    class="col-6"-->
                        <!--    size="sm"-->
                        <!--    placeholder="Days to retain incremental snapshots"></b-form-input>-->
                        <!--</b-form-group>-->

                        <b-form-group
                          label="Volume Type of EBS Storage"
                          label-cols="4"
                          label-size="sm"
                        >
                          <b-form-select v-model="ebs.VolumeType" size="sm">
                            <option value disabled>Please select an option</option>
                            <option value="gp2">General Purpose SSD (gp2)</option>
                            <option value="gp3">General Purpose SSD (gp3)</option>
                            <option value="io1">Provisioned IOPS SSD (io1)</option>
                            <option value="io2">Provisioned IOPS SSD (io2)</option>
                          </b-form-select>
                        </b-form-group>
                       
                        <b-form-group v-if="false" label="Local Storage Preference:" label-cols="4" label-size="sm" 
                        v-b-tooltip.hover="'This tells DBCSI if you want to only consider Shapes with local storage.  Some customers prefer to have local storage for temporary tablespace usage or for the Database Flash Cache feature.'">
                          <b-form-select v-model="form.nvme_shape_algo" size="sm" @change="showCalculateMessage">
                            <!--<option value="se_prefer" disabled>Prefer SE2 License Included</option>-->
                            <option value="Y">Only consider shapes with local storage (e.g. r5d,m5d)</option>
                            <option value="N">Consider any shape</option>
                          </b-form-select>
                        </b-form-group>
                        <b-form-group v-if="false" label="T-Shape Preference:" label-cols="4" label-size="sm" 
                        v-b-tooltip.hover="'This tells DBCSI if you want to consider T-shapes with burstable CPU.  Some customers prefer to avoid T-shapes with burstable CPU when they are bringing expensive per-CPU Oracle licenses '">
                          <b-form-select v-model="form.tshape_algo" size="sm" @change="showCalculateMessage">
                            <!--<option value="se_prefer" disabled>Prefer SE2 License Included</option>-->
                            <option value="Y">Consider T-shapes (burstable CPU)</option>
                            <option value="N">Do not consider T-shapes (burstable CPU)</option>
                          </b-form-select>
                        </b-form-group>
                        <b-form-group v-if="showOptCPU" label="Optimize CPU Preference" label-cols="4" label-size="sm" 
                          v-b-tooltip.hover="'You can use this control to tell DBCSI your preference for the Optimize CPU capability of RDS'">
                          <b-form-select v-model="form.optgoal_algo" size="sm" @change="showCalculateMessage">
                            <option value="Y">Use Optimize CPU</option>
                            <option value="min_cost">Ignore Optimize CPU</option>
                            <!--<option value="min_license">Ignore Optimize CPU and pick RDS shape to minimize VCPU (even if shape costs more)</option>-->
                          </b-form-select>
                        </b-form-group>
              <b-form-group label="AWS Pricing Preference:" label-cols="4" label-size="sm" 
                v-b-tooltip.hover="'You can use this control to tell DBCSI your preference for pricing AWS compute instances'">
                <b-form-select v-model="form.useRI_algo" size="sm" @change="showCalculateMessage">
                  <option value="RI">Use 1yr No-Upfront Reserved Instance pricing if available</option>
                  <option value="SP">Use 1yr No-Upfront Database Savings Plans pricing if available</option>
                  <option value="OD">Use On-Demand pricing</option>
                </b-form-select>
              </b-form-group>

                        <b-form-group label="Use Multi-AZ" label-cols="4" label-size="sm" 
                          v-b-tooltip.hover="'You can use this control to tell DBCSI your preference for MultiAZ'">
                    <b-form-select v-model="UseMAZ" size="sm">
                      <option value="No">No</option>
                      <option value="Yes">Yes</option>
                    </b-form-select>
                    </b-form-group>

              <b-form-group label="AWS Region for Pricing:" label-cols="4" label-size="sm">

                <b-form-select v-model="regionCode" size="sm" @change="changeRegion" :options="region_lov"/>
              </b-form-group>


                  
                        
                        <b-form-textarea
                          id="textarea10"
                          v-model="comments.RDS"
                          placeholder="Type your RDS-Oracle configuration comments/notes here."
                          :rows="3"
                          :max-rows="6"
                          size="sm"
                        ></b-form-textarea>
                        <br>
                        <b-card header="Candidate RDS Shape List">
                          Click on your desired RDS shape to select it. The list of candidate RDS shapes is filtered based on your performance requirement inputs and ordered by default by increasing cost.
                          <br>
                          <br>

                          <!-- https://bootstrap-vue.js.org/docs/components/table/ -->

                          <b-table
                            :per-page="perPage"
                            :current-page="currentPageRDS"
                            selectable
                            responsive
                            select-mode="single"
                            selectedVariant="success"
                            hover
                            :items="rdsfiltered"
                            :fields="rdsfields"
                            :sort-by.sync="rdssortBy"
                            @row-selected="rdsRowSelected"
                          >
                            <template v-slot:cell(show_details)="row">
                              <b-button
                                size="sm"
                                @click="row.toggleDetails"
                                class="mr-2"
                              >{{ row.detailsShowing ? 'Hide' : 'Show'}} Details</b-button>
                            </template>
                            <template v-slot:row-details="row">
                              <b-card>
                                <b-row class="mb-2">
                                  <b-col sm="3" class="text-sm-right">
                                    <b>Name:</b>
                                  </b-col>
                                  <b-col>{{ row.item.Name }}</b-col>
                                </b-row>
                                <b-row class="mb-2">
                                  <b-col sm="3" class="text-sm-right">
                                    <b>vCPUs:</b>
                                  </b-col>
                                  <b-col>{{ row.item.vCPU_Details }}</b-col>
                                </b-row>
                                <b-row class="mb-2" v-b-tooltip.hover title="Optimize vCPUs (assuming hyperthreading)">
                                  <b-col sm="3" class="text-sm-right">
                                    <b>Optimize vCPU choices:</b>
                                  </b-col>
                                  <b-col>{{ row.item.OptimizeVCPUs }}</b-col>
                                </b-row>
                                <b-row class="mb-2">
                                  <b-col sm="3" class="text-sm-right">
                                    <b>Processor:</b>
                                  </b-col>
                                  <b-col>{{ row.item.Processor }}</b-col>
                                </b-row>

                                <b-row class="mb-2">
                                  <b-col sm="3" class="text-sm-right">
                                    <b>Clockspeed:</b>
                                  </b-col>
                                  <b-col>{{ row.item.Clockspeed }}</b-col>
                                </b-row>
                                <b-row class="mb-2">
                                  <b-col sm="3" class="text-sm-right">
                                    <b>Local Storage:</b>
                                  </b-col>
                                  <b-col>{{ row.item.InstanceStorage }}</b-col>
                                </b-row>
                                <b-row class="mb-2" >
                                  <b-col sm="3" class="text-sm-right">
                                    <b>Max IO Throughput:</b>
                                  </b-col>
                                  <b-col>{{ row.item.Throughput }}</b-col>
                                </b-row>
                                <b-row class="mb-2" v-if="row.item.BaselineThroughput>0" v-b-tooltip.hover title="This instance size uses EBS bursting">
                                  <b-col sm="3" class="text-sm-right">
                                    <b>Baseline IO Throughput:</b>
                                  </b-col>
                                  <b-col>{{ row.item.BaselineThroughput }}</b-col>
                                </b-row>
                                <b-row class="mb-2">
                                  <b-col sm="3" class="text-sm-right">
                                    <b>Network Throughput (in megabits/sec):</b>
                                  </b-col>
                                  <b-col>{{ row.item.Network }}</b-col>
                                </b-row>
                                <b-row class="mb-2">
                                  <b-col sm="3" class="text-sm-right">
                                    <b>Network Throughput - Baseline (in megabits/sec):</b>
                                  </b-col>
                                  <b-col>{{ row.item.BaselineNetwork}}</b-col>
                                </b-row>

                                <!-- <b-button size="sm" @click="row.toggleDetails">Hide Details</b-button> -->
                              </b-card>
                            </template>
                          </b-table>
                          <b-pagination
                            :total-rows="rdsfiltered.length"
                            :per-page="perPage"
                            v-model="currentPageRDS"
                            class="my-0"
                          />

                          <b-row>
                            <b-col class="mt-3 text-left">
                              <br/>
                              <span v-for="(list, index) in disclaimers_rds" :key="list">
                                <span>{{ list }}</span><br/>
                              </span>
                              <br>
                            </b-col>
                          </b-row>
                        </b-card>
                      </b-card>
                      <br>
                    </div>
                    <a href="#" class="card-link">Top of Page</a>
                    <b-link href="/" class="card-link">Home Page</b-link>
                  </b-card-body>
                </b-collapse>
              </b-card>
              <!-- End of Replatform to RDS section -->



              <!-- The Rearchitect to Aurora Mapping section -->
              <b-card
                no-body
                class="mb-1"
                border-variant="warning"
                header-bg-variant="warning"
                header-text-variant="white"
              >
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-btn
                    block
                    href="#"
                    v-b-toggle.accordionAurora
                    variant="warning"
                  >Re-architect to Aurora Mapping Tool (very experimental) &nbsp;
              <span class="float-right">{{ !showCollapseAurora ? '▶' : '▼' }}</span></b-btn>
                </b-card-header>

                <b-collapse id="accordionAurora" v-model="showCollapseAurora" role="tabpanel">
                  <b-card-body>
                    This section provides an experimental tool to help map your desired vCPU, Memory, and IO Throughput to an Aurora shape.
                    <br>
                    <br>The sizing of an Aurora shape will be very approximate, much more approximate than the sizing to an Oracle Database on EC2 or RDS-Oracle shape. Please see the discussion in the Overview section about measuring performance and making adjustments as needed.
                    <br>
                    <br>There is effort involved in re-architecting to Aurora. The AWS Database Migration Service and the AWS Schema Conversion Tool can assist you in parts of the effort, but not all. A good first step will be to use the Schema Conversion Tool to run a migration assessment report for a migration to Aurora(PostgreSQL) or Aurora(MySQL). Another good first step is to begin a conversation with a migration partner or AWS Professional Services.
                    <br>
                    <br>This section is coming soon.
                    <br>
                    <div>
                      <b-card title="AWS Mapping to Aurora Summary" bg-variant="warning">
                        <div v-if="auroraSelected.length==0">
                          <b-row>
                            <b-col>
                              <b>INSTRUCTIONS:</b> Confirm/adjust the performance requirement inputs, and choose an Aurora shape from the candidate Aurora shape list below...
                            </b-col>
                          </b-row>
                        </div>

                        <div v-if="auroraSelected.length>0">
                          <b-row>
                            <b-col>
                              Aurora Compute Shape: {{targetconfig_aurora.shape}}
                              <br>
                              {{targetconfig_aurora.shape_summaryText}}
                            </b-col>
                          </b-row>
                          <br>

                          <b-row>
                            <b-col>
                              {{targetconfig_aurora.ebs_data_summaryText1}}
                              <br>
                              {{targetconfig_aurora.ebs_data_summaryText2}}
                            </b-col>
                          </b-row>
                          <br>
                          <b-row>
                            <b-col>
                              {{targetconfig_aurora.iops_summaryText1}}
                              <br>
                              {{targetconfig_aurora.iops_summaryText2}}
                            </b-col>
                          </b-row>
                          <br>
                          
                          <!--<b-row>-->
                          <!--  <b-col>-->
                          <!--    {{targetconfig_aurora.ebs_backup_summaryText1}}-->
                          <!--    <br>-->
                          <!--    {{targetconfig_aurora.ebs_backup_summaryText2}}-->
                          <!--  </b-col>-->
                          <!--</b-row>-->

                          <br>
                      

                          <!-- <b-row>
                            <b-col>
                              <b>License: {{targetconfig_aurora.license_summaryText}}</b>
                              <br/>
                            </b-col>
                          </b-row>
                          <br> -->

                          <b-row>
                            <b-col>
                              <b>Summary Estimate: {{targetconfig_aurora.summaryText}}</b>
                              <br>
                            </b-col>
                          </b-row>
                          <b-row v-if="targetconfig_aurora.cpu_warnings!=''">
                            <b-col>
                              <br/>
                              <b-card bg-variant="danger" text-variant="white" header="Warning" class="text-center">
                              <b-card-text>
                              {{targetconfig_aurora.cpu_warnings}}
                              </b-card-text>
                              </b-card>
                            </b-col>
                          </b-row>

                          <br>
                          <b-button
                            type="submit"
                            v-b-tooltip.hover
                            title="Save user inputs to the database"
                            block
                            variant="success"
                          >Save Page</b-button>
                        </div>
                      </b-card>
                      <br>
                      <br>

                      <b-card header="Performance Requirement Inputs">
                        <!--<b-form-group-->
                        <!--  label="Database Flavor"-->
                        <!--  label-cols="4"-->
                        <!--  label-size="sm">-->
                        <!--  <b-form-select v-model="ec2extras.aurora_flavor" size="sm">-->
                        <!--    <option value disabled>Please select an option</option>-->
                        <!--    <option value="PG">PostgreSQL</option>-->
                        <!--    <option value="MYSQL" disabled>MySQL</option>-->
                        <!--  </b-form-select>-->
                        <!--</b-form-group>-->

                        <b-form-group label="VPCUs" label-cols="4" label-size="sm">
                          <b-form-input
                            type="number"
                            v-model="ec2.VCPU"
                            class="col-6"
                            size="sm"
                            placeholder="Type to Search"
                          ></b-form-input>
                        </b-form-group>
                        <b-form-group label="Memory (GB)" label-cols="4" label-size="sm">
                          <b-form-input
                            type="number"
                            v-model="ec2.Memory"
                            class="col-6"
                            size="sm"
                            placeholder="Type to Search"
                          ></b-form-input>
                        </b-form-group>
                        <b-form-group label="Throughput (MB/s)" label-cols="4" label-size="sm">
                          <b-form-input
                            type="number"
                            v-model="ec2.Throughput"
                            class="col-6"
                            size="sm"
                            placeholder="Type to Search"
                          ></b-form-input>
                        </b-form-group>

                        <b-form-group label="Disk Space (GB)" label-cols="4" label-size="sm">
                          <b-form-input
                            type="number"
                            v-model="ebs.DiskSpace"
                            class="col-6"
                            size="sm"
                            placeholder="Enter size of database"
                          ></b-form-input>
                        </b-form-group>
                        
              <b-form-group label="Aurora IO Estimate:" label-cols="4" label-size="sm"
                v-b-tooltip.hover="'Use this control to tell DBCSI to also include a rough estimate of an Aurora PostgreSQL sizing.  This will be a very ballpark sizing based on some broad assumptions.'">
                <b-form-select v-model="form.aurora_algo" size="sm">
                  <option value="auro2" >Estimate Storage IO costs as 25% of the on-demand cost of the compute shape</option>
                  <!--<option value="auro3" disabled>Yes- estimate Storage IO costs as 35% of the on-demand cost of the compute shape</option>-->
                  <option value="auro4" >Estimate Storage IO costs based on estimated IOs derived from target IO Throughput metric, adjusted by internal ratios</option>
                  <option value="auro5" >Use the Aurora IO-Optimized mode (no need to estimate number of storage IOs)</option>
                </b-form-select>
              </b-form-group>
              <b-form-group label="AWS Pricing Preference:" label-cols="4" label-size="sm" 
                v-b-tooltip.hover="'You can use this control to tell DBCSI your preference for pricing AWS compute instances'">
                <b-form-select v-model="form.useRI_algo" size="sm" @change="showCalculateMessage">
                  <option value="RI">Use 1yr No-Upfront Reserved Instance pricing if available</option>
                  <option value="SP">Use 1yr No-Upfront Database Savings Plans pricing if available</option>
                  <option value="OD">Use On-Demand pricing</option>
                </b-form-select>
              </b-form-group>

                        <b-form-group label="Use High-Availability (add a Replica)" label-cols="4" label-size="sm" 
                          v-b-tooltip.hover="'You can use this control to tell DBCSI your preference for having a 2nd instance in the Aurora cluster'">
                          <b-form-select v-model="UseMAZ" size="sm">
                            <option value="No">No</option>
                            <option value="Yes">Yes</option>
                          </b-form-select>
                        </b-form-group>

              <b-form-group label="AWS Region for Pricing:" label-cols="4" label-size="sm">

                <b-form-select v-model="regionCode" size="sm" @change="changeRegion" :options="region_lov"/>
              </b-form-group>

                        
                        <!--<b-form-group label="Average Change Rate (MB/s)" label-cols="4" label-size="sm">-->
                        <!--  <b-form-input-->
                        <!--    type="number"-->
                        <!--    step="0.01"-->
                        <!--    v-model="ebs.Backup"-->
                        <!--    class="col-6"-->
                        <!--    size="sm"-->
                        <!--    readonly-->
                        <!--    placeholder="Enter desired change rate"></b-form-input>-->
                        <!--</b-form-group>-->
                        <!--<b-form-group-->
                        <!--  label="Snapshot Retention Days"-->
                        <!--  label-cols="4"-->
                        <!--  label-size="sm">-->
                        <!--  <b-form-input-->
                        <!--    type="number"-->
                        <!--    step="0.01"-->
                        <!--    v-model="ebs.SnapshotDays"-->
                        <!--    class="col-6"-->
                        <!--    size="sm"-->
                        <!--    readonly-->
                        <!--    placeholder="Days to retain incremental snapshots"></b-form-input>-->
                        <!--</b-form-group>-->
                        
                        
<!--                        <b-card>-->
<!--                          <b-form-group label="Pre-Aurora Throughput (MB/s)" label-cols="4" label-size="sm">-->
<!--                          <b-form-input-->
<!--                            type="number"-->
<!--                            v-model="ec2.Throughput"-->
<!--                            class="col-6"-->
<!--                            size="sm"-->
<!--                            readonly-->
<!--                            placeholder="Type to Search"></b-form-input>-->
<!--                        </b-form-group>-->

<!--                        <b-form-group label="Pre-Aurora Peak IOPS" label-cols="4" label-size="sm">-->
<!--                          <b-form-input-->
<!--                            type="number"-->
<!--                            v-model="ebs.IOPS"-->
<!--                            class="col-6"-->
<!--                            size="sm"-->
<!--                            readonly-->
<!--                            placeholder="Enter desired Peak IOPS"></b-form-input>-->
<!--                        </b-form-group>-->
<!-- https://w.amazon.com/index.php/Ricesimo/AuroraPG-estimation -->
<!--                        <b-form-group label="Aurora IOPS Peak to Average Factor" label-cols="4" label-size="sm" v-b-tooltip.hover-->
<!--                title="Enter the factor to use to adjust for converting to Peak IOPS to average (sustained) IOPS.  Typically, we see Peaks that are 2-4x the sustained average.">-->
<!--                          <b-form-input-->
<!--                            type="number"-->
<!--                            step="0.1"-->
<!--                            v-model="ebs.aurora_IOPS_peak_adj"-->
<!--                            class="col-6"-->
<!--                            size="sm"-->
<!--                            placeholder="Enter Peak to Average IOPS Factor"></b-form-input>-->
<!--                        </b-form-group>-->
<!--                        <b-form-group label="Aurora IOPS Write Reduction Factor" label-cols="4" label-size="sm" v-b-tooltip.hover-->
<!--                title="Enter the factor to use to adjust for Aurora write de-amplification.  Typically, we may see Aurora only uses 0.8 to 1.0 of the IOPS otherwise.">-->
<!--                          <b-form-input-->
<!--                            type="number"-->
<!--                            step="0.01"-->
<!--                            v-model="ebs.aurora_IOPS_write_adj"-->
<!--                            class="col-6"-->
<!--                            size="sm"-->
<!--                            placeholder="Enter IOPS Write de-amplification Factor"></b-form-input>-->
<!--                        </b-form-group>-->
                        
<!--              <b-row>-->
<!--                <b-col>Implied average database request size: {{(ec2.Throughput*1024/ebs.IOPS).toFixed(0)}} KB</b-col>-->
<!--              </b-row>-->
<!--              <b-row>-->
<!--                <b-col>-->
<!--                  Implied Pre-Aurora IOPS using 8K pages: {{(aurora_8k_iops_pre).toFixed(0)}}</b-col>-->
<!--              </b-row>    -->
<!--              <b-row>-->
<!--                <b-col>-->
<!--                  Estimated Aurora IOPS: <b>{{ aurora_calculated_iops.toFixed(0) }} IOs per second, {{ (aurora_calculated_iops*60*732/1000000).toFixed(2) }} Million IOs per Month</b>-->
<!--                </b-col>    -->
<!--              </b-row>-->
<!--                  </b-card>-->
                  <br/>

                        <b-form-textarea
                          id="textarea10"
                          v-model="comments.Aurora"
                          placeholder="Type your Aurora configuration comments/notes here."
                          :rows="3"
                          :max-rows="6"
                          size="sm"
                        ></b-form-textarea>
                        <br>
                        <b-card header="Candidate Aurora Shape List">
                          Click on your desired Aurora shape to select it. The list of candidate Aurora shapes is filtered based on your performance requirement inputs and ordered by default by increasing cost.
                          <br>
                          <br>

                          <!-- https://bootstrap-vue.js.org/docs/components/table/ -->

                          <b-table
                            :per-page="perPage"
                            :current-page="currentPageAurora"
                            selectable
                            responsive
                            select-mode="single"
                            selectedVariant="success"
                            hover
                            :items="aurorafiltered"
                            :fields="aurorafields"
                            :sort-by.sync="aurorasortBy"
                            @row-selected="auroraRowSelected"
                          >
                            <template v-slot:cell(show_details)="row">
                              <b-button
                                size="sm"
                                @click="row.toggleDetails"
                                class="mr-2"
                              >{{ row.detailsShowing ? 'Hide' : 'Show'}} Details</b-button>
                            </template>
                            <template v-slot:cell(AuroraPG1yrNURI)="row">
                              {{ row.item.AuroraPG1yrNURI ? Math.round(1000*row.item.AuroraPG1yrNURI*1.3)/1000 : ''}}
                            </template>  

                            <template v-slot:row-details="row">
                              <b-card>
                                <b-row class="mb-2">
                                  <b-col sm="3" class="text-sm-right">
                                    <b>Name:</b>
                                  </b-col>
                                  <b-col>{{ row.item.Name }}</b-col>
                                </b-row>
                                <b-row class="mb-2">
                                  <b-col sm="3" class="text-sm-right">
                                    <b>vCPUs:</b>
                                  </b-col>
                                  <b-col>{{ row.item.VCPU }}</b-col>
                                </b-row>
                                <b-row class="mb-2">
                                  <b-col sm="3" class="text-sm-right">
                                    <b>Processor:</b>
                                  </b-col>
                                  <b-col>{{ row.item.Processor }}</b-col>
                                </b-row>

                                <b-row class="mb-2">
                                  <b-col sm="3" class="text-sm-right">
                                    <b>Clockspeed:</b>
                                  </b-col>
                                  <b-col>{{ row.item.Clockspeed }}</b-col>
                                </b-row>

                                <b-row v-if="row.item.InstanceStorage && row.item.InstanceStorage!='EBS only'" class="mb-2">
                                  <b-col sm="3" class="text-sm-right">
                                    <b>Instance Storage:</b>
                                  </b-col>
                                  <b-col>{{ row.item.InstanceStorage }}</b-col>
                                </b-row>

                                <b-row class="mb-2">
                                  <b-col sm="3" class="text-sm-right">
                                    <b>Network Throughput (in megabits/sec):</b>
                                  </b-col>
                                  <b-col>{{ row.item.Network }}</b-col>
                                </b-row>
                                <b-row class="mb-2">
                                  <b-col sm="3" class="text-sm-right">
                                    <b>Network Throughput - Baseline (in megabits/sec):</b>
                                  </b-col>
                                  <b-col>{{ row.item.BaselineNetwork}}</b-col>
                                </b-row>

                              </b-card>
                            </template>
                          </b-table>
                          <b-pagination
                            :total-rows="aurorafiltered.length"
                            :per-page="perPage"
                            v-model="currentPageAurora"
                            class="my-0"
                          />

                          <b-row>
                            <b-col class="mt-3 text-left">
                              <br/>
                              <span v-for="(list, index) in disclaimers_aurora" :key="list">
                                <span>{{ list }}</span><br/>
                              </span>
                              <br>
                            </b-col>
                          </b-row>
                        </b-card>
                      </b-card>
                      <br>
                    </div>
                    <a href="#" class="card-link">Top of Page</a>
                    <b-link href="/" class="card-link">Home Page</b-link>
                  </b-card-body>
                </b-collapse>
              </b-card>
              <!-- End of Rearchitect to Aurora section -->



            </b-card-body>
          </b-collapse>
        </b-card>
      </b-form>
    </div>
  </div>
</template>

<script>
import { API } from "aws-amplify";
import TimeChartContainer from "./TimeChartContainer.vue";
import TimeChart2Container from "./TimeChart2Container.vue";
import TimeChart4Container from "./TimeChart4Container.vue";
import TimeChartRACContainer from "./TimeChartRACContainer.vue";
import TimeBarChartNContainer from "./TimeBarChartNContainer.vue";
import ScatterChartContainer from "./ScatterChartContainer.vue";
import {calculate_target_values} from "./dbcsi_external.js";
import {disclaimers} from "./dbcsi_external.js";
import {calculate_ec2_config} from "./dbcsi_ec2.js";
import {calculate_ec2fsxn_config} from "./dbcsi_ec2fsxn.js";
import {calculate_rds_config} from "./dbcsi_rds.js";
import {calculate_aurora_config} from "./dbcsi_aurora.js";
import {older_generation_cost_adjustment} from "./dbcsi_external.js";
import ExadataObservations from "./ExadataObservations.vue";
import axios from "axios";

export default {
  name: "app",
  components: {
    timechartcontainer: TimeChartContainer,
    timechart2container: TimeChart2Container,
    timechart4container: TimeChart4Container,
    timechartRACcontainer: TimeChartRACContainer,
    timebarchartncontainer: TimeBarChartNContainer,
    scatterchartcontainer: ScatterChartContainer,
    exadataobservations: ExadataObservations
  },
  async created() {
    
    this.collection_id = this.param_collection_id;
    // is this shareMode?
    if ( (this.param_collection_id.substring(0,2)=="SD")  || (this.param_collection_id.substring(0,2)=="SB")) {
      console.log("shareMode");
      this.collection_id=this.param_collection_id.substring(2).split('-')[1];
      this.shareMode=true;
    }
    
    var tries = 2;
    var batchsuccess=false;
    var isOK = true;
    while (tries > 0) {
      await API.get(
        "dbcsiAPI",
        `/dbcsi/authorized/${this.param_collection_id}`
      )
        .then(response => {
          if (response.data.authorized!="Y") {
            console.log("Sorry, not authorized to view this collection.  Routing back to main page.");      
            this.$router.push('/');
            tries = 0;
            isOK=false;
            
          }
        })
        .catch(error => {
          console.log("Metrics-authorized Error:", error);
          console.log("Will retry.  Attempts Left:", (tries-1));
        });
      tries -= 1;
		}
		
		if (!isOK) return;
		
    await API.get(
        "dbcsiAPI",
        `/dbcsi/permissions`
      )
        .then(response => {
          if (response.data.racOK=="Y") {
            console.log("Authorized for RAC.");      
            this.showRAC = true;
          }
          if (response.data.currentEmployee=="Y") {
            // console.log("Current Employee.");      
            this.currentEmployee = true;
          }
          
        })
        .catch(error => {
          console.log("Batch-permissions Error:", error);
        });

    if ( (["dbayardAWS","amzn~dbayard"].includes(this.user)) || (this.user=="svaidya") ) {
      this.showRAC = true;
    }

    if (this.query!=undefined) {
      // console.log("query", this.query);
      if ( (this.query.toLowerCase().indexOf("show_rac")>=0) || (this.query.toLowerCase().indexOf("showrac")>=0) ) {
        console.log("showRAC enabled");
        this.showRAC = true;
      }
      if ( (this.query.toLowerCase().indexOf("show_optcpu")>=0) || (this.query.toLowerCase().indexOf("showoptcpu")>=0) ) {
        console.log("showoptCPU enabled");
        this.showOptCPU = true;
      }
      
    }
 		
    tries = 2;
    
    while (tries > 0) {
      await API.get(
        "dbcsiAPI",
        `/dbcsi/batch/${this.shareMode ? this.param_collection_id : ('C' + this.collection_id) }`
      )
        .then(response => {
				// 	console.log("get batch success ",response);
					if (response.success) {
					   if (response.data.length>0) {
                this.batchItems = response.data;
               batchsuccess=true;
					   } else {
					     console.log("metrics- no data returned from /batch/Cxxxx");
					     batchsuccess=false;
					   }  
          
 
          
          //are any of these batchItems non X86?
          if (batchsuccess) {
          for (var i of this.batchItems) {
            if ( ! i.PLATFORM_NAME.includes('x86')  ) {
              this.showAlertNonX86 = true;
              this.alertTextNonX86 = "Warning: This is a non X86 platform.  Please enter a CPU thread mapping ratio value.  " + (this.currentEmployee ? "AWS Employees can watch https://broadcast.amazon.com/videos/398430 (internal) for more details." : "You can watch https://www.youtube.com/watch?v=fA8rKA1Sggs for more details.");
              this.NonX86Platform = i.PLATFORM_NAME;
              
               if (i.PLATFORM_NAME=="None") {
                this.alertTextNonX86 = "Warning: It is unknown if this is a X86 platform.  If this is not X86, then please enter a CPU thread mapping ratio value.  " + (this.currentEmployee ? "AWS Employees can watch https://broadcast.amazon.com/videos/398430 (internal) for more details." : "You can watch https://www.youtube.com/watch?v=fA8rKA1Sggs for more details.");
              }
              
              if (i.PLATFORM_NAME=="Solaris[tm]_OE_(64-bit)") {
                this.alertTextNonX86 = "Warning: This is a SPARC platform.  You should enter a x86 CPU Thread Mapping Ratio value to account for relative performance between a SPARC thread and an x86 thread.  Some suggested ratios values are T3=16.7, T5=5.9, M7=4.9, VII=3.7, X=1.8, XII=2.4. " + (this.currentEmployee ? "AWS Employees can watch https://broadcast.amazon.com/videos/398430 (internal) for more details." : "You can watch https://www.youtube.com/watch?v=fA8rKA1Sggs for more details.");
                this.form.cpu_thread_ratio = 4.9;
              }

              if (i.PLATFORM_NAME=="AIX-Based_Systems_(64-bit)") {
                this.showAIX = true;
                this.AIX_CPU_ADJUSTMENT = i.AIX_CPU_ADJUSTMENT;
                i.AIX_CPU_ADJUSTMENT_USED =i.AIX_CPU_ADJUSTMENT*1; 
                if (this.form.aix_algo=="old") {
                  i.AIX_CPU_ADJUSTMENT_USED =i.AIX_CPU_ADJUSTMENT*1; 
                } else if (this.form.aix_algo=="new") {
                  i.AIX_CPU_ADJUSTMENT_USED = (i.AIX_CPU_ADJUSTMENT*1) == 8 ? 4 : 2.5;
                } else if (this.form.aix_algo=="new2") {
                  i.AIX_CPU_ADJUSTMENT_USED =(i.AIX_CPU_ADJUSTMENT*1) == 8 ? 2.0 : 1.8;
                }   
                this.AIX_CPU_ADJUSTMENT_USED = i.AIX_CPU_ADJUSTMENT_USED;
                
                // console.log("AIX", this.AIX_CPU_ADJUSTMENT);
                this.alertTextNonX86 = "Warning: This is an AIX platform.  To account for differences in how AIX tracks CPU time (see https://ardentperf.com/2016/07/01/understanding-cpu-on-aix-power-smt-systems/), we will adjust the CPU Usage metric by an AIX Power SMT CPU Time Adjustment factor.  You should also enter a x86 CPU Thread Mapping Ratio value to account for relative performance between an AIX thread and an x86 thread.  Some suggested ratios values are Power6=1.6, Power7=2.1, Power8=2.5, Power9=1.8, Power10=1.3, Power11=1.15.  " + (this.currentEmployee ? "AWS Employees can watch https://broadcast.amazon.com/videos/398430 (internal) for more details." : "You can watch https://www.youtube.com/watch?v=fA8rKA1Sggs for more details.");
                this.form.cpu_thread_ratio = 2.5;
              }
              //break;
            }
            if (i.Exadata=="Yes") {
              // ADP and ADW hide the fact that they are exadata!
              this.IS_EXADATA = true;
              //break;
            }
            if (i.IS_PDB=="YES") {
              // ADP and ADW hide the fact that they are exadata!
              this.IS_PDB = "YES";
              this.showPDBalert = true;
              //break;
            }
          }  
          }
					tries = 0;
					// console.log("get batch set batchItems:"+this.batchItems.length);
					}
          // console.log(this.genItems);
        })
        .catch(error => {
          console.log("Metrics-batchItems Error:", error);
          console.log("Will retry.  Attempts Left:", (tries-1));
        });
      tries -= 1;
		}



    
    // console.log("I am here1");
    tries = 2;
    while (tries > 0) {
      await API.get(
        "dbcsiAPI",
        `/dbcsi/${this.param_collection_id}/${this.collection_type}`
      )
        .then(response => {
          
          this.genItems = response.data;
          
          //if no rows, then not authorized
          if (this.genItems.length==0) {
            console.log("Sorry, not authorized to view this collection.  Routing back to main page.");      
            this.$router.push('/');
          } 
          
          //pull out platform and DBsize
          
          for (var ii = 0; ii < this.genItems.length; ii++) {

            //is this AWR_MINER_VERSION
            if (this.genItems[ii].name == "AWR_MINER_VERSION") {
              // console.log("Platform", this.genItems[ii].value);
              this.gen_dbcsi_script = this.genItems[ii].value;
            }
             
            //is this !CPU_CORE_COUNT or GLOBAL_CPU_CORE_COUNT
            if ((this.genItems[ii].name == "!CPU_CORE_COUNT")||(this.genItems[ii].name == "GLOBAL_CPU_CORE_COUNT")) {
              // console.log("cpu_core_count", this.genItems[ii].value);
              this.gen_cpu_core_count = this.genItems[ii].value;
            }
            
            //TOTAL_DB_SIZE_GB
            if (this.genItems[ii].name == "TOTAL_DB_SIZE_GB") {
              // console.log("Platform", this.genItems[ii].value);
              this.gen_db_size = this.genItems[ii].value;
            }
            //COUNT_TABLE
            if (this.genItems[ii].name == "COUNT_TABLE") {
              // console.log("Platform", this.genItems[ii].value);
              this.count_table = this.genItems[ii].value;
            }
            //COUNT_LINES_PLSQL
            if (this.genItems[ii].name == "COUNT_LINES_PLSQL") {
              // console.log("Platform", this.genItems[ii].value);
              this.count_lines_plsql = this.genItems[ii].value;
            }
            //HOSTS
            if (this.genItems[ii].name == "HOSTS") {
              // console.log("Platform", this.genItems[ii].value);
              this.hosts = this.genItems[ii].value;
            }
            //INSTANCES
            if (this.genItems[ii].name == "INSTANCES") {
              this.instances = this.genItems[ii].value;
            }  
            //INSTANCENUMS
            if (this.genItems[ii].name == "INSTANCENUMS") {
              this.instancenums = this.genItems[ii].value;
            }  
              
            //hide socket values
            if ((this.genItems[ii].name == "!CPU_SOCKET_COUNT")||(this.genItems[ii].name == "GLOBAL_CPU_SOCKET_COUNT") ||(this.genItems[ii].name == "NUM_CPU_SOCKETS")  ) {
              // console.log("Removing socket1", this.genItems.length);
              this.genItems.splice(ii,1);
              // console.log("Removing socket2", this.genItems.length);
              ii--;
            }
            
            //hide DEBUG values
            if ( this.genItems[ii].name.startsWith("DEBUG")  ) {
              // console.log("Removing DEBUG1", this.genItems.length);
              this.genItems.splice(ii,1);
              // console.log("Removing DEBUG2", this.genItems.length);
              ii--;
            }
            
            //SNAPSHOT_START
            if (this.genItems[ii].name == "SNAPSHOT_START") {
              // console.log("SNAPSHOT_START", this.genItems[ii].value);
              this.start_date = this.genItems[ii].value.split(' ')[0];
              this.start_date_min = this.start_date;
            }
            if (this.genItems[ii].name == "SNAPSHOT_STOP") {
              // console.log("SNAPSHOT_STOP", this.genItems[ii].value);
              this.end_date = this.genItems[ii].value.split(' ')[0];
              this.end_date_max = this.end_date;
            }
            
            //hide DB_ values
             if ( this.genItems[ii].name.startsWith("DB_") && this.genItems[ii].name!="DB_NAME" ) {
              this.genItems.splice(ii,1);
              ii--;
            }
           

            
            
          }
          // add row for SE2_ANALYSIS
          this.genItems.push({name: "SE2_ANALYSIS", value: ""});
          
          //setup instanceChoices
          this.instanceChoices = [
             { value: 'all', text: 'Display metrics for Entire Cluster' }
          ];

          //if we have instancenums use that
          if (this.instancenums!='') {
            for (var iii = 0; iii < this.instancenums.split(',').length ; iii++) {
                  this.instanceChoices.push({ value: this.instancenums.split(',')[iii], text: 'Instance '+this.instancenums.split(',')[iii]});
                }
          } else
          {
            //first adjust instances to be at least # of hosts
            let numHosts = this.hosts.split(',').length;
            if (this.instances*1 < numHosts) {
              console.log('adjusting instances to numHosts');
              this.instances = numHosts;
            }
            for (var iii = 1; iii <= this.instances*1 ; iii++) {
              this.instanceChoices.push({ value: iii, text: 'Instance '+iii});
            }
          }


          tries = 0;
          // console.log(this.genItems);
        })
        .catch(error => {
          console.log("Metrics-GeneralItems Error:", error);
          console.log("Will retry.  Attempts Left:", (tries-1));
        });

      tries -= 1;
    }

    
    // now get additional data

    var success = true;
    
    if (batchsuccess) {
        //clear out existing configs
                 
        for (var agroupi=0; agroupi< this.batchItems.length ; agroupi++) {
          this.batchItems[agroupi].targetconfig_rds = null;
          this.batchItems[agroupi].targetconfig_aurora = null;

        }  



          this.flatItems = [];




          var  batchParams = {
              body: {
                outliers: {
                  IOPS: 50000,
                  IOMB: 8000,
                  VCPU: 50
                }
              }
            };

            //is this a PDB?
            var pdb_response = {};
            if (this.batchItems[0].IS_PDB=="YES") {
                tries = 4;
                while (tries > 0) {
                  tries -= 1;  
                
                  await API.put(
                    "dbcsiAPI",
                    `/dbcsi/batch/additional_pdb_percentiles/${this.batchItems[0].collectionID}`,  
                    batchParams
                  )
                    .then(response => {
                      // console.log("additional_pdb_percentiles", response.data);
                      pdb_response = response.data;
                      //if we have CDB_IOPS, use those as new outliers
                      if (pdb_response.CDB_IOPS != undefined) {
                        console.log("setting new outliers based on CDB");
                        batchParams.body.outliers.IOPS = pdb_response.CDB_IOPS;
                        batchParams.body.outliers.IOMB = pdb_response.CDB_IOMB;
                        batchParams.body.outliers.VCPU = pdb_response.CDB_VCPU;
                      }
                      tries=0;
                      success=true;
                    } 
                    )
                    .catch(error => {
                      console.log("Metrics- additional_pdb_percentiles.put Error. Tries:", tries);
                        // this.alertTextRecalc = "Error while additional_datapoints: "+error;
                        // this.alertStyleRecalc="danger";
                        success=false;
                    });
                }    
              
            }

            var response = {
              data: ""
            };

            tries = 2;
            while (tries > 0) {
              tries -= 1;  
            
              await API.put(
                "dbcsiAPI",
                `/dbcsi/batch/additional_percentiles/${this.batchItems[0].collectionID}`,  
                batchParams
              )
                .then(newresponse => {
                  // console.log("additional_percentiles", newresponse.data);
                  var main_response=newresponse.data;
                  //merge in PDB values
                  if (this.batchItems[0].IS_PDB=="YES") {
                    main_response.DB_PDB2_IOMB_AVERAGE_P99 = pdb_response.DB_PDB2_IOMB_AVERAGE_P99;
                    main_response.DB_PDB2_CPU_THREADS_AVERAGE_P99 = pdb_response.DB_PDB2_CPU_THREADS_AVERAGE_P99;
                    main_response.DB_PDB2_CPU_THREADS_AVERAGE_P75 = pdb_response.DB_PDB2_CPU_THREADS_AVERAGE_P75;
                    main_response.CDB_IOPS = pdb_response.CDB_IOPS;
                    main_response.CDB_IOMB = pdb_response.CDB_IOMB;
                    main_response.CDB_VCPU = pdb_response.CDB_VCPU;
                    main_response.CDB_DBID = pdb_response.CDB_DBID;
                    main_response.CDB_collectionId = pdb_response.CDB_collectionId;
                    main_response.cdb_target_comments = pdb_response.cdb_target_comments;
                  }
                  batchParams.body.inputs = main_response;
                  this.batchItems[0].additional_datapoints = main_response;
                  this.batchItems[0].Exadata = main_response.Exadata;
                  response.data = main_response;
                  tries=0;
                  success=true;
                } 
                )
                .catch(error => {
                  console.log("Batch- additional_percentiles.put Error. Tries:", tries);
                    // this.alertTextRecalc = "Error while additional_datapoints: "+error;
                    // this.alertStyleRecalc="danger";
                    success=false;
                });
            }    




                this.batchItems[0].SmartScanEligible=response.data.DB_EXA_CELL_BYTES_ELIG_MB_P99;
                this.batchItems[0].StorageIndexSavings=response.data.DB_EXA_CELL_SI_SAVE_MB_P99;
                this.batchItems[0].IOPS=response.data.IOPS;
                this.batchItems[0].Exadata=response.data.Exadata;
                this.batchItems[0].Throughput=response.data.Throughput;
                this.blended_cpu1=response.data.blended_cpu1;
                this.blended_iops1=response.data.blended_iops1;
                this.blended_iomb1=response.data.blended_iomb1;
                
                //bridge to old stuff for now. 0701
                this.ec2.VCPU=this.batchItems[0].VCPU;
                this.ec2.Memory=this.batchItems[0].Memory;
                this.ec2.Throughput=this.batchItems[0].Throughput;
                this.ebs.DiskSpace=this.batchItems[0].DiskSpace;
                this.ebs.IOPS=this.batchItems[0].IOPS;
                this.ebs.VolumeType=this.batchItems[0].VolumeType;
                
                this.UseMAZ = response.data.UseMAZ;


     //now load suggestions
    await this.autosuggest('ALL');
    


    // now load reviewComments
    await API.get(
      "dbcsiAPI",
      `/dbcsi/${this.collection_id}/${this.collection_type}/reviewComments`
    )
      .then(response => {
        // console.log("I am here4");
        this.comments = response.data.comments;
        this.ec2 = response.data.ec2;

        var tempebs = response.data.ebs;
        //fix default for VolumeType
        //TODO: did I break something?  Is there a better way to set this so that my computed field gets updated too?
        if (typeof tempebs.VolumeType === "undefined") {
          tempebs.VolumeType = "gp2";
        }
        if (typeof tempebs.BackupType === "undefined") {
          tempebs.BackupType = "none";
        }
        if (typeof tempebs.Backup === "undefined") {
          tempebs.Backup = "0";
        }
        if (typeof tempebs.SnapshotDays === "undefined") {
          tempebs.SnapshotDays = "7";
        }
        if (typeof tempebs.aurora_IOPS_peak_adj === "undefined") {
          tempebs.aurora_IOPS_peak_adj = "4";
        }
        if (typeof tempebs.aurora_IOPS_write_adj === "undefined") {
          tempebs.aurora_IOPS_write_adj = "0.9";
        }
        
        this.ebs = tempebs;
        this.ec2extras = response.data.ec2extras;
        if (typeof this.ec2extras.CPU_src_specint === "undefined") {
          // this.ec2extras.CPU_src_specint = 20;
          // this breaks responsiveness somehow
        }
        if (typeof this.ec2extras.VCPU_adj_other === "undefined") {
          // this.ec2extras.VCPU_adj_other = 1.0;
          // this breaks responsiveness somehow
        }
        if (typeof this.ec2extras.aurora_flavor === "undefined") {
          this.ec2extras.aurora_flavor = "PG";
        }


      })
      .catch(error => {
        console.log("Metrics-Load ReviewComments Error:", error);
      });
    // console.log("I am here4");

    // console.log("query",this.query);
    // console.log("before", this.ec2);
    if (this.query != undefined) {
      var myStuff = this.query.split(':');
      myStuff = myStuff.filter(word => (word!='undefined' && word!='') );
      if (myStuff.length>=2) {
        this.regionCode=myStuff[0];
        // this.databaseType=myStuff[1];
        if (myStuff[2]!="undefined") {
          
          var tempEC2 = JSON.parse(JSON.stringify(this.ec2)); //not sure why I have to do this
          var tempEBS = JSON.parse(JSON.stringify(this.ebs)); //not sure why I have to do this
          
          if (myStuff.length>=3)  {
            tempEC2.VCPU=myStuff[2];
            // console.log("VCPU", this.ec2.VCPU, myStuff[2], tempEC2.VCPU);

          }
          if (myStuff.length>=4) {
            tempEC2.Memory=myStuff[3];
          }
          if (myStuff.length>=5) {
            tempEC2.Throughput=myStuff[4];
          }  
          if (myStuff.length>=6) {
            tempEBS.IOPS=myStuff[5];
          }  
          if (myStuff.length>=7) {
            tempEBS.DiskSpace=myStuff[6];
          }  
          if (myStuff.length>=8) {
            // console.log("UseMAZ", myStuff[7]);
            tempEBS.VolumeType=myStuff[7];
          }  
          if (myStuff.length>=9) {
            // console.log("UseMAZ", myStuff[7]);
            this.UseMAZ=myStuff[8];
          }  
          this.ec2 = tempEC2;
          this.ebs = tempEBS;
        }  
      }  
        
    }
    // console.log("after", this.ec2);


    // now load Region info
    await this.changeRegion(this.regionCode);
    
  
    // setup adhoc-charts
    await API.get("dbcsiAPI", `/dbcsi/adhoc_chart_columns/${this.collection_id}`)
      .then(response => {
        // console.log("Charts: I am here3");
        this.chart_columns = response.data;
        tries = 0;
      })
      .catch(error => {
        console.log("Chart adhoc_chart_columns Error:", error);
      });

    this.column_lov = [];
    for (var iii = 0; iii < this.chart_columns.length ; iii++) {
      // console.log(iii, this.chart_columns[iii].metric_name);
      // if (this.chart_columns[iii].metric_group=='MAIN_METRICS') {
        this.column_lov.push({ value: this.chart_columns[iii].metric_name, text: this.chart_columns[iii].metric_title, metric_group:this.chart_columns[iii].metric_group} );
      // }  
    }
    
    //make copies
    this.changeAdhocMetricGroup1('MAIN_METRICS');
    this.changeAdhocMetricGroup2('MAIN_METRICS');
    this.changeAdhocMetricGroup3('MAIN_METRICS');
    this.changeAdhocMetricGroup4('MAIN_METRICS');

    } //if batchItems>0
    this.loaded = true;
// console.log("I am here4");
  }, //end created()


  props: ["param_collection_id", "collection_type", "user", "query"],
  data() {
    return {
      start_date: "",
      end_date: "",
      start_date_min: "",
      end_date_max: "",
      loaded: false,
      generatedSharingURL: '',
      collection_id: "",
      shareMode: false,
      comments: {
        General: "",
        DiskSpace: "",
        CPU: "",
        Memory: "",
        IO: "",
        Backup: "",
        EC2: "",
        RDS: "",
        Waits: "",
        Exadata: "",
        Aurora: ""
      },
      regionCode: "us-east-1",
      region_lov: [
{ value: 'af-south-1', text: 'af-south-1 Cape Town' },
{ value: 'ap-east-1', text: 'ap-east-1 Hong Kong'  },
{ value: 'ap-east-2', text: 'ap-east-1 Taipei'  },
{ value: 'ap-northeast-1', text: 'ap-northeast-1 Tokyo'  },
{ value: 'ap-northeast-2', text: 'ap-northeast-2 Seoul'  },
{ value: 'ap-northeast-3', text: 'ap-northeast-3 Osaka'  },
{ value: 'ap-south-1', text: 'ap-south-1 Mumbai'  },
{ value: 'ap-south-2', text: 'ap-south-2 Hyderabad'  },
{ value: 'ap-southeast-1', text: 'ap-southeast-1 Singapore'  },
{ value: 'ap-southeast-2', text: 'ap-southeast-2 Sydney'  },
{ value: 'ap-southeast-3', text: 'ap-southeast-3 Jakarta'  },
{ value: 'ap-southeast-4', text: 'ap-southeast-4 Melbourne'  },
{ value: 'ap-southeast-5', text: 'ap-southeast-5 Malaysia'  },
{ value: 'ap-southeast-6', text: 'ap-southeast-6 New Zealand'  },
{ value: 'ap-southeast-7', text: 'ap-southeast-7 Thailand'  },
{ value: 'ca-central-1', text: 'ca-central-1 Canada' },
{ value: 'ca-west-1', text: 'ca-west-1 Calgary' },
{ value: 'eu-central-1', text: 'eu-central-1 Frankfurt'  },
{ value: 'eu-central-2', text: 'eu-central-2 Zurich'  },
{ value: 'eu-north-1', text: 'eu-north-1 Stockholm'  },
{ value: 'eu-south-1', text: 'eu-south-1 Milan'  },
{ value: 'eu-south-2', text: 'eu-south-2 Spain'  },
{ value: 'eu-west-1', text: 'eu-west-1 Ireland' },
{ value: 'eu-west-2', text: 'eu-west-2 London'  },
{ value: 'eu-west-3', text: 'eu-west-3 Paris'  },
{ value: 'il-central-1', text: 'il-central-1 Tel Aviv'  },
{ value: 'me-central-1', text: 'me-central-1 UAE'  },
{ value: 'me-south-1', text: 'me-south-1 Bahrain'  },
{ value: 'mx-central-1', text: 'mx-central-1 Mexico'  },
{ value: 'sa-east-1', text: 'sa-east-1 Sao Paulo' },
{ value: 'us-east-1', text: 'us-east-1 N.Virginia' },
{ value: 'us-east-2', text: 'us-east-2 Ohio'  },
{ value: 'us-gov-east-1', text: 'us-gov-east-1 GovCloud US-East'  },
{ value: 'us-gov-west-1', text: 'us-gov-west-1 GovCloud US-West'  },
{ value: 'us-west-1', text: 'us-west-1 N.California'  },
{ value: 'us-west-2', text: 'us-west-2 Oregon'  }
      ],
      regionInfo: {region: "us-east-1", lastUpdate: "August 2, 2022"},
      showRAC: false,
      showOptCPU: false,
      instanceMetrics: "all",
      instances: "1",
      instancenums: "",
      instanceChoices: [
          { value: 'all', text: 'Display metrics for Entire Cluster' }
      ],
      genItems: [{ name: "Retrieving Data..." }],
      gen_platform: "",
      gen_dbcsi_script: "",
      gen_cpu_core_count: "",
      gen_db_size: "",
      batchItems: [ {VERSION: "19", PLATFORM_NAME: "Linux_x86_64-bit", IS_PDB: "NO", "Exadata": "No", IOPS:"0", SmartScanEligible:0, StorageIndexSavings:0, Throughput:1000, SE2_Comments: "" } ],
      flatItems: [{ database: "to be computed..." } ],
      IS_PDB: "",
      hosts: "",
      blended_cpu1: "",
      blended_iops1: "",
      blended_iomb1: "",
      IS_EXADATA: false,
      AIX_CPU_ADJUSTMENT: "",
      AIX_CPU_ADJUSTMENT_USED: "",
      count_table: "",
      count_lines_plsql: "",
      NonX86Platform: "",
      alertText: "",
      alertTextNonX86: "",
      alertTextPrint: "",
      alertStyle: "default",
      alertStylePrint: "default",
      deleteMessage: "",
      currentEmployee: false,
      showBeta: true,
      showCollapse: true,
      showMax: false,
      showAIX: false,
      showReflines: true,      
      showReflinesCPU: true, 
      showHostCPU: false,
      showSizing: false,
      showCollapseGeneral: true,
      showCollapseIOPS: false,
      showCollapseIOMB: false,
      showCollapseSummary: false,      
      showCollapseBackup: false,
      showCollapseDiskSpace: false,
      showCollapseCPU: false,
      showCollapseSessions: false,
      showCollapseMemory: false,
      showCollapseExa: false,
      showCollapseAdhoc: false,
      showCollapseEC2: false,
      showCollapseEC2FSXN: false,
      showCollapseMap: false,
      showCollapseMapOverview: false,
      showCollapseRDS: false,
      showCollapseAurora: false,
      showAlertNonX86: false,
      showPDBalert: false,
      showchart1: false,
      showReflineschart1: true, 
      chart1_instances: "all",
      chart1_metric1: "cpu_per_s",
      chart1_metric2: "cpu_per_s_max",
      chart1_type: "single",
      chart1_group: "MAIN_METRICS",
      showchart2: false,
      chart2_instances: "all",
      chart2_metric1: "cpu_per_s",
      chart2_metric2: "cpu_per_s_max",
      chart2_type: "single",
      chart2_group: "MAIN_METRICS",
      showReflineschart2: true, 
      showchart3: false,
      chart3_instances: "all",
      chart3_metric1: "cpu_per_s",
      chart3_metric2: "cpu_per_s_max",
      chart3_type: "single",
      chart3_group: "MAIN_METRICS",
      showReflineschart3: true, 
      showchart4: false,
      chart4_instances: "all",
      chart4_metric1: "cpu_per_s",
      chart4_metric2: "cpu_per_s_max",
      chart4_type: "single",
      chart4_group: "MAIN_METRICS",
      showReflineschart4: true, 
      chart_columns: [
          { metric_group: 'MAIN_METRICS', metric_name: 'aas', metric_title: 'Average Active Sessions', metric_units: ''}
        ],
      column_lov: [
          { value: 'aas', text: 'Average Active Sessions' }
      ],
      column_lov1: [
          { value: 'aas', text: 'Average Active Sessions' }
      ],
      column_lov2: [
          { value: 'aas', text: 'Average Active Sessions' }
      ],
      column_lov3: [
          { value: 'aas', text: 'Average Active Sessions' }
      ],
      column_lov4: [
          { value: 'aas', text: 'Average Active Sessions' }
      ],
      
      form: {
        cpu_algo: "cpu3",
        cpu_thread_ratio: "1.00",
        diskspace_algo: "disk1_plus15",
        iops_algo: "iops5",
        iomb_algo: "iomb5",
        memory_algo: "mem2_plus20_2",
        ebs_algo: "ebs1",
        rds_algo: "ee",
        tshape_algo: "N",
        nvme_shape_algo: "N",
        optgoal_algo: "min_cost",
        savedtargets_algo: "targ1",
        platform_algo: "plat1",
        aurora_algo: "auro2",
        smartscan_algo: "ss2",
        smartscan_minimum: "500",
        exa_memory_algo: "em1",
        pdb_algo: "pdb2",
        useRI_algo: "RI",
        ec2fsxn_algo: "N",
        ec2fsxn_baremetal_ranking: "minimumCores",
        ec2fsxn_corefactor: "negativeguess",
        ec2fsxn_shape_scope: "all",
        ec2fsxn_fsxn_generation: "auto",
        ec2fsxn_fsxn_max_filesystems: "4",
        bursting_algo: "Y",
        ec2fsxn_baremetal_HA: "single",
        aix_algo: "new"
      },
      suggestions: {
        VCPU: "",
        Memory: "",
        DiskSpace: "",
        IOPS: "", 
        Throughput: "",
        VolumeType: "",
        UseMAZ: "",
        TargetPlatform: "",
        Comments: ""        
      },
      sortBy: "LinuxOD",
      rdssortBy: "OracleOD",
      aurorasortBy: "AuroraPGOD",      
      ec2: {
        VCPU: "",
        Memory: "",
        Throughput: ""
      },
      ec2extras: {
        CPU_src: "",
        CPU_src_specint: "",
        VCPU_adj_other: "",
        ec2_shape: "",
        rds_shape: "",
        aurora_shape: "",
        aurora_flavor: ""
      },
      ebs: {
        DiskSpace: "",
        DiskSpace_src: "",
        DiskSpace_adj_other: "",
        IOPS: "",
        Backup: "0",
        VolumeType: "gp2",
        SnapshotDays: "",
        BackupType: "none",
        aurora_IOPS_write_adj: "",
        aurora_IOPS_peak_adj: "",
        aurora_IOPS_adj: ""
      },
      config: {
        targetconfig_rds: {}
      },
      UseMAZ: "No",
      selected: [],
      ec2fsxnSelected: [],
      rdsSelected: [],
      auroraSelected: [],
      currentPage: 1,
      perPage: 6,
      currentPageRDS: 1,
      currentPageAurora: 1,      
      fields: [
        {Name: {
          label: "Name",
          sortable: true
        }},
        {VCPU: {
          label: "VCPU",
          sortable: true
        }},
        {Memory: {
          label: "Memory",
          sortable: true
        }},
        {Throughput: {
          label: "Throughput",
          sortable: true
        }},
        {IOPS: {
          label: "IOPS",
          sortable: true
        }},
        {LinuxOD: {
          label: "On-Demand $/hour",
          sortable: true
        }},
        {Linux1yrNURI: {
          label: "1Year Reserved $/hour",
          sortable: true
        }},
        {show_details: {
          label: "Show Details",
          sortable: false
        }}
      ],
      ec2fsxnfields: [
        {Name: {
          label: "Name",
          sortable: true
        }},
        {VCPU: {
          label: "VCPU",
          sortable: true
        }},
        {OracleCoreFactor: {
          label: "Core Factor?",
          sortable: true
        }},
        {Geekbench5CoreScoreRounded: {
          label: "Single Core Benchmark",
          sortable: true
        }},
        {Memory: {
          label: "Memory",
          sortable: true
        }},
        {Network: {
          label: "Network Throughput",
          sortable: true
        }},
        {IOPS: {
          label: "IOPS",
          sortable: true
        }},
        {LinuxOD: {
          label: "On-Demand $/hour",
          sortable: true
        }},
        {Linux1yrNURI: {
          label: "1Year Reserved $/hour",
          sortable: true
        }}
      ],
      items: [
        {
          Name: "r4.16xlarge",
          VCPU: 64,
          Memory: 488.0,
          Throughput: 1750.0,
          LinuxOD: 4.256,
          Linux1yrNURI: 2.688,
          Processor: "Intel Xeon E5-2686 v4 (Broadwell)",
          Clockspeed: "2.3 GHz",
          InstanceStorage: "EBS only",
          vCPU_Details: "64 vCPUs",
          OptimizeCores: "2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30, 32",
          OptimizeVCPUs: "4, 8, 12, 16, 20, 24, 28, 32, 36, 40, 44, 48, 52, 56, 60, 64"
        }
      ],

      rdsItems: [
        {
          Name: "db.r4.16xlarge",
          VCPU: 64,
          Memory: 488.0,
          Throughput: 1750.0,
          OracleOD: 7.68,
          Oracle1yrNURI: 0.0,
          Processor: "Intel Xeon E5-2686 v4 (Broadwell)",
          Clockspeed: "2.3 GHz",
          vCPU_Details: "64 vCPUs",
          OptimizeCores: "2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30, 32",
          OptimizeVCPUs: "4, 8, 12, 16, 20, 24, 28, 32, 36, 40, 44, 48, 52, 56, 60, 64"
        }
      ],
      auroraItems: [
        {
          Name: "db.r4.16xlarge",
          VCPU: 64,
          Memory: 488.0,
          Throughput: 1750.0,
          AuroraPGOD: 9.28,
          AuroraPG1yrNURI: 6.04,
          Processor: "Intel Xeon E5-2686 v4 (Broadwell)",
          Clockspeed: "2.3 GHz",
          vCPU_Details: "64 vCPUs"
        }
      ]

    };
  },
  methods: {
    async showCalculateMessage(value) {
      // console.log('show calculate message',value);
      // this.showAlertRecalc = false;
      // this.showCalculateMessageFlag = true;
    },  
    
    changeAdhocMetricGroup1(value) {
      this.showchart1=false;
      this.column_lov1 = [];
      for (var iii = 0; iii < this.chart_columns.length ; iii++) {
        // console.log(iii, this.chart_columns[iii].metric_name);
        if (this.chart_columns[iii].metric_group==value) {
          this.column_lov1.push({ value: this.chart_columns[iii].metric_name, text: this.chart_columns[iii].metric_title + (this.chart_columns[iii].metric_units ? ' ('+this.chart_columns[iii].metric_units+')' : '') , metric_group:this.chart_columns[iii].metric_group} );
        }  
      }
    },
    changeAdhocMetricGroup2(value) {
      this.showchart2=false;
      this.column_lov2 = [];
      for (var iii = 0; iii < this.chart_columns.length ; iii++) {
        // console.log(iii, this.chart_columns[iii].metric_name);
        if (this.chart_columns[iii].metric_group==value) {
          this.column_lov2.push({ value: this.chart_columns[iii].metric_name, text: this.chart_columns[iii].metric_title + (this.chart_columns[iii].metric_units ? ' ('+this.chart_columns[iii].metric_units+')' : '') , metric_group:this.chart_columns[iii].metric_group} );
        }  
      }
    },
    changeAdhocMetricGroup3(value) {
      this.showchart3=false;
      this.column_lov3 = [];
      for (var iii = 0; iii < this.chart_columns.length ; iii++) {
        // console.log(iii, this.chart_columns[iii].metric_name);
        if (this.chart_columns[iii].metric_group==value) {
          this.column_lov3.push({ value: this.chart_columns[iii].metric_name, text: this.chart_columns[iii].metric_title + (this.chart_columns[iii].metric_units ? ' ('+this.chart_columns[iii].metric_units+')' : '') , metric_group:this.chart_columns[iii].metric_group} );
        }  
      }
    },
    changeAdhocMetricGroup4(value) {
      this.showchart4=false;
      this.column_lov4 = [];
      for (var iii = 0; iii < this.chart_columns.length ; iii++) {
        // console.log(iii, this.chart_columns[iii].metric_name);
        if (this.chart_columns[iii].metric_group==value) {
          this.column_lov4.push({ value: this.chart_columns[iii].metric_name, text: this.chart_columns[iii].metric_title + (this.chart_columns[iii].metric_units ? ' ('+this.chart_columns[iii].metric_units+')' : '') , metric_group:this.chart_columns[iii].metric_group} );
        }  
      }
    },
    
    changeAdhocMetricGroupAll(value) {
      this.showchart1=false;
      this.showchart2=false;
      this.showchart3=false;
      this.showchart4=false;
      this.showCollapseIOPS=false;
      this.showCollapseIOMB=false;
      this.showCollapseBackup=false;
      this.showCollapseDiskSpace=false;
      this.showCollapseCPU=false;
      this.showCollapseSessions=false;
      this.showCollapseMemory=false;
      this.showCollapseExa=false;
    },  
    
    
    async changeRegion(value) {
      // console.log('changeRegion',value);
      // this.showAlertRecalc = false;
      // this.showCalculateMessageFlag = true;
      this.selected=[];
      this.ec2extras.ec2_shape=null;
      this.ec2fsxnSelected=[];
      this.ec2extras.ec2fsxn_shape=null;
      
      this.rdsSelected=[];
      this.ec2extras.rds_shape=null;
      this.auroraSelected=[];
      this.ec2extras.aurora_shape=null;
      this.regionCode=value;
      
    // now load Region info
      await axios
        .get("/db-"+value+".json")
        .then(response => {
          // console.log("I am here4");
          this.regionInfo = response.data;
        
      })
        .catch(error => {
          console.log("Metrics-Load regionInfo data Error:", error);
      });

    // copy into EC2 info
    this.items = JSON.parse(JSON.stringify(this.regionInfo.shapes));

    //now filter and sort
    this.items = this.items.filter(value => value.LinuxOD*1 > 0);
    
    function ec2CompareCost(a, b) {
      // Use toUpperCase() to ignore character casing
      const itemA = older_generation_cost_adjustment((a.Linux1yrNURI * 1 > 0 ? a.Linux1yrNURI*1 : a.LinuxOD*1), a) * 1000 + a.VCPU*1;
      const itemB = older_generation_cost_adjustment((b.Linux1yrNURI * 1 > 0 ? b.Linux1yrNURI*1 : b.LinuxOD*1), b) * 1000 + b.VCPU*1;

      let comparison = 0;
      if (itemA > itemB) {
        comparison = 1;
      } else if (itemA < itemB) {
        comparison = -1;
      }
      return comparison;
    }
    
    function ec2CompareVCPU(a, b) {
      // Use toUpperCase() to ignore character casing
      const itemA = a.VCPU * 10000 + older_generation_cost_adjustment((a.Linux1yrNURI * 1 > 0 ? a.Linux1yrNURI*1 : a.LinuxOD*1), a);
      const itemB = b.VCPU * 10000 + older_generation_cost_adjustment((b.Linux1yrNURI * 1 > 0 ? b.Linux1yrNURI*1 : b.LinuxOD*1), b);

      let comparison = 0;
      if (itemA > itemB) {
        comparison = 1;
      } else if (itemA < itemB) {
        comparison = -1;
      }
      return comparison;
    }
    
    //if optgoal_algo is min_cost, sort by cost, then VCPU.  if optgoal_algo is min_license, sort by VCPU, then cost
    if (this.form.optgoal_algo=="min_license") {
      this.items.sort(ec2CompareVCPU);
      // console.log("sort by VCPU");
    } else  {
      this.items.sort(ec2CompareCost);
      // console.log("sort by Cost");
    }  
    
        if (
          typeof this.ec2extras.ec2_shape != "undefined" &&
          this.ec2extras.ec2_shape != null
        ) {
          // console.log("reseting ec2_shape to " + this.ec2extras.ec2_shape);
          // get matching data from items
          // first find what item this is by name
          for (var ii = 0; ii < this.items.length; ii++) {
            if (this.items[ii].Name == this.ec2extras.ec2_shape) {
              this.selected[0] = this.items[ii];
              break;
            }
          }
          
        }

    // now load RDS info
    this.rdsItems = JSON.parse(JSON.stringify(this.regionInfo.shapes));

    //now filter and sort
    //for now, hide all tpc1 shapes until someone convinces me otherwise 
    this.rdsItems = this.rdsItems.filter(value => (value.OracleOD*1 > 0) && !(value.Name.includes('tpc1')) );
    
         function rdsCompareCost(a, b) {
          // Use toUpperCase() to ignore character casing
          const itemA = older_generation_cost_adjustment((a.Oracle1yrNURI * 1 > 0 ? a.Oracle1yrNURI*1 : a.OracleOD*1), a) * 1000 + a.VCPU*1;
          const itemB = older_generation_cost_adjustment((b.Oracle1yrNURI * 1 > 0 ? b.Oracle1yrNURI*1 : b.OracleOD*1), b) * 1000 + b.VCPU*1;

          let comparison = 0;
          if (itemA > itemB) {
            comparison = 1;
          } else if (itemA < itemB) {
            comparison = -1;
          }
          return comparison;
        }

        function rdsCompareVCPU(a, b) {
          // Use toUpperCase() to ignore character casing
          const itemA = a.VCPU * 10000 + older_generation_cost_adjustment((a.Oracle1yrNURI * 1 > 0 ? a.Oracle1yrNURI*1 : a.OracleOD*1), a);
          const itemB = b.VCPU * 10000 + older_generation_cost_adjustment((b.Oracle1yrNURI * 1 > 0 ? b.Oracle1yrNURI*1 : b.OracleOD*1), b);

          let comparison = 0;
          if (itemA > itemB) {
            comparison = 1;
          } else if (itemA < itemB) {
            comparison = -1;
          }
          return comparison;
        }
        
      //if optgoal_algo is min_cost, sort by cost, then VCPU.  if optgoal_algo is min_license, sort by VCPU, then cost
      if (this.form.optgoal_algo=="min_license") {
        this.rdsItems.sort(rdsCompareVCPU);
        // console.log("sort by VCPU");
      } else  {
        this.rdsItems.sort(rdsCompareCost);
        // console.log("sort by Cost");
      }  
   
      // now reset the selected rds shape if needed
      if (
        typeof this.ec2extras.rds_shape != "undefined" &&
        this.ec2extras.rds_shape != null
      ) {
        // console.log("reseting rds_shape to " + this.ec2extras.rds_shape);
        // get matching data from items
        // first find what item this is by name
        
        for (var ii = 0; ii < this.rdsItems.length; ii++) {
          if (this.rdsItems[ii].Name == this.ec2extras.rds_shape) {
            this.rdsSelected[0] = this.rdsItems[ii];
            break;
          }
        }

      }


    // now load Aurora info
    this.auroraItems = JSON.parse(JSON.stringify(this.regionInfo.shapes));

    //now filter and sort
    this.auroraItems = this.auroraItems.filter(value => value.AuroraPGOD*1 > 0);
    
    
     for (var ii = 0; ii < this.auroraItems.length; ii++) {
        this.auroraItems[ii].NetworkThroughput = this.auroraItems[ii].Network/8;
      }

    // now reset the selected aurora shape if needed
    if (
      typeof this.ec2extras.aurora_shape != "undefined" &&
      this.ec2extras.aurora_shape != null
    ) {
      // console.log("reseting aurora_shape to " + this.ec2extras.aurora_shape);
      // get matching data from items
      // first find what item this is by name
      for (var ii = 0; ii < this.auroraItems.length; ii++) {
        if (this.auroraItems[ii].Name == this.ec2extras.aurora_shape) {
          this.auroraSelected[0] = this.auroraItems[ii];
          break;
        }
      }
      
    }
  
      
    },  

    check: function(e) {
      // console.log("here", this.showReflines,e);
      if (e == "ALL") {
        this.showCollapseCPU = false;
        this.showCollapseIOPS = false;
        this.showCollapseIOMB = false;
        this.showCollapseMemory = false;
      } else if (e == "CPU") {
        this.showCollapseCPU = false;
      } else {
        this.showCollapseIOPS = false;
        this.showCollapseIOMB = false;
      }  
    },
    autosuggest: async function(e) {
      // console.log("here", this.showReflines,e);
      let displaymsg = "Calculating Targets... Please wait...";
      if  (e == "CPU") {
        this.suggestions.VCPU = displaymsg;
      } else if (e == "MEMORY") {
        this.suggestions.Memory = displaymsg;
      } else if (e == "IOPS") {
        this.suggestions.IOPS = displaymsg;
      } else if (e == "IOMB") {
        this.suggestions.Throughput = displaymsg;
      } else if (e == "DiskSpace") {
        this.suggestions.DiskSpace = displaymsg;
      }  
      
      var batchParams = {
        body: {
          batchRow: 0,
          prefs: this.form
        }
      };

      //save orig comments from additional_data
      var cpu_target_comments = this.batchItems[0].additional_datapoints.cpu_target_comments;
      var memory_target_comments = this.batchItems[0].additional_datapoints.memory_target_comments;
      var iops_target_comments = this.batchItems[0].additional_datapoints.iops_target_comments;
      var iomb_target_comments = this.batchItems[0].additional_datapoints.iomb_target_comments;

      //clear out orig comments? (to avoid duplicates?)
      //I am try to prevent duplicated comments every time you re-calculate_target_values
      //I want to keep the original comment from additional_data.

      // this.batchItems[0].additional_datapoints.cpu_target_comments = '';
      // this.batchItems[0].additional_datapoints.memory_target_comments = '';
      // this.batchItems[0].additional_datapoints.iops_target_comments = '';
      // this.batchItems[0].additional_datapoints.iomb_target_comments = '';
      
      
      batchParams.body.inputs = this.batchItems[0].additional_datapoints;
      if (this.AIX_CPU_ADJUSTMENT*1>0) {
        batchParams.body.inputs.AIX_CPU_ADJUSTMENT = this.AIX_CPU_ADJUSTMENT;
      }
      
            var response = {
              data: ""
            };
            
            // console.log("pre calc", batchParams.body.inputs);
            response.data = calculate_target_values(batchParams);
            // console.log("2-CDB IOMB IOPS VCPU EXA IOMB", response.data.CDB_IOMB, response.data.CDB_IOPS, response.data.CDB_VCPU, response.data.DB_EXA_CELL_BYTES_ELIG_MB_P99, response.data.DB_IOMB_AVERAGE_P99 );
  
            // console.log('sugg0', response.data.iops_target_comments);
            // console.log("post calc", response.data);
      
          //console.log("Metrics- recalc_targets: put success");
          //TODO: capture Comments and display it?
          this.suggestions.VCPU=response.data.VCPU;
          this.suggestions.Memory=response.data.Memory;
          this.suggestions.DiskSpace=response.data.DiskSpace;
          this.suggestions.IOPS=response.data.IOPS;
          this.suggestions.Throughput=response.data.Throughput;
          this.suggestions.TargetPlatform=response.data.TargetPlatform;
          this.suggestions.UseMAZ=response.data.UseMAZ;
          this.suggestions.Comments=response.data.Comments;
          this.suggestions.VolumeType=response.data.VolumeType;

                // add/overwrite things being returned by additional_datapoints
                this.batchItems[0].VCPU=response.data.VCPU;
                this.batchItems[0].OrigVCPU=response.data.VCPU;
                this.batchItems[0].Memory=response.data.Memory;
                this.batchItems[0].DiskSpace=response.data.DiskSpace;
                this.batchItems[0].IOPS=response.data.IOPS;
                this.batchItems[0].Throughput=response.data.Throughput;
                this.batchItems[0].OrigThroughput=response.data.OrigThroughput;
                this.batchItems[0].OrigIOPS=response.data.OrigIOPS;
                this.batchItems[0].TargetPlatform=response.data.TargetPlatform;

                this.UseMAZ = response.data.UseMAZ;
                
                this.batchItems[0].UseMAZ=response.data.UseMAZ;
                this.batchItems[0].UseRI=response.data.UseRI;
                this.batchItems[0].optgoal_choice=response.data.optgoal_choice;
                this.batchItems[0].cpu_thread_ratio=response.data.cpu_thread_ratio;
                // this.batchItems[0].pdb_algo=response.data.pdb_algo;
                // this.batchItems[0].smartscan_algo=response.data.smartscan_algo;
                // this.batchItems[0].smartscan_minimum=response.data.smartscan_minimum;
                // this.batchItems[0].nvme_shape_algo=response.data.nvme_shape_algo;
                // this.batchItems[0].tshape_algo=response.data.tshape_algo;
                

                this.batchItems[0].Comments='';
                this.batchItems[0].cpu_target_comments=response.data.cpu_target_comments;
                this.batchItems[0].iomb_target_comments=response.data.iomb_target_comments;
                this.batchItems[0].iops_target_comments=response.data.iops_target_comments;
                this.batchItems[0].memory_target_comments=response.data.memory_target_comments;
                this.batchItems[0].cdb_target_comments=response.data.cdb_target_comments;
                this.batchItems[0].diskspace_target_comments=response.data.diskspace_target_comments;

                
                this.batchItems[0].CDB_IOPS=response.data.CDB_IOPS;
                this.batchItems[0].CDB_DBID=response.data.CDB_DBID;
                this.batchItems[0].CDB_IOMB=response.data.CDB_IOMB;
                this.batchItems[0].CDB_VCPU=response.data.CDB_VCPU;
                this.batchItems[0].CDB_collectionId=response.data.CDB_collectionId;
                
                this.batchItems[0].VolumeType=response.data.VolumeType;
                this.batchItems[0].SmartScanEligible=response.data.DB_EXA_CELL_BYTES_ELIG_MB_P99;
                this.batchItems[0].StorageIndexSavings=response.data.DB_EXA_CELL_SI_SAVE_MB_P99;
                this.batchItems[0].ThroughputMaxAverage=response.data.DB_IOMB_AVERAGE_P99;
                this.batchItems[0].ExadataAdjustmentText=response.data.ExadataAdjustmentText;                
                this.batchItems[0].ExadataAdjustment=response.data.ExadataAdjustment;                
                this.batchItems[0].ExadataVCPUAdjustmentText=response.data.ExadataVCPUAdjustmentText;                
                this.batchItems[0].UseSE2=response.data.UseSE2;   
                
                this.AIX_CPU_ADJUSTMENT_USED = response.data.AIX_CPU_ADJUSTMENT_USED;

          this.suggestions.cpu_target_comments = response.data.cpu_target_comments;
          this.suggestions.memory_target_comments = response.data.memory_target_comments;
          this.suggestions.iops_target_comments = response.data.iops_target_comments;
          this.suggestions.iomb_target_comments = response.data.iomb_target_comments;
          // console.log('sugg1', this.suggestions.iops_target_comments);

          // reset additional data comments
      this.batchItems[0].additional_datapoints.cpu_target_comments = cpu_target_comments;
      this.batchItems[0].additional_datapoints.memory_target_comments = memory_target_comments;
      this.batchItems[0].additional_datapoints.iops_target_comments = iops_target_comments;
      this.batchItems[0].additional_datapoints.iomb_target_comments = iomb_target_comments;

      // console.log('sugg2', this.suggestions.iops_target_comments);
    },
    
    

    
    rowSelected(items) {
      this.selected = items;
      if (this.selected.length > 0) {
        this.ec2extras.ec2_shape = this.selected[0].Name;
      } else {
        this.ec2extras.ec2_shape = null;
      }
    },
    ec2fsxnRowSelected(items) {
      this.ec2fsxnSelected = items;
      if (this.ec2fsxnSelected.length > 0) {
        this.ec2extras.ec2fsxn_shape = this.ec2fsxnSelected[0].Name;
        this.form.ec2fsxn_algo='Y';
      } else {
        this.ec2extras.ec2fsxn_shape = null;
      }
    },
    rdsRowSelected(items) {
      this.rdsSelected = items;
      if (this.rdsSelected.length > 0) {
        this.ec2extras.rds_shape = this.rdsSelected[0].Name;
      } else {
        this.ec2extras.rds_shape = null;
      }
    },
    auroraRowSelected(items) {
      this.auroraSelected = items;
      if (this.auroraSelected.length > 0) {
        this.ec2extras.aurora_shape = this.auroraSelected[0].Name;
      } else {
        this.ec2extras.aurora_shape = null;
      }
    },
    resetDeleteModal() {
          this.deleteMessage = "";
    },
    
    async deleteCollection(evt) {
      evt.preventDefault();
      this.deleteMessage = "Deleting database.  Please wait as this may take a bit...";
      // this.alertStyle="primary"
      // this.alertText = "Saving Sizing Output to Database... Please wait...";
      // this.showAlert = true;

      //   console.log("deleteCollection: I am here1");
      var tries = 5;
      var success = true;
      // while (tries > 0) {
      //   this.deleteMessage += ".";
      //   await API.get("dbcsiAPI", `/dbcsi/collections`)
      //     .then(response => {
      //       // console.log("Add: Aurora is ready");
      //       //   this.collection_list = response.data;
      //       tries = 0;
      //       success = true;
      //     })
      //     .catch(error => {
      //       console.log(
      //         "Metrics.vue API Error (Aurora asleep? can retry):",
      //         error
      //       );
      //     console.log("Will retry.  Attempts Left:", (tries-1));
      //     });

      //   tries -= 1;
      // }
      if (success) {
        console.log("Metrics- deleteCollection: Calling collection delete API");
        //do a delete to /:collection_id
        
        if (this.batchItems[0].CONSOLIDATED_DATABASES*1>0) {
          var local_batch_id=this.batchItems[0].batchID;
          console.log("This is a consolidated database.  Deleting corresponding batch:", local_batch_id);
          await API.del(
            "dbcsiAPI",
            `/dbcsi/batch/${local_batch_id}`
          );
        }
        
        await API.del(
          "dbcsiAPI",
          `/dbcsi/${this.collection_id}`
        )
          .then(response => {
            success = response.success;
            if (success) {
              this.deleteMessage = "Database deleted.";
              console.log("Metrics- deleteCollection: delete success");
            } else {
            console.log("Metrics- deleteCollection.delete Error:", response.data.reason);
              this.deleteMessage = "ERROR: " + response.data.reason;
            }
          })
          .catch(error => {
            console.log("Metrics- deleteCollection.delete Error:", error);
              // this.alertText = "Error while deleting: "+error;
              // this.alertStyle="danger"
            this.deleteMessage = "Database unable to be deleted.  Please try again.";   
              success=false;
          });
        } 
        // if (success) {
        // this.alertText = "Saving Sizing Output to Database Finished.";
        // this.alertStyle="success";
        // }
        console.log("Metrics- deleteCollection: done");
        if (success) {
          this.$router.push('/') ;
        }  
        console.log("Metrics- deleteCollection: done2");
    },
    async shareDatabases(theItem) {
      // console.log("shareDatabases", theItem.collectionID);

      this.generatedSharingURL = '';
      

      var batchParams = {
        body: {
          batchID: this.batch_id
        }
      };
      

      await API.put(
        "dbcsiAPI",
        `/dbcsi/shareURL`,
        batchParams
      )
        .then(response => {
          // success = true;
          // console.log("Batch- shareDatabases: put success");
            // this.alertText = "Saving Sizing Output to Database... Saved "+groupi+" of "+num_items;
            this.generatedSharingURL=response.data.generatedSharingURL;
        })
        .catch(error => {
          console.log("Batch- shareDatabases:", error);
            this.generatedSharingURL = "Error while saving: "+error;
            // this.alertStyle="danger";
            // success=false;
        });
      
    },

    async onSubmit(evt) {
      evt.preventDefault();
      // console.log("Add: I am here1");
      
      var tries = 0;
      var success = true;
      while (tries > 0) {
        await API.get("dbcsiAPI", `/dbcsi/collections`)
          .then(response => {
            // console.log("Add: Aurora is ready");
            //   this.collection_list = response.data;
            tries = 0;
            success = true;
          })
          .catch(error => {
            console.log(
              "Metrics.vue API Error (Aurora asleep? can retry):",
              error
            );
            console.log("Will retry.  Attempts Left:", (tries-1));
          });

        tries -= 1;
      }
      
      // get latest description
      // console.log("Metrics- Submit: Saving data0");
      let new_description = "";
      let new_database = "";
      for (var ii = 0; ii < this.genItems.length; ii++) {
           // console.log("ii", ii, this.genItems[ii]);
            //is this PLATFORM_NAME
            if (this.genItems[ii].name == "DESCRIPTION") {
              // console.log("Description:", this.genItems[ii].value);
              new_description = this.genItems[ii].value;
            }
            if (this.genItems[ii].name == "DATABASE") {
              // console.log("Description:", this.genItems[ii].value);
              new_database = this.genItems[ii].value;
            }
      }     
      
      // console.log("Metrics- Submit: Saving data2");
      
      if (success) {
        // console.log("Add: I am here4");
        //do a put to /collections/collection_id/reviewComments
        const putParams = {
          body: {
            review_comments: {
              comments: this.comments,
              ec2: this.ec2,
              ebs: this.ebs,
              ec2extras: this.ec2extras
            },
            description: new_description,
            database: new_database           
          }
        };
        
        console.log("Metrics- Submit: Saving data");

        await API.put(
          "dbcsiAPI",
          `/dbcsi/${this.collection_id}/${
            this.collection_type
          }/reviewComments`,
          putParams
        )
          .then(response => {
            success = true;
            // console.log("Metrics- ReviewComments: new collection_id=", new_id);
          })
          .catch(error => {
            console.log("Metrics- ReviewComments.put Error:", error);
          });
      }
    },
    onReset(evt) {
      evt.preventDefault();

    }
  },
  watch: {
    // default sort column for the RDS / Aurora shape tables follows the pricing option
    'form.rds_algo': {
      immediate: true,
      handler(rds_algo) {
        if (rds_algo=="ee") this.rdssortBy = "OracleOD";
        if (rds_algo=="se") this.rdssortBy =  "OracleLIse2_OD";
        if (rds_algo=="custom") this.rdssortBy =  "OracleCustomOD";
        if (rds_algo=="rac") this.rdssortBy =  "OracleOD";
      }
    },
    'form.aurora_algo': {
      immediate: true,
      handler(aurora_algo) {
        this.aurorasortBy = (aurora_algo=="auro5") ? "AuroraPGOptimOD" : "AuroraPGOD";
      }
    }
  },
  computed: {
    batch_id() {
      return 'C'+this.collection_id;
    },
    instanceLabel() {
      if (this.instanceMetrics=='all') {
        return '';
      } else {
        return '- Instance#'+this.instanceMetrics;
      }
    },
    aurora_calculated_iops() {
       return this.aurora_8k_iops_pre/this.ebs.aurora_IOPS_peak_adj*this.ebs.aurora_IOPS_write_adj;
    },
    aurora_8k_iops_pre() {
      return this.ec2.Throughput*1024/8;
    },
    filtered() {
      const filtered = this.items.filter(item => ( (item.VCPU >= this.ec2.VCPU*1) && (item.Memory >= this.ec2.Memory*1) && (item.Throughput >= this.ec2.Throughput*1) && (item.IOPS >= this.ebs.IOPS*1)) );
      return filtered;
    },
    ec2fsxnfiltered() {
      // console.log("here");
      // no EBS IOPS check: storage IO goes to FSx-OnTap over the EC2 network, not EBS
      var ec2fsxnfiltered = this.items.filter(item => ( (item.VCPU >= this.ec2.VCPU*1) && (item.Memory >= this.ec2.Memory*1) && (((this.form.bursting_algo=="N" && item.BaselineNetwork*1>0) ? item.BaselineNetwork : item.Network)/8 >= this.ec2.Throughput*1) && !(/[0-9]g/.test((item.Name||"").split('.')[0])) && (this.form.ec2fsxn_shape_scope=="all" ? item.LinuxOD*1>0 : item.OracleCoreFactor*1>0)) );
      // var rdsfiltered = this.rdsItems.filter(item => {
      //   return Object.keys(this.ec2).every(
      //     key => item[key] >= this.ec2[key]
      //     // String(item[key]).includes(this.ec2[key])
      //   );
      // });
      // rdsfiltered = rdsfiltered.filter(item => ( (item.IOPS >= this.ebs.IOPS*1) ) );
      return ec2fsxnfiltered;
    },
    rdsfiltered() {
      // console.log("here");
      var rdsfiltered = this.rdsItems.filter(item => ( (item.VCPU >= this.ec2.VCPU*1) && (item.Memory >= this.ec2.Memory*1) && (item.Throughput >= this.ec2.Throughput*1) && (item.IOPS >= this.ebs.IOPS*1)) );
      // var rdsfiltered = this.rdsItems.filter(item => {
      //   return Object.keys(this.ec2).every(
      //     key => item[key] >= this.ec2[key]
      //     // String(item[key]).includes(this.ec2[key])
      //   );
      // });
      // rdsfiltered = rdsfiltered.filter(item => ( (item.IOPS >= this.ebs.IOPS*1) ) );
      
      var shape_list = JSON.parse(JSON.stringify(rdsfiltered));
      var filter_shape_list = [];
      if (this.form.rds_algo=="ee") filter_shape_list= shape_list.filter(value => (value.OracleOD*1 > 0) && !(value.Name.includes('tpc1')) );
      if (this.form.rds_algo=="se") filter_shape_list= shape_list.filter(value => (value.OracleLIse2_OD*1 > 0) && !(value.Name.includes('tpc1')) );
      if (this.form.rds_algo=="custom") filter_shape_list= shape_list.filter(value => (value.OracleCustomOD*1 > 0) && !(value.Name.includes('tpc1')) );
      if (this.form.rds_algo=="rac") filter_shape_list= shape_list.filter(value => (value.OracleOD*1 > 0) && !(value.Name.includes('tpc')) && 
         ( value.Name.includes('r5.') || value.Name.includes('r5b.') || value.Name.includes('m6i.') || value.Name.includes('r6i.') || value.Name.includes('x2iedn.')  || value.Name.includes('r6in.')) );

      return filter_shape_list;
    },

    rdsfields() {
      var myFields = [
        {Name: {
          label: "Name",
          sortable: true
        }},
        {VCPU: {
          label: "VCPU",
          sortable: true
        }},
        {Memory: {
          label: "Memory",
          sortable: true
        }},
        {Throughput: {
          label: "Throughput",
          sortable: true
        }},
        {IOPS: {
          label: "IOPS",
          sortable: true
        }} ];
      if (this.form.rds_algo=="se") {
        myFields.push (  {OracleLIse2_OD: {
            label: "On-Demand $/hour",
            sortable: true
          }},
          {OracleLIse2_1yrNURI: {
            label: "1Year Reserved $/hour",
            sortable: true
          }});
        
      } else if (this.form.rds_algo=="custom") {
        myFields.push ( {OracleCustomOD: {
            label: "On-Demand $/hour",
            sortable: true
          }},
          {OracleCustom1yrNURI: {
            label: "1Year Reserved $/hour",
            sortable: true
          }});
      } else {
        myFields.push (  {OracleOD: {
            label: "On-Demand $/hour",
            sortable: true
          }},
          {Oracle1yrNURI: {
            label: "1Year Reserved $/hour",
            sortable: true
          }},
          {Oracle1yrNUSP: {
            label: "1Year Savings Plan $/hour",
            sortable: true
          }});
      }  
        
       myFields.push (   {show_details: {
          label: "Show Details",
          sortable: false
        }}
       );
      
      return myFields;

    },
    aurorafiltered() {
      const aurorafiltered = this.auroraItems.filter(item => ((item.VCPU >= this.ec2.VCPU*1) && (item.Memory >= this.ec2.Memory*1) && (item.Network/8 >= this.ec2.Throughput*1)));
      return aurorafiltered;
    },

    aurorafields() {
      var myFields = [
        {Name: {
          label: "Name",
          sortable: true
        }},
        {VCPU: {
          label: "VCPU",
          sortable: true
        }},
        {Memory: {
          label: "Memory",
          sortable: true
        }},
        {NetworkThroughput: {
          label: "Network Throughput",
          sortable: true
        }},
        {AuroraPGOD: {
          label: "On-Demand $/hour",
          sortable: true
        }},
        {AuroraPG1yrNURI: {
          label: "1Year Reserved $/hour",
          sortable: true
        }},
        {AuroraPG1yrNUSP: {
          label: "1Year Savings Plan $/hour",
          sortable: true
        }},
        {show_details: {
          label: "Show Details",
          sortable: false
        }}
      ];
      if (this.form.aurora_algo=="auro5") {
        myFields = [
        {Name: {
          label: "Name",
          sortable: true
        }},
        {VCPU: {
          label: "VCPU",
          sortable: true
        }},
        {Memory: {
          label: "Memory",
          sortable: true
        }},
        {NetworkThroughput: {
          label: "Network Throughput",
          sortable: true
        }},
        {AuroraPGOptimOD: {
          label: "IO-Optimized On-Demand $/hour",
          sortable: true
        }},
        {AuroraPG1yrNURI: {
          label: "IO-Optimized 1Year Reserved $/hour",
          sortable: true
        }},
        {AuroraPGOptim1yrNUSP: {
          label: "IO-Optimized 1Year Savings Plan $/hour",
          sortable: true
        }},
        {show_details: {
          label: "Show Details",
          sortable: false
        }}
      ];
        
      } 
        
      
      return myFields;

    },

// **************************
// EC2 Configuration
// **************************
    targetconfig_ec2() {

      var ec2_shape = { Name: null };
      
            // get matching data from items
      // first find what item this is by name
      for (var ii = 0; ii < this.items.length; ii++) {
        if (this.items[ii].Name == this.selected[0].Name) {
          break;
        }
      }
      ec2_shape = this.items[ii];

      var inputConfig = {};
      inputConfig.VCPU = this.ec2.VCPU ;
      inputConfig.Memory = this.ec2.Memory ;
      inputConfig.Throughput = this.ec2.Throughput ;
      inputConfig.DiskSpace = this.ebs.DiskSpace ;
      inputConfig.IOPS = this.ebs.IOPS ;
      inputConfig.VolumeType = this.ebs.VolumeType ;
      inputConfig.BackupType = this.ebs.BackupType ;
      inputConfig.ChangeRate = this.ebs.Backup ;
      inputConfig.SnapshotDays = this.ebs.SnapshotDays ;
      inputConfig.UseMAZ = this.UseMAZ ;
      inputConfig.UseRI = this.form.useRI_algo ;
      inputConfig.UseSE2 = this.UseSE2 ;
      inputConfig.frozen_prefs = JSON.parse(JSON.stringify(this.form));

      
      var myConfig = calculate_ec2_config(this.regionInfo, ec2_shape, inputConfig);
      
      return myConfig.targetconfig_ec2;

    },


// **************************
// EC2  Bare Metal Configuration
// **************************
    targetconfig_ec2fsxn() {

      var ec2_shape = { Name: null };
      
            // get matching data from items
      // first find what item this is by name
      for (var ii = 0; ii < this.items.length; ii++) {
        if (this.items[ii].Name == this.ec2fsxnSelected[0].Name) {
          break;
        }
      }
      ec2_shape = this.items[ii];

      var inputConfig = {};
      inputConfig.VCPU = this.ec2.VCPU ;
      inputConfig.Memory = this.ec2.Memory ;
      inputConfig.Throughput = this.ec2.Throughput ;
      inputConfig.DiskSpace = this.ebs.DiskSpace ;
      inputConfig.IOPS = this.ebs.IOPS ;
      inputConfig.VolumeType = this.ebs.VolumeType ;
      inputConfig.BackupType = this.ebs.BackupType ;
      inputConfig.ChangeRate = this.ebs.Backup ;
      inputConfig.SnapshotDays = this.ebs.SnapshotDays ;
      inputConfig.UseMAZ = this.UseMAZ ;
      inputConfig.UseRI = this.form.useRI_algo ;
      inputConfig.UseSE2 = this.UseSE2 ;
      inputConfig.frozen_prefs = JSON.parse(JSON.stringify(this.form));

      
      var myConfig = calculate_ec2fsxn_config(this.regionInfo, ec2_shape, inputConfig);
      
      return myConfig.targetconfig_ec2fsxn;

    },



// **************************
// RDS Configuration
// **************************
    targetconfig_rds() {
      
      var rds_shape = { Name: null };
      
            // get matching data from items
      // first find what item this is by name
      for (var ii = 0; ii < this.rdsItems.length; ii++) {
        if (this.rdsItems[ii].Name == this.rdsSelected[0].Name) {
          break;
        }
      }
      rds_shape = this.rdsItems[ii];

      var inputConfig = {};
      inputConfig.VCPU = this.ec2.VCPU ;
      inputConfig.Memory = this.ec2.Memory ;
      inputConfig.Throughput = this.ec2.Throughput ;
      inputConfig.DiskSpace = this.ebs.DiskSpace ;
      inputConfig.IOPS = this.ebs.IOPS ;
      inputConfig.VolumeType = this.ebs.VolumeType ;
      inputConfig.BackupType = this.ebs.BackupType ;
      inputConfig.ChangeRate = this.ebs.Backup ;
      inputConfig.SnapshotDays = this.ebs.SnapshotDays ;
      inputConfig.UseMAZ = this.UseMAZ ;
      inputConfig.UseRI = this.form.useRI_algo ;
      inputConfig.optgoal_choice = this.form.optgoal_algo;
      inputConfig.rds_type = this.form.rds_algo;
      inputConfig.UseSE2 = this.UseSE2 ;
      inputConfig.frozen_prefs = JSON.parse(JSON.stringify(this.form));

      
      var myConfig = calculate_rds_config(this.regionInfo, rds_shape, inputConfig);
      
      return myConfig.targetconfig_rds;
      
    },



// **************************
// Aurora Configuration
// **************************
    targetconfig_aurora() {
      
      var aurora_shape = { Name: null };
      
            // get matching data from items
      // first find what item this is by name
      for (var ii = 0; ii < this.auroraItems.length; ii++) {
        if (this.auroraItems[ii].Name == this.auroraSelected[0].Name) {
          break;
        }
      }
      aurora_shape = this.auroraItems[ii];

      var inputConfig = {};
      inputConfig.VCPU = this.ec2.VCPU ;
      inputConfig.Memory = this.ec2.Memory ;
      inputConfig.Throughput = this.ec2.Throughput ;
      inputConfig.DiskSpace = this.ebs.DiskSpace ;
      inputConfig.IOPS = this.ebs.IOPS ;
      inputConfig.VolumeType = this.ebs.VolumeType ;
      inputConfig.BackupType = this.ebs.BackupType ;
      inputConfig.ChangeRate = this.ebs.Backup ;
      inputConfig.SnapshotDays = this.ebs.SnapshotDays ;
      inputConfig.UseMAZ = this.UseMAZ ;
      inputConfig.UseRI = this.form.useRI_algo ;
      inputConfig.UseSE2 = this.UseSE2 ;
      inputConfig.frozen_prefs = JSON.parse(JSON.stringify(this.form));

      
      var myConfig = calculate_aurora_config(this.regionInfo, aurora_shape, inputConfig);
      return myConfig.targetconfig_aurora;

    }, //end of aurora section

// **************************
// Disclaimers, one list per platform section
// **************************
    disclaimer_params() {
      return {
        use_se: this.form.rds_algo=="se",
        use_rac: this.form.rds_algo=="rac",
        optgoal_algo: this.form.optgoal_algo,
        aurora_algo: this.form.aurora_algo
      };
    },
    disclaimers_ec2() {
      return disclaimers("metrics","ec2",this.disclaimer_params, this.regionInfo);
    },
    disclaimers_ec2fsxn() {
      return disclaimers("metrics","ec2fsxn",{ ...this.disclaimer_params, ec2fsxn_algo: 'Y' }, this.regionInfo);
    },
    disclaimers_rds() {
      return disclaimers("metrics","rds",this.disclaimer_params, this.regionInfo);
    },
    disclaimers_aurora() {
      return disclaimers("metrics","aurora",this.disclaimer_params, this.regionInfo);
    }


  }
};
</script>

<style>
</style>
